export default {
  US: {
    PCD: {
      text: {
        home: 'Home',
        contact_us: 'Contact Us',
        products: 'Products',
        himacs: 'HIMACS',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        teracanto: 'TERACANTO',
        viateraquartzsurface: 'VIATERA',
        himacssolidsurface: 'HIMACS',
        teracantoporcelainsurface: 'TERACANTO',
        bortepanel: 'BORTE',
        home_film: 'Home Appliance Surface Film',
        automotive: 'Automotive',
        sub: {
          lvt: 'Luxury Vinyl Tile',
          los: 'Looselay',
          spc: 'SPC Rigid Core',
          homo: 'Homogeneous Sheet',
          het: 'Heterogeneous Sheet',
          spt: 'Specialty',
          veh: 'Vehicles and Transportation',
          sd: 'Signs and Displays',
          illum: 'Illuminated Sign',
          arch: 'Architecture',
          eco: 'Eco Solutions',
          corp: 'Corporate Branding',
          home_film: 'About Home Appliance Surface Film',
          automotive: {
            vegan_leather: 'Vegan Leather',
            light_comm: 'Lightweight Component',
            auto_comm: 'Automotive Component'
          }
        },
        vizuon_a: 'VIZUON',
        deco: 'Deco Film',
        exterior: 'Exterior Film',
        about: {
          himacs: 'About HIMACS',
          hflor: 'About HFLOR',
          viatera: 'About VIATERA',
          teracanto: 'About TERACANTO',
          borte: 'About BORTE',
        },
        featured_products: 'Featured Products',
        cart: 'cart',
        wish_list: 'wish list',
        new: 'New',
        coming: 'Coming soon',
        collection: 'Collection',
        explore_collection: 'Explore Collection',
        online_book: 'Online Book',
        load_more: 'Load More',
        certi_more: 'What These Certifications Mean',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        awards: 'Awards',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        order_a_sample: 'Order a Sample',
        documentation: 'Documentation',
        care_maintenance: 'Care & Maintenance',
        warranty: 'Warranty',
        where_to_buy: 'Where to buy',

        hidden_h1: 'Quartz Countertops',

        home_app_film: {
          title: 'Home Appliance Surface Film',
          title_description: 'Film laminated steel surface finishing material of home appliances, UBR and Elevator.',
          intro1: 'LX Hausys Home Appliance Surface Film is a high quality surface material with a variety of colors and patterns for refrigerators, washing machines and bathrooms.',
          intro2: 'Our superb products are already chosen by global appliance companies, because of its excellent anti-pollution, anti-scratch and anti-corrosion characteristics.',
          point_title1: 'Customizing Design Solution',
          point_description1: 'Based on Global Trend Research, development capabilities of customizing design solution for local customers has been recognized around the world, particularly in India, America, China, Southeast Asia and Europe.',
          point_title2: 'Global No.1',
          point_description2: 'LX Hausys’ Home Appliance Surface Film is running for the 1st M/S as a partner for Global major home appliance companies.',
          point_title3: 'Excellent Quality',
          point_description3: 'LX Hausys’ technology provides Anti Finger prints, Contamination Resistance, Anti Scratch and High Elongation for customers to use home appliances beautifully for a long time',
          construction: 'Construction',
          construction_film1: 'Metallic Film',
          film1_item1: 'Eco PET',
          film1_item1_desc: 'Printed Hairline on metal pearl with PET base',
          film1_item2: 'Metalon',
          film1_item2_desc: 'Metalizing gives real metal look on the film.',
          film1_item3: 'SUS Film',
          film1_item3_desc: 'Embossed Hairline technology allows customized pattern including horizontal hairline which enables the exact same look of STS.',
          construction_film2: 'Pearl & Patterned Film',
          film2_item1: 'Hi-Gloss',
          film2_item1_desc: 'Excellent printing technology can offer customized patterns.',
          film2_item2: 'Galaxy',
          film2_item2_desc: 'Various pearl effects will allow fine and glittery surface.',
          film2_item3: 'Soft-matte',
          film2_item3_desc: 'Soft-matte Textures with various color or customized patterns',
          application: 'Application',
          application_sub_title: 'Home Appliance Surface Film',
          application_item1: 'Pastel Metal',
          application_item2: 'Soft Matte',
          application_item3: 'Horizontal Hairline (Silver, Short)',
          application_item4: 'Horizontal Hairline (Black)',
          application_item5: 'Iridium Hairline',
          application_item6: 'Horizontal Hairline (Dark-grey)',
          application_item7: 'Glass Fiber',
          application_item8: 'Horizontal Hairline (Silver, Long)'
        },
        automotive_skin: {
          title: 'Vegan Leather',
          sub_title: 'Sustainable & Innovative',
          title_description: 'Sustainable Products, Innovative Technology for Environment',
          intro: 'is a major supplier of interior skin for various automotive applications. With our advanced technology and innovative design, we are able to offer you a total interior solutions to decorate your vehicle beyond your expectations.',
          point_title1: 'SAFETY',
          point_description1: 'STANDARD 100 by OEKO-TEX® certified products have been tested for harmful substances to protect your health (Green Label)',
          point_title2: 'Sustainable Materials',
          point_description2: 'Sustainable development by using bio-based and post-consumer recycled materials (Bio / Eco Label)',
          seat_cover: 'Seat Cover',
          seat_cover_desc: 'LX Hausys automotive skin delivers innovative designs through our best-in-class technology so as to bring emotional qualities to the indoor driving space.',
          cover_item1: 'SOFINO®',
          cover_item2: 'VERNO®',
          cover_item3: 'Calfpelle®',
          cover_item4: 'LUSSINO™',
          sofino_item1: 'SOFINO® Green',
          sofino_desc1: 'Comply with Class 1 of the OEKO-TEX® Standard 100, which attests that the material is safe for babies and small children¹⁾',
          sofino_item2: 'SOFINO® Bio',
          sofino_desc2: '<span>Developing bio leather from bio based fillers</span>' +
            '        <br />' +
            '        <span>(e.g., Kenaf, Eucalyptus, and so on)</span>',
          sofino_item3: 'SOFINO® Eco',
          sofino_desc3: ' <span>• RCS (Recycled Claim Standard) certificated</span>' +
            '        <br />' +
            '        <span>• Recycled content 35 wt% (Recycled Post-Consumer Polyester)</span>',
          sofino_anno: '<span>1) Limit values of OEKO-TEX® Standard 100 Class 1 (Products for babies)</span>' +
            '      <br />' +
            '      <span>• Solvent residues of NMP (1-Methyl-2-pyrrolidone), DMF (Dimethylformamide) ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span>• Sum of phthalates ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span class="spacing">(DBP, BBP, DEP, DMP, DEHP, DEMP, DIHP, DHNUP, DHxP, DIDP, DPrP, DHP, DNOP, DNP, DPP)</span>' +
            '      <br />' +
            '      <span>• Do not contain any of the banned flame retardant substances</span>' +
            '      <br />' +
            '      <span class="spacing">(e.g., Polybrominated Diphenyl Ethers, Antimony Trioxide)</span>' +
            '      <br />',
          verno_item1: 'VERNO® Green',
          verno_desc1: 'Comply with Class 1 of the OEKO-TEX® Standard 100, which attests that the material is safe for babies and small children¹⁾',
          verno_item2: 'VERNO® Bio',
          verno_desc2: '<span>• Environmental Claim Validation of UL-Solutions for biobased content</span>' +
            '        <br />' +
            '        <span>• Bio-based content ≥ 19%</span>',
          verno_item3: 'VERNO® Eco',
          verno_desc3: '<span>• RCS (Recycled Claim Standard) certificated</span>' +
            '        <br />' +
            '        <span>• Recycled content 50 wt% (Recycled Post-Consumer Polyester)</span>',
          verno_anno: '<span>1) Limit values of OEKO-TEX® Standard 100 Class 1 (Products for babies)</span>' +
            '      <br />' +
            '      <span>• Solvent residues of NMP (1-Methyl-2-pyrrolidone), DMF (Dimethylformamide) ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span>• Sum of phthalates ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span class="spacing">(DBP, BBP, DEP, DMP, DEHP, DEMP, DIHP, DHNUP, DHxP, DIDP, DPrP, DHP, DNOP, DNP, DPP)</span>' +
            '      <br />' +
            '      <span>• Do not contain any of the banned flame retardant substances</span>' +
            '      <br />' +
            '      <span class="spacing">(e.g., Polybrominated Diphenyl Ethers, Antimony Trioxide)</span>' +
            '      <br />',
          calfpelle_item1: 'Calfpelle®',
          calfpelle_desc1: '<span>• Suede with excellent surface quality</span>' +
            '        <br />' +
            '        <span>• Soft haptic and superior durability</span>',
          calfpelle_item2: 'Calfpelle® Bio',
          calfpelle_desc2: '<span>• Environmental Claim Validation of UL-Solutions for biobased content</span>' +
            '        <br />' +
            '        <span>• Bio-based content ≥ 10%</span>',
          lussino_item1: 'LUSSINO™',
          lussino_desc1: '<span>• [Premium grade] High-perfomance and sustainable silicone based leather</span>' +
            '        <br />' +
            '        <span>• Composition of silicone based material (Topcoat, Skin, Binder)</span>',
          design_area: 'Design',
          design_area_desc: 'LX Hausys develops automotive fabrics that not only offer high quality but also research and develop surface texture designs that match the vehicle\'s concept. By utilizing various patterns and design post-processing techniques, we provide design solutions that cater to our customers\' preferences.',
          comm_vegan_leather: 'Commercial Vegan Leather',
          comm_vegan_leather_desc: 'We have applied automotive seat fabric technology to achieve excellent surface quality in terms of durability, resistance to contamination, and other factors. We are also able to provide products using bio-based materials such as Kenaf.',
          comm_prd_title: 'LXELLO™',
          comm_item1: 'LXELLO™ Green',
          comm_desc1: 'Comply with Class 1 of the OEKO-TEX® Standard 100, which attests that the material is safe for babies and small children',
          comm_item2: 'LXELLO™ Bio',
          comm_desc2: 'The skin and foam layers contain bio based materials such as kenaf',
          comm_item3: 'LXELLO™ Eco',
          comm_desc3: '<span>• RCS (Recycled Claim Standard) certificated</span><br /> <span>• Recycled content 35 wt% (Recycled Post-Consumer Polyester)</span>',
          comm_anno: '<span>• The skin and foam layers contain bio based materials such as kenaf</span>' +
            '            <br>' +
            '            <span>- Kenaf is one of the highest CO<sub>2</sub> absorption rates among plants 3 to 10 times higher than average ¹⁾</span>' +
            '            <br>' +
            '            <span>• Designed to meet automotive interior demands including that of stain resistance</span>' +
            '            <br>' +
            '            <span>- Excellent anti-staining performance enables bright interior design</span>' +
            '            <br>' +
            '            <span>1) Source: Ministry of Environment\'s \'Analytic Report on Eco-friendly Crops\' (2019)</span>' +
            '            <br>',
          lello_palette_title: 'LXELLO™ Color Palette'
        },

        automotive_lightweight: {
          title: 'Lightweight Component',
          sub_title: 'We provide lightweight materials consisting of reinforced plastics, which maintain the strength of conventional steel and contribute to cut fuel consumption by reducing the weight of components.',
          title_description: 'Eco friendly, fuel-efficient lightweight car components with high steel rigidity',
          point_title1: 'Lightweight',
          point_description1: 'Reducing weight by 25% against conventional steel',
          point_title2: 'High strength',
          point_description2: 'Maintaining the strength of conventional steel',
          point_title3: 'Cost reduction',
          point_description3: 'Reducing the number of parts through design optimization',
          component_item1: 'Bumper Beam',
          component_desc1: '- Reducing weight by 25% against conventional steel \n ' +
            '- Protecting passengers on impact by shock absorption',
          component_item2: 'Knee Bolster',
          component_desc2: '- Reducing weight by 56% against conventional steel \n' +
            '- Protecting knees on impact',
          component_item3: 'Seat Back',
          component_desc3: '- Reducing weight by 30% against conventional steel \n' +
            '- minimization the number of components \n' +
            '- Improving the impact safety',
          component_item4: 'Battery Pack Bottom Panel',
          component_desc4: '- Reducing weight by 30% against alumimun\n' +
            '- Protecting the lower part of the electric vehicle battery pack',
          component_info: '※ Weight reduction is based on simulation results of automotive design analysis programs (CATIA, LS-DYNA), and may vary depending on specifications when the actual product is manufactured.',
          material_title: 'Lightweight Material',
          material_lwn_title: 'LiteMax',
          material_lwn_desc: 'LX Hausys\' Thermoplastic Continuous Glass Fiber Sheet',
          lwn_item1: 'LiteMax PPGF60',
          lwn_desc1: '<p>- Polypropylene impregnated glass fiber sheet</p>' +
            '                  <p>- Glass fiber content : 60wt%</p>' +
            '                  <p>- Best for lightweight designs</p>' +
            '                  <p>- Application : Rear bumper beam</p>',
          lwn_item2: 'LiteMax PPGF80',
          lwn_desc2: '<p>- Polypropylene impregnated glass fiber sheet</p>' +
            '                  <p>- Glass fiber content : 80wt%</p>' +
            '                  <p>- High glass fiber content for high stiffness</p>' +
            '                  <p>- Application : Bettery pack bottom panel</p>',
          lwn_item3: 'LiteMax PAGF60',
          lwn_desc3: '<p>- Polyamide 6 impregnated glass fiber sheet</p>' +
            '                  <p>- Glass fiber content : 60wt%</p>' +
            '                  <p>- Excellent thermal and impact resistance</p>' +
            '                  <p>- Application : Seat back frame</p>',
          material_lcore_title: 'L-Core Panel',
          material_lcore_desc: 'Lightweight sandwich panels with fiber core are used as a wall for trailers in North America.\n' +
            '                  L-core panels are lighter, more corrosion-resistant, and more resilient than HDPE Core panels.',
          lcore_item1: 'HDPE Panel',
          lcore_item2: 'L-Core Panel',
          lcore_thick: 'Thickness',
          lcore_weight: 'Unit weight',
          lcore_redu: 'Weight reduction',
          lcore_resi: 'Corrosion resistance',
          lcore_defo: 'Deformation<br>before and after loading',
          lcore_testInfo: '*Based on our high temperature and humidity accelerated life test'
        },

        automotive_auto: {
          title: 'Automotive Component',
          sub_title: 'We make innovative automotive components with a multitude of material formulas. Our cutting-edge technology improve energy efficiency and reduce weight of autos.',
          title_description: 'Various components applied to the exterior and interior of automobiles',
          point_title1: 'Energy Efficiency',
          point_description1: 'Reducing weight to <br/> improve energy efficiency',
          point_title2: 'High Quality',
          point_description2: 'Excellent quality by a <br/> cutting edge technology',
          point_title3: 'Superior Design',
          point_description3: 'Realizing the sophiscated and luxury patterns for your driving space',
          ext_eng_title: 'Exterior & Engine Part',
          exterior_part: 'Exterior Part',
          engine_part: 'Engine Part',
          exterior_item1: 'Structural Bumper System',
          exterior_desc1: '- Front, rear bumper assembly\n' +
            '- Observance of Pedestrian Safety\n' +
            '- Compliance with IIHS, R-Car',
          exterior_item2: 'Side Sil',
          exterior_desc2: '- Injection molding + Painting\n' +
            '- Forming technology (Electric Injection molding)',
          engine_item1: 'Cylinder Head Cover',
          engine_desc1: '- Replacing Aluminum with Plastic\n' +
            '- Prevention of oil leakage\n' +
            '- Oil-water separating system\n' +
            '- Observance of Euro5 legislation',
          engine_item2: 'Air Intake Manifold',
          engine_desc2: '- Replacing Aluminum with Plastic\n' +
            '- Variable Induction System',
          engine_item3: 'Transmission Oil Pan',
          engine_desc3: '- Replacing Plastic with Steel\n' +
            '- Prevention of oil leakage\n' +
            '- System for circulating the oil',
          interior_title: 'Interior Part',
          interior_desc: 'Creating sophisticated designs with natural patterned real wood',
          inter_detail1: 'SRP (Superfine Real Printing)',
          inter_detail1_desc: '<li>Enables precision 3D object printing</li>\n' +
            '            <li>Delivers superior realism and textured effects</li>\n' +
            '            <li>Applicable to a wide range of automotive interiors</li>\n' +
            '            <li>Application : Crash pads, Garnish, Consoles, Steering wheels, etc.</li>',
          inter_detail2: 'Real Materials',
          inter_detail2_desc: '<li>Premium aesthetic from natural wood veneers and carbon fiber</li>\n' +
            '            <li>Exquisite crash pads, garnishes, consoles, and armrests for luxury\n' +
            '              interior parts</li>',
          inter_design1: 'SRP Design',
          inter_design1_item1: 'Wood',
          inter_design1_item2: 'Fabric',
          inter_design1_item3: 'Geometric, Technical',
          inter_design1_item4: 'Hair line',
          inter_design2: 'Real Materials',
          inter_design2_item1: 'Wood',
          inter_design2_item2: 'Aluminum',
          inter_design2_item3: 'Textile',
          inter_design2_item4: 'Stone',
          inter_design2_item5: 'Carbon'
        },

        SOLID_SURFACE: 'SOLID SURFACE',
        KV_brief: 'The New Generation of Design Inspiration',
        brief: 'HIMACS is composed of minerals, acrylic and natural pigments that come together to provide a durable, smooth, non-porous and visually seamless surface which meets the highest standards for quality, aesthetics, fabrication, functionality and hygiene - offering manifold advantages over conventional materials. HIMACS is durable, it can be shaped by a thermoforming process, and thanks to its huge colour spectrum and translucent properties can help to achieve outstanding and colourful designs. HIMACS uses a simple heating process to give three-dimensional thermoforming capabilities, allows visually seamless designs, offers a virtually limitless range of colours and - for some shades - exhibits a special translucency when exposed to light. Although HIMACS is almost as robust as stone, it can be worked in a similar way as wood: it can be sawn, routed, drilled or sanded. HIMACS is available in sheets of different dimensions and thicknesses. The collection is completed with our range of kitchen sinks, basins, baths and shower trays.',
        photo_credit: 'Photo Credits: Design Marc Fidelle and Andrei David - Paris Airport Engineering and Architectural Management, fabrication : LCCA, photo : Mathieu Ducros',

        Aurora_collection_title: 'AURORA & MARMO',
        Aurora_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        ASTER_collection_title: 'ASTER',
        ASTER_collection_brief: 'Aster is a collection of elegant shades of grey, ranging from almost white to a warm beige, all with a gorgeous mother of pearl shimmer.',

        CONCRETE_collection_title: 'CONCRETE',
        CONCRETE_collection_brief: 'The indusrial look of concrete combined with the incredible flexibility of HI-MACS. The Concrete Collection adds huge opportunities for great designs to architects and designers',

        EXTERIA_collection_title: 'EXTERIA',

        GRANITE_collection_title: 'GRANITE, SPARKLE, QUARTZ, SAND & PEARL',
        GRANITE_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        LUCIA_collection_title: 'LUCIA',
        LUCIA_collection_brief: 'This collection focuses on the natural trend colours black, white and grey. The lively and homogeneous structures add character and expression to the colours. Not surprising, as the renowned Dutch designer, Marcel Wanders, designed three of these colours. (W001, W003, W004)',

        LUCENT_collection_title: 'LUCENT',
        LUCENT_collection_brief: 'The shades of the Lucent Collection, with their exceptional light translucency, allow for spectacular designs. Whether effectively backlit or simply illuminated, the Lucent colours of the architecture always add an elegant touch thanks to their characteristic reaction to light.',

        SOLIDS_collection_title: 'SOLIDS',
        SOLIDS_collection_brief: 'The classic in terms of solid surfaces &ndash; a wide range of attractive shades of white lies at the heart of this collection. Complemented by colourful, dynamic uni-shade accents from Lemon Squash to Festival Pink. The timeless collection offers the perfect colour for every design.',

        STRATO_collection_title: 'STRATO',
        STRATO_collection_brief: 'The marked linear patterns of Strato collection creates geometry through its soft structure and subtle look. The skilful use of the new linear pattern, vertically or horizontally, allows for great variation in each and every project.',

        TERRAZZO_collection_title: 'TERRAZZO',
        TERRAZZO_collection_brief: 'Using a vibrant concrete-base as the canvas for each design, the Terrazzo Collection from HI-MACS offers a vibration of color and patterns that speak to your past, present, and future self in anesthetic. Textured shades, artistic designs, and a touch of modern class, this collection creates a one of a kind experience.',

        ULTRA_collection_title: 'ULTRA',
        ULTRA_collection_brief: 'HIMACS Intense Ultra is based on a brand-new material formulation and combines Intense Colour technology with Ultra-thermoforming. Dark colours become more “intense”, darker and also more resistant, with less visible scratches. The new HIMACS Intense Ultra, also has excellent thermoforming capabilities.',

        VOLCANICS_collection_title: 'VOLCANICS',
        VOLCANICS_collection_brief: 'The large particles of the Volcanics shades add a sense of style to any design. When used on a large scale the result is a dramatic showpiece.',

        Sustainability: 'Sustainability',

        /* US feature benefits TAB */

        TAB_Quality_Design_title: 'Quality Design',
        TAB_Quality_Performance_title: 'Quality Performance',
        TAB_Quality_Fabrication_title: 'Quality Fabrication',
        TAB_Quality_Sustainability_title: 'Quality Sustainability',

        /* END US feature benefits TAB */

        /* US feature benefits - Quality Design - TAB */

        Design_title1: 'Wide Range of Shapes',
        Design_brief1: 'Every option is available to designers to create neat washrooms, kitchens, hospitals and much more with our wide range of HIMACS sinks and bowls. Perfectly coordinated and ideal for mixing and matching, the bowls and sinks guarantee a modern look that is easy ad simple to look after.',

        Design_title2: 'Dramatic Translucency',
        Design_brief2: 'Certain colours and thicknesses of HIMACS exhibit a special translucency when exposed to light.',
        Design_brief2_1: 'Various textures and patterns can be built into the material to intensify the HIMACS translucency effect.',

        Design_title3: '3-Dimensional Design',
        Design_brief3: 'HIMACS boasts a simple heating process and three-dimensional thermoplastic forming capabilities.',
        Design_brief3_1: 'This allows for greater forming flexibility compared with other conventional materials so that spectacular ideas can quickly take on a concrete shape.',

        Design_title4: 'Unlimited Spectrum of Colours',
        Design_brief4: 'HIMACS offers a virtually limitless range of colours in all conceivable shades.',
        Design_brief4_1: 'More are being added every year no matter what colour you choose, HIMACS remains 100% homogeneous.',

        /* END US feature benefits - Quality Design - TAB */

        /* US feature benefits - Quality Performance - TAB */

        Performance_title1: 'Strong',
        Performance_brief1: 'Stronger surface with durability similar to that of natural stone - HIMACS stands up to everyday scratches. Should you accidentally inflict a deeper scratch or surface impression, a trained professional can easily resurface your HIMACS thanks to its sealant-free consistency.',

        Performance_title2: 'Fire Resistant',
        Performance_brief2: 'Backed up with numerous certificates that attest of its fire resistance,',
        Performance_brief2_1: 'HIMACS is ideal for places where security is the number 1 criteria of choice.',

        Performance_title3: 'Hygienic',
        Performance_brief3: 'Thanks to its impermeability to dirt, bacteria, viruses and countless chemicals, HIMACS is the ideal material for the hospital,',
        Performance_brief3_1: 'medical practice or laboratory. And for all other areas where hygiene really counts.',

        Performance_title4: 'Water Resistant',
        Performance_brief4: 'Thanks to its non-porous surface HIMACS is suitable for humid areas where moisture can form such as wet rooms',
        Performance_brief4_1: 'and bathrooms.',

        /* END US feature benefits - Quality Performance - TAB */

        /* US feature benefits - Quality Fabrication - TAB */

        Fabrication_title1: 'Most Advanced Fabrication Technology',
        Fabrication_brief1: 'The material is heated in a progressive tempering process (Thermal Cure). which sets HIMACS apart from other mineral materials and produces a new and stronger compound in which any structural defects are perfectly evened out. This improved structure automatically affects the quality of the material.',

        Fabrication_title2: 'Simple Processing',
        Fabrication_brief2: 'Although HIMACS is almost as robust as stone, it can be worked in the same way as wood. ',
        Fabrication_brief2_1: 'Using conventional carpenter\'s tools, this solid surface material can be sawn, routed or drilled.',

        Fabrication_title3: 'Seamless Perfection',
        Fabrication_brief3: 'HIMACS allows for visually seamless manipulation.',
        Fabrication_brief3_1: 'Smooth integration enables large areas without joints or edges as well as flush mounting of sinks or bowls.',

        /* END US feature benefits - Quality Fabrication - TAB */

        /* US feature benefits - Quality Sustainability - TAB */

        Sustainability_title1: 'Renewable',
        Sustainability_brief1: 'With easy-to-care and repairable properties, no matter if it\'s a scratch, stain or crack,',
        Sustainability_brief1_1: 'HIMACS can be restored to its original state by a certified professional.',

        Sustainability_title2: 'Sustailable',
        Sustainability_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        /* END US feature benefits - Quality Sustainability - TAB */

        /* US certifications TAB */

        certifications_desc_p: 'Certification Description',
        certifications_desc_m: 'Certification <br> Description',

        TAB_Environment_title: 'Environment',
        TAB_Fire_Rating_title: 'Fire Rating',
        TAB_HIMACS_Exteria_title: 'HIMACS Exteria Certificates',
        TAB_Hygiene_title: 'Hygiene',
        TAB_Process_title: 'Process',

        /* END US certifications TAB */

        /* US certifications - Environment - TAB */

        Environment_title1: 'Ministry of Environment of the Republic of Korea',
        Environment_brief1: 'designates HIMACS as environmentally-friendly thanks to the demonstration of its commitment to ecological awareness in its product management activities.',

        Environment_title2: 'M1 Emissions Classification',
        Environment_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        Environment_title3: 'Leadership in Energy and Environnemental Design (LEED)',
        Environment_brief3: 'Is a standard voluntary system to certify high performance of buildings, from the US Green Building Council (USGBC). LEED certifies buildings using a credit system. The use of HIMACS contributes toward satisfying EQ Credit for Low-Emitting Materials with the category Indoor Environmental Quality (EQ).',

        Environment_title4: 'ISO 14001',
        Environment_brief4: 'The ISO 14000 family concerns the management of environmental quality. The most popular certificate in this group is ISO 14001. It encourages the minimisation of damage caused by our own activity to the environment and the continuous improvement of environmental performance. The objective is to contribute to protecting and stabilising our planet’s environment. This test certifies that the environment management system of HIMACS conforms to ISO 14001 standards.',

        Environment_title5: 'Greenguard',
        Environment_brief5: 'HI-MACS has been approved by Greenguard in the USA, as a “low emitting product”. The organisation establishes acceptable indoor air standards for indoor products, environments and buildings. The organisation’s goal is to improve public health and quality of life through programs that improve indoor air.',

        Environment_title6: 'Environmental Building Certificate – Grade "outstanding"',
        Environment_brief6: 'The Korean Air Cleaning Association certifies that HIMACS complies with the Korean regulations for environmental building materials.',

        Environment_title7: 'DGNB',
        Environment_brief7: 'The DGNB system, founded by the "German Sustainable Building Council”, evaluates buildings holistically on the basis of individual criteria within the categories Ecological Quality, Economic Quality, Sociocultural and Functional Quality, Technical Quality, Process Quality and Location Quality. Different profiles allow the certification of new buildings and existing buildings, as well as of quarters in Germany and Internationally. Buildings can achieve a certification in Bronze, Silver, Gold and Platinum. HIMACS has an Environmental Product Declaration (EPD), which can be used to calculate the building life cycle assessment (ENV1.1/2.1). Furthermore, HIMACS has achieved Quality Level 4 of 4 in DGNB 2018 criteria for local environmental impact for the entire product.',

        Environment_title8: 'BREEAM (Building Research Establishment Environmental Assessment Method)',
        Environment_brief8: 'BREEAM is the world’s leading sustainability assessment method for masterplanning rojects, infrastructure and buildings. It recognises and reflects the value in higher performing assets across the built environment lifecycle, from new construction to in-use and refurbishment. HIMACS can contribute to BREEAM International New Construction 2016 certification, as the entire product complies with Hea 02 Indoor air quality. Furthermore, HIMACS achieved RSCS summary score level in Mat 03, responsible sourcing of construction products for the entire product: RSCS level 1. “BREEAM is a registered trade mark of the Building Research Establishment Limited, a wholly owned subsidiary of BRE Group Limited, and is used by permission. LX Hausys and its products are not affiliated, endorsed or certified by BRE Global Limited, which is the operator of BREEAM, or any other subsidiary of BRE Group Limited. All rights are reserved.”',

        /* END US certifications - Environment - TAB */

        /* US certifications - Fire Rating - TAB */

        Fire_Rating_title1: 'Norm NFP 92-501 Class M1',
        Fire_Rating_brief1: 'LNE tests the reactivity to fire of a material. Class M1 certifies that HIMACS FR benefits from advanced resistance to fire. This certificate is recommended in France.',

        Fire_Rating_title2: 'Norm EN 45 545 Class R1 HZL3',
        Fire_Rating_brief2: 'Fire protection on railway vehicles: The measures and requirements specified in EN 45 545 are intended to protect passengers and staff in railway vehicles in the event of a fire on board. HIMACS has achieved the highest and best performance R1 HZL3 (Hazard Level). Valid for Alpine White S728.',

        Fire_Rating_title3: 'Norm EN 13501 - Class B-s1, d0',
        Fire_Rating_brief3: 'HIMACS successfully passed the European test EN 13501 – Class B-s1, d0, equivalent to the class 0 from Warrington Fire certification.',

        Fire_Rating_title4: 'Norm DIN 4102-1 - Class B1',
        Fire_Rating_brief4: 'Class B1 certifies that HIMACS has a low flammability. B1 class is the European fire resistance requirement. This test result is valid for all colour ranges in 12mm.',

        /* END US certifications - Fire Rating - TAB */

        /* US certifications - Exteria Certificates - TAB */

        Exteria_title1: 'IMO MED – Modules B and D',
        Exteria_brief1: 'MED stands for Marine Equipment Directive. Both modules are extremely important for the shipbuilding industry, as they are mandatory for fabrication materials used in ships. IMO B covers the fire resistance of the material per se and certifies that the material has low flame spread characteristics and is not capable of producing excessive quantities of smoke and toxic combustion products. Module D covers the overall production capacity and checks, among other production processes, the management and systems used.',

        Exteria_title2: 'ETA',
        Exteria_brief2: 'Fixed with Keil inserts and a BWM structure, HIMACS facade in S728 - Alpine White successfully passed the ETA tests (European Technical Agreement).',

        Exteria_title3: 'CSTB Certification',
        Exteria_brief3: 'HIMACS has obtained the French QB certification and CSTB ATec “Avis Technique” for facade applications (Avis Technique 2.2/18-1795_V1).',

        /* END US certifications - Exteria Certificates - TAB */

        /* US certifications - Hygiene - TAB */

        Hygiene_title1: 'NSF',
        Hygiene_brief1: 'NSF standards are generally accepted norms for a variety of public health related industries and fields. These include drinking water treatment and contact with materials, food equipment manufacturing etc. NSF recognises that HIMACS complies with NSF norms.',

        Hygiene_title2: 'LGA',
        Hygiene_brief2: 'Necessary in hospitals and environments where hygiene is critical, LGA assesses the ease of cleaning, resistance to bacteria and fungi and rates the design from a hygiene point of view. Thanks to its non-porosity, HIMACS has been approved for the LGA seal “hygiene tested”.',

        /* END US certifications - Hygiene - TAB */

        /* US certifications - Process - TAB */

        Process_title1: 'OHSAS 18001',
        Process_brief1: 'OHSAS 18001, Occupational Health and Safety Assessment Series, (officially BS OHSAS 18001) is a British Standard for occupational health and safety management systems. Compliance with it enables organizations to demonstrate that they have a system in place for occupational health and safety.',

        Process_title2: 'ISO 9001',
        Process_brief2: 'ISO 9001 criteria can guarantee the following points:',
        Process_brief3: 'The whole fabrication process, ensuring a good product quality',
        Process_brief4: 'Quality control, with an appropriate corrective procedure, when needed and regular control of quality control procedures.',
        Process_brief5: 'Process, which aims to continuously improve global efficiency',

        /* END US certifications - Process - TAB */

        /* US sustainbility - TAB */

        sustainbility_title1: 'Shaping the Future in Harmony with the Environment',
        sustainbility_brief1: 'Countless internationally recognized certificates attest to the fact that HIMACS has a strong focus on ecological aspects. Without exception, all HIMACS products are manufactured in accordance with the ISO 14001 environmental standard.',

        TAB_Commitment_title: 'Commitment',
        TAB_Material_Safety_title: 'Material Safety',
        TAB_Manufacturing_title: 'Manufacturing',
        TAB_Processing_title: 'Processing',
        TAB_Transport_title: 'Transport',

        /* END US sustainbility - TAB */

        /* US sustainbility - Commitment - TAB */

        Commitment_title1: 'Commitment',
        Commitment_brief1: 'LX Hausys conducts and publishes regular environmental audits along with energy consumption analyses. Thanks to the use of non-polluting fuels, greenhouse gas emissions have been cut by 15,000 tons per year since 2008.',

        /* END US sustainbility - Commitment - TAB */

        /* US sustainbility - Material Safety - TAB */

        Material_Safety_title1: 'Material Safety',
        Material_Safety_brief1: 'Extensive studies – within LX Hausys’ own laboratories as well as tests carried out by other renowned independent institutions – have shown that the HIMACS material itself, as well as the cured adhesive, are completely free from formaldehyde and emissions. HIMACS has been awarded the Greenguard Gold Indoor Air Quality Certificate.',

        /* END US sustainbility - Material Safety - TAB */

        /* US sustainbility - Manufacturing - TAB */

        Manufacturing_title1: 'Manufacturing',
        Manufacturing_brief1: 'The production of this solid surface material is marked by an excellent energy balance. In recent years, the company was very successful in achieving ambitious goals in terms of waste reduction and water conservation. In addition, HIMACS plants in Cheongju (Korea) and Atlanta (USA) meet all environmental standards.',

        /* END US sustainbility - Manufacturing - TAB */

        /* US sustainbility - Processing - TAB */

        Processing_title1: 'Processing',
        Processing_brief1: 'The material allows for virtually waste-free processing. In addition, HIMACS installations are extremely strong and durable. They can easily be renewed to their original appearance, meaning they don’t have to be replaced, thus giving a positive long-term  environmental footprint.',

        /* END US sustainbility - Processing - TAB */

        /* US sustainbility - Transport - TAB */

        Transport_title1: 'Transport',
        Transport_brief1: 'Within Europe, HIMACS observes the Euro-5 standards for reduced particulate emissions. The partner-network of LX Hausys Europe consists of carefully selected partners with the highest environmental standards: for example, the State-of-the-Art logistics centre in the Netherlands is one of the first buildings to have been constructed in accordance with the WELL Building Standards and awarded the BREEAM Certificate. This means that it meets the highest requirements for environmentally friendly and healthy construction. '

        /* END US sustainbility - Transport - TAB */

      }, // End of PCD - text

      alert: {
        loginLike: 'Log in to save to your Likes'
      }, // End of PCD - alert

      button: {
        seeMore: 'See More',
        see_all: 'See all Designs',
        learnMore: 'Learn more',
        explore_collection: 'Explore Collection',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        close: 'close',
        find_a_sales_rep: 'Find a Sales Rep',
        btn_sustainbility_brochure: 'Download Sustainability Brochure',

        English: 'English',
        German: 'German',
        French: 'French',
        Italian: 'Italian',
        Spanish: 'Spanish',
        Dutch: 'Dutch',
        EnglishUK: 'English (UK)'

      }, // End of PCD - button

      popup: {
        /* Edge Profiles 시작 점 */
        edge_title: 'Viatera Edge Profile',
        edge_brief: 'Where quartz meets the edge. LX Hausys Surfaces offers a wide selection of edge treatments.' +
          '                    Select from a simple rounded corner to the complex multi-toned,' +
          '                    multi-tiered rolling edges that add that special finishing touch to your solid surface counter.' +
          '                    For more information on our edge treatments, please consult your local area distributor or' +
          '                    fabricator.',

        beveled_Edge: 'Beveled Edge',
        beveled_Edge_brief: 'Maintains the surface’s thickness,\n' +
          '                    but with a ¼” or ½” angular top edge.',
        bullnose_Edge: 'Bullnose Edge',
        bullnose_Edge_brief: 'A completed rounded edge.',

        eased_Edge: 'Eased Edge',
        eased_Edge_brief: 'A slightly rounded top edge that still\n' +
          "                    maintains the surface's thickness.",

        ellipse_Edge: 'Ellipse Edge',
        ellipse_Edge_brief: 'Rounded top and bottom edges\n' +
          '                    with a flat face.',

        knife_Edge: 'Knife Edge',
        knife_Edge_brief: 'A sharp, blade-like edge.',

        reverse_Ogee_Edge: 'Reverse Ogee Edge',
        reverse_Ogee_Edge_brief: 'Similar to Roman Edge, but reversed.',

        roman_Edge: 'Roman Edge',
        roman_Edge_brief: 'An elaborate ogee-style edge design\n' +
          '                    inspired by Roman architecture.',

        roundover_Edge: 'Roundover Edge',
        roundover_Edge_brief: 'A semi-circle rounded top edge.',

        /* Edge Profiles 끝 */

        /* Finish 시작 점 */
        finishInfo: 'Finish guide',
        finishTitle: 'Introducing New Viatera Finish Brushed',
        finishBrief: 'Select Viatera colors are now available with a “Brushed” finish to fulfill a wider range of aesthetics.\n' +
          '                  Enjoy the new classic beauty with a satin-like finish.',
        polished: 'POLISHED',
        polished_brief: 'Traditional reflective surface',

        brushed: 'BRUSHED',
        brushed_brief: 'Soft and smooth feel with\n' +
          '                    low-luster on the surface',

        leather: 'Leather',
        leather_brief: 'Leather finish has a slightly more matte texture than a polished finish, and makes you feel the soft touch of the leather.',

        velvet_Touch: 'Velvet Touch',
        velvet_Touch_brief: 'Velvet touch finish enables you to feel the texture of nature with the feeling of stone dents.',

        finish_viatera: 'Viatera',
        finish_viatera_info: 'Brushed Finish Care & Maintenance',
        finish_viatera_brief: 'Viatera products with Brushed Finish are the same as those with the standard Polished Finish.\n' +
          '                  The only manufacturing difference is how the final gloss level is achieved.',

        finish_viatera_brief_01: 'Brushed Finish may need more daily attention than Polished Finish. This is the nature of any material with a matte finish when compared to the same material\n' +
          '                  with a polished finish – smudges, fingerprints, and water spots are simply more visible on a matte surface. Promptly wipe up and buff dry routine spills, droplets,\n' +
          '                  and rings. A microfiber towel may be more effective than a paper towel because Brushed Finish has a slight surface texture when compared to Polished Finish.\n' +
          '                  These non-woven cleaning products work well on all surfaces and are especially helpful on products that feature anything other than a perfectly smooth surface.',

        finish_viatera_brief_02: 'Routine Care and Maintenance of Brushed Finish is easy with the same liquid household cleaners that are suitable for “Polished” finishes, including Formula 409\n' +
          '                  Natural Stone & Steel Cleaner.',

        finish_viatera_brief_03: 'Always read and follow that manufacturer’s label instructions. A textured sponge that’s suitable for non-stick coated cookware may be helpful in removing some\n' +
          '                  tougher spills. Avoid using abrasive cleaners like Ajax or Comet, as these more aggressive materials may dull or damage the surface of Brushed Finish.\n' +
          '                  After using any cleaning product always rinse the area and buff the area dry. A microfiber product is suggested but not required.'

        /* Finish 끝 */

      } // End of PCD - popup
    }, // End of PCD

    PD: {
      text: {
        new: 'NEW',
        coming: 'Coming soon',
        discontinued_Color: 'Discontinued Color',
        image_enlarged_view: 'IMAGE ENLARGED VIEW',
        image_download_view: 'IMAGE DOWNLOAD VIEW',
        finish: 'Finish',
        finishGuide: 'Finish guide',
        color: 'Color',
        product_Specs: 'Product Specs',
        product_type: 'Product Type',
        total_thickness: 'Total Thickness',
        wear_layer: 'Wear Layer',
        dimension: 'Dimensions',
        dimension1: 'Dimension &',
        weight: 'Weight',
        remark: 'Remark',
        pattern: 'Pattern',
        emboss: 'Emboss',
        installation: 'Installation',
        adhesive_code: 'Adhesive Code',
        adhesive_name: 'Adhesive Name',
        available_Countries: 'Available Countries',
        related_Products: 'Related Products',
        features_Benefits: 'Features & Benefits',
        certifications: 'Certifications',
        documentation_technical_details: 'DOCUMENTATION & TECHNICAL DETAILS',
        fabrication: 'Fabrication',
        test_report: 'Test Report',
        care_maintenance: 'Care & Maintenance',
        catalogue: 'Catalog',
        certification: 'Certification',
        technical_datasheet: 'Technical Datasheet',
        installation_guide: 'Installation Guide',
        warranty: 'Warranty',
        productWarning: 'Product Warning and Safety Data Sheet',
        edge_profile: 'Edge Profile',
        inspiration: 'Inspiration',
        standard: 'Standard',
        image_viewer: 'For illustration purposes only. Image size:',
        in: 'in',
        zoom_out: 'zoom Out',
        zoom_in: 'zoom In',
        Thickness: 'Thickness',
        Use: 'Use',
        Pattern: 'Pattern',
        Notice: 'Notice',
        Notice_brief: 'Less suitable for surfaces which are subject to high traffic, due to their higher pigmented colour saturation, marks may be seen more easily.',
        Semi_Translucent: 'Semi-Translucent colour',
        Semi_Translucent_brief: 'Colours with this mark have a semi-translucent effect, evident when combined with light sources',
        Outdoor: 'Outdoor',
        Outdoor_brief: 'Suitable for exterior use. Please check conditions about level of suitability and warranty per colour. Indoor, Suitable for Kitchen & Bathroom',
        Recycled: 'Recycled',
        Recycled_brief: 'Certified to contain pre-consumer recycled content. Minimum',
        Designer: 'Designer Series',
        Designer_brief: 'Designed by Marcel Wanders',
        Lucent: 'Lucent',
        Lucent_brief: 'Lucent colours have a higher level of translucency, more evident when combined with light source. Translucent colour',
        Veined: 'Veined',
        Veined_brief: 'As Marmo is a randomly veined product, specific fabrication guidelines need to be followed.',
        prd_specs: 'PRODUCT SPECS',
        sales_channel: 'Sales Channel',
        news_letter: 'Sign up for our Newsletter',
        news_letter_desc: 'Discover innovative projects, unique colors  and the latest news and trends',
        subscribe: 'Subscribe',
      }, // End of PD - text

      button: {
        virtual_Showroom: 'Virtual Showroom',
        prev: 'Prev',
        next: 'Next',
        list_view: 'list view',
        download: 'download',
        see_all_documentation: 'See All Documentation',
        see_all_case_studies: 'See All Case Studies',
        see_more: 'See More'

      } // End of PD - button

    }, // End of PD

    PF: {
      text: {
        category: 'CATEGORY',
        luxury_vinyl_tile: 'Luxury Vinyl Tile',
        looselay: 'Looselay',
        homogeneous_sheet: 'Homogeneous Sheet',
        heterogeneous_sheet: 'Heterogeneous Sheet',
        specialty: 'Specialty',
        home: 'Home',
        filter_by: 'Filter By',
        patterns: 'Patterns',
        country: 'Country',
        new: 'New',
        new_a: 'NEW',
        coming: 'Coming soon',
        new_colors: 'NEW COLORS',
        product_type: 'Product Type',
        thickness: 'Thickness (inch)',
        weight: 'Weight (lbs)',
        finish: 'Finish',
        wear_layer: 'Wear Layer',
        dimension: 'Dimensions (inch)',
        searchText: 'Enter Item Number or Name',
        Tones: 'Tones',
        Use: 'Use',
        Recycled: 'Recycled',
        Thickness: 'Thickness',
        himacs: 'HIMACS',
        borte: 'BORTE',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        exteriorfilm: 'EXTERIOR Film',
        decofilm: 'DECO Film',
        teracanto: 'TERACANTO',
        benif: 'BENIF',
        vizuon_a: 'VIZUON',
        lvt: 'Luxury Vinyl Tile',
        los: 'Looselay',
        spc: 'SPC Rigid Core',
        hom: 'Homogeneous Sheet',
        het: 'Heterogeneous Sheet',
        spt: 'Specialty',
        installation: 'Installation',
        results: 'Results',
        no_search_result: 'No Result Found',
        no_compare_item: 'No items to compare',
        no_option: 'Please select option',
        color: 'Color',
        filters: 'Filters',
        compare: {
          viatera: 'COMPARE VIATERA PRODUCTS',
          hflor: 'COMPARE HFLOR PRODUCTS',
          teracanto: 'COMPARE TERACANTO PRODUCTS',
          himacs: 'COMPARE HIMACS PRODUCTS'
        },
        compare_full: {
          text: 'Do you want to replace the first Products <br>' +
            'you added by the one you selected?',
          footer: 'Edit products in compare'
        },
        slab_size: 'Slab Size(inch)',
        bookmatch: 'Bookmatch',
        remark: 'Remark',
        isNeoQ: 'NEOQ™ (Less Than 1% Crystalline Silica)',
        isMadeInUSA: 'Made in USA with U.S. and imported parts',
        key_visual_desc: {
          all_colors: 'Discover the ideal color and design option for your upcoming projects, from quartz countertops to solid surfaces, porcelain, panels, and resilient <br>' +
            'flooring. <br>' +
            'LX Hausys provides a broad spectrum of colors, finishes, and aesthetic choices across its entire portfolio of surfacing and flooring materials.',

          all_samples: 'Find the perfect samples for your next project, whether you need quartz countertops, solid surfaces, porcelain surfaces, or resilient flooring. <br>' +
            'LX Hausys offers a diverse array of samples across its entire surfacing and flooring portfolio.',

          hflor_color: 'Explore the vast world of design possibilities with HFLOR resilient flooring. <br>' +
            'Our diverse palette of colors and patterns extends across all our resilient flooring materials, including luxury vinyl tile and vinyl sheet flooring',

          hflor_sample: 'Find the perfect resilient flooring samples for your next demanding project. <br>' +
            'HFLOR offers a diverse array of samples to help you select from its innovative and high-performance LVT collections.',

          viatera_color: 'Raise the style quotient of every space with the beautiful range of quartz worktops from VIATERA. <br>' +
            'Explore our vast selection to find the ideal quartz countertop solution that blends exceptional performance with timeless design.',

          viatera_sample: 'Find the perfect quartz countertop samples for your next design project. <br>' +
            'VIATERA offers a diverse array of samples across its beautiful and highly durable quartz collection.',

          himacs_color: 'With HIMACS, rethink the limitations of design and push the boundaries of what’s possible. <br>' +
            'Discover the limitless palette of colors and designs that make HIMACS the ideal solid surface for both commercial and residential applications.',

          himacs_sample: 'Find the perfect solid surface samples for your next creative project. <br>' +
            'HIMACS offers a diverse array of samples to help you explore its flexible and seamless solid surface collection.',

          teracanto_color: 'Let the bold and exquisite designs of TERACANTO worktops transform your space into a memorable experience. <br>' +
            'Discover the extensive range of colors and patterns that establish TERACANTO porcelain surface as a true masterpiece of nature and superior <br>' +
            'engineering.',

          teracanto_sample: 'Find the perfect porcelain surface samples for your next sophisticated design. <br>' +
            'TERACANTO offers a diverse array of samples across its durable, large-format porcelain collection.',

          benif_color: 'Unlock exceptional design versatility with BENIF architectural film. <br>' +
            'Explore our extensive selection of colors and patterns to easily transform walls, ceilings, and furniture, using the specialized self-adhesive backing <br>' +
            'for quick and easy application.',

          borte_color: 'Designed for the spaces you live in every day, BORTE is a premium panel defined by surfaces that invite touch, <br>' +
            'materials that feel considered, and details that elevate a room.',

          default_desc: '',
        },
        allColors: {
          himacs: 'HIMACS Colors',
          himacs_samples: 'HIMACS Samples',
          hflor: 'HFLOR Colors',
          hflor_samples: 'HFLOR Samples',
          viatera: 'VIATERA Colors',
          viatera_samples: 'VIATERA Samples',
          teracanto: 'TERACANTO Colors',
          teracanto_samples: 'TERACANTO Samples',
          borte: 'BORTE Colors',
          borte_samples: 'BORTE Samples',
          benif: 'BENIF Colors',
          himacs_ac: 'HIMACS',
          hflor_ac: 'HFLOR',
          viatera_ac: 'VIATERA',
          exteriorfilm_ac: 'EXTERIOR Film',
          decofilm_ac: 'DECO Film',
          borte_ac: 'BORTE',
          teracanto_ac: 'TERACANTO',
          benif_ac: 'BENIF',
          vizuon_ac: 'VIZUON',
          products: 'Products',
          all_colors: 'All Colors',
          all_samples: 'All Samples',
          filter: 'Filter',
          filter_by: 'Filter By',
          brand: 'Brand',
          color: 'Color',
          searchText: 'Enter Item Number or Name',
          results: 'Results',
          no_result: 'No Result found',
          no_result_text: 'If you do not find what you are looking for, please try different search terms or filters.',
          apply: 'Apply',
          clear_all: 'Clear All',
          clear_all2: 'clear all',
          products_a_to_z: 'Products A to Z',
          products_z_to_a: 'Products Z to A',
          new_products_first: 'Most Recent',
          your_compare_is_full: 'Your compare is full',
          new: 'New',
          new_a: 'NEW',
          brandLabel: 'BRAND',
          colorLabel: 'COLOR',
          white: 'White',
          cream: 'Cream',
          beige: 'Beige',
          brown: 'Brown',
          gray: 'Gray',
          black: 'Black',
          green: 'Green',
          blue: 'Blue',
          pink: 'Pink',
          purple: 'Purple',
          ivory: 'Ivory',
          orange: 'Orange',
          red: 'Red',
          hidden_p: 'Discover the perfect quartz countertops color for your space with LX Hausys. Explore our impressive palette, featuring everything from timeless classics to bold contemporary designs. Experience the beauty of unique quartz colors and intricate details that elevate any style.',
          cala_hidden_h1: 'Calacatta Quartz VIATERA Colors',
          cala_hidden_p: 'Discover the perfect Calacatta quartz countertops color for your space with LX Hausys. Explore our impressive palette, featuring everything from timeless classics to bold contemporary designs. Experience the beauty of unique quartz colors and intricate details that elevate any style.',
          white_hidden_h1: 'White Quartz Countertops',
          white_hidden_p: 'Elevate your space with the unmatched elegance of white quartz countertops. Discover stunning designs that bring timeless beauty and sophistication to your kitchen or home. Order now and let white quartz countertops transform your style.',
          gray_hidden_h1: 'Gray Quartz Countertops',
          gray_hidden_p: 'Elevate your space with the unmatched elegance of gray quartz countertops. Discover stunning designs that bring timeless beauty and sophistication to your kitchen or home. Order now and let gray quartz countertops transform your style.'
        }
      }, // End of PF - text

      filter: {
        filter_by: 'Filter by',
        vizuon: 'VIZUON',
        vt: 'Vehicles and Transportation',
        sd: 'Signs and Displays',
        is: 'Illuminated Sign',
        ar: 'Architecture',
        es: 'Eco Solution',
        cb: 'Corporate Branding',
        feature: 'Feature',
        country: 'COUNTRY',
        compare: 'COMPARE',
        bookmatch: 'Bookmatch',
        application: 'APPLICATION',
        weatherability: 'WEATHERABILITY',
        remark: 'Remark',
        hflor: 'HFLOR',
        pet: 'PET',
        installation: 'Installation',
        productType: 'PRODUCT TYPE',
        filter: 'Filter',
        color: 'Color',
        collection: 'Collection',
        patterns: 'Pattern',
        finish: 'Finish',
        recycled: 'Recycled',
        thickness: 'Thickness',
        format: 'Format',
        wearlayer: 'Wear Layer',
        dimensions: 'Dimension',
        prdtype: 'Installation', // installation
        adhesivetype: 'Adhesive Type',
        productclassification: 'Product Classification',
        airfree: 'Air Free',
        solidcolor: 'Solid Color',
        solidPatterns: 'Solid Pattern',
        stoneColor: 'Stone Color',
        metalColor: 'Metal Color',
        woodColor: 'Wood Color',
        metalPattern: 'Metal Pattern',
        woodPattern: 'Wood Pattern',
        stonePattern: 'Stone Pattern',
        pvc: 'PVC',
        petFurnitureFilm: 'PET',
        acrylicFurnitureFilm: 'Acrylic',
        woodSpecies: 'Wood Species',
        new: 'NEW',
        fireresistance: 'Fire Resistance',
        stonetype: 'Stone Type',
        textiletype: 'Textile Type',
        slabsize: 'Slab Size',
        isNeoQ: 'Remark',
        category: 'Category',
        type: 'Type'
      },
      popup: {
        filter_by: 'FILTER BY',
        your_compare_is_full: 'Your compare is full',
        compare_tool: 'Compare tool',
        compare_alert1: 'Do you want to replace the first product',
        compare_alert2: 'you added by the one you selected?',
        edit_products_in_compare: 'EDIT PRODUCTS IN COMPARE',
        replace: 'REPLACE',
        close: 'close',
        characteristics_technical_performance: 'Characteristics & Technical Performance',
        pvc: 'PVC',
        acrylic: 'Acrylic',
        adhesive_type: 'Adhesive Type',
        adhesive_code: 'Adhesive Code',
        adhesive_name: 'Adhesive Name',
        air_free: 'Air Free',
        film_type: 'Film Type',
        material: 'Material',
        liner: 'Liner',
        width: 'Width',
        grade: 'Grade',
        length: 'Length',
        repeatImage: 'Repeat Image',
        fireResis: 'Fire Resistance',
        pet: 'PET',
        thickness: 'Thickness',
        thickness_mminch: 'Thickness (mm/inch)',
        thickness_cm: 'Thickness (cm)',
        dimension: 'Dimension',
        dimensions: 'Dimensions',
        dimension_inch: 'Dimension (inch)',
        dimensions_cm: 'Dimensions (cm)',
        dimensions_mm: 'Dimensions (mm)',
        weight_kg: 'Weight (kg)',
        slabsize_mminch: 'Slab Size (mm/inch)',
        slabsize_mm: 'Slab Size (mm)'
      },
      button: {
        all: 'All',
        lux: 'Luxury Vinyl Tile',
        hom: 'Homogeneous Sheet',
        het: 'Heterogeneous Sheet',
        spt: 'Specialty',
        compare: 'Compare',
        compare_your_colors: 'Compare your colors',
        remove: 'Remove',
        add_more: 'Add more',
        search: 'search',
        color: 'Color',
        collection: 'Collection',
        patterns: 'Patterns',
        finish: 'Finish',
        country: 'Country',
        new: 'New',
        coming: 'Coming soon',
        all_products: 'All products',
        grouped_by_collections: 'Grouped by collections',
        filter_by: 'Filter By',
        products_a_to_z: 'Products A to Z',
        products_z_to_a: 'Products Z to A',
        new_products_first: 'Most Recent',
        clear_all: 'Clear All',
        load_more: 'Load More',
        see_all_colors: 'See all colors',
        download: 'Download',
        Popularity: 'Popularity',
        lvt: 'Luxury Vinyl Tile',
        los: 'Looselay',
        spc: 'SPC Rigid Core',
        compare_on: 'ON',
        filter: 'Filter',
        most_recent: 'Most Recent',
        apply: 'Apply',
        all_filters: 'All Filters',
        reset: 'Reset',
        reset_all: 'Reset All',
      } // End of PF - button
    }, // End of PF
    other: {
      text: {
        sales_rep: 'Find a Sales Rep',
        showroom: 'Virtual Showroom',
        home: 'Home',
        products: 'Products',
        viatera: 'VIATERA',
        himacs: 'HIMACS',
        hotherPD: 'HIMACS Sinks',
        votherPD: 'VIATERA Sinks',
        overall: 'Overall Dimensions',
        inner: 'Inner Dimensions',
        contactus: 'Contact Us',
        close: 'close',
        arctic: 'Arctic White',
        ivory: 'Ivory White',
        cream: 'Cream',
        almond: 'Almond',
        all: 'All',
        otheroverall: 'Overall Dimensions',
        otherinner: 'Inner Dimensions',
        kitchen: 'Kitchen',
        bathroom: 'Bathroom',
        ada: 'ADA Compliance',
        himacs_sink_banner_desc: 'Explore the complete line of HIMACS vanity and kitchen sinks designed for superior aesthetics and functionality.<br>' +
          'Every HIMACS solid surface sink is engineered to be seamlessly integrated with a HIMACS countertop,<br>' +
          'providing a beautifully smooth, clean, and well-designed surface.',
        viatera_sink_banner_desc: 'Discover the Lovello™ stainless steel sink collection, designed to perfectly complement VIATERA Quartz Countertops.<br>' +
          'These high-quality sinks offer unique styling to enhance any kitchen or vanity,<br>' +
          'providing the ideal finishing touch when paired with your VIATERA surface.'
      },
      button: {
        learn_more: 'Learn more',
        view_more: 'View more',
        load_more: 'Load more',
        certi_more: 'What These Certifications Mean'
      }
    }

  }, // End of US

  GL: {
    PCD: {
      text: {
        home: 'Home',
        contact_us: 'Contact Us',
        products: 'Products',
        himacs: 'HIMACS',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        teracanto: 'TERACANTO',
        vizuonsigngraphic: 'VIZUON',
        himacssolidsurface: 'HIMACS',
        viateraquartzsurface: 'VIATERA',
        teracantoporcelainsurface: 'TERACANTO',
        benifarchitecturalfilm: 'BENIF',
        decofilm: 'Deco Film',
        exteriorfilm: 'Exterior Film',
        bortepanel: 'About BORTE',
        home_film: 'Home Appliance Surface Film',
        automotive: 'Automotive',
        sub: {
          lvt: 'Luxury Vinyl Tile',
          los: 'Looselay',
          spc: 'SPC Rigid Core',
          homo: 'Homogeneous Sheet',
          het: 'Heterogeneous Sheet',
          spt: 'Specialty',
          veh: 'Vehicles and Transportation',
          sd: 'Signs and Displays',
          illum: 'Illuminated Sign',
          arch: 'Architecture',
          eco: 'Eco Solutions',
          corp: 'Corporate Branding'
        },
        vizuon_a: 'VIZUON',
        benif: 'BENIF',
        deco: 'Deco Film',
        exterior: 'Exterior Film',
        about: {
          himacs: 'About HIMACS',
          hflor: 'About HFLOR',
          viatera: 'About VIATERA',
          teracanto: 'About TERACANTO',
          benif: 'About BENIF',
          borte: 'About BORTE',
          vizuon_a: 'About VIZUON',
          deco: 'About Deco Film',
          exterior: 'About Exterior Film',
          home_film: 'About Home Appliance Surface Film',
          automotive: {
            vegan_leather: 'Vegan Leather',
            light_comm: 'Lightweight Component',
            auto_comm: 'Automotive Component'
          }
        },
        featured_products: 'Featured Products',
        cart: 'cart',
        wish_list: 'wish list',
        new: 'New',
        coming: 'Coming soon',
        collection: 'Collection',
        explore_collection: 'Explore Collection',
        online_book: 'Online Book',
        load_more: 'Load More',
        certi_more: 'What These Certifications Mean',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        awards: 'Awards',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        order_a_sample: 'Order a Sample',
        documentation: 'Documentation',
        care_maintenance: 'Care & Maintenance',
        warranty: 'Warranty',
        where_to_buy: 'Where to buy',

        home_app_film: {
          title: 'Home Appliance Surface Film',
          title_description: 'Film laminated steel surface finishing material of home appliances, UBR and Elevator.',
          intro1: 'LX Hausys Home Appliance Surface Film is a high quality surface material with a variety of colors and patterns for refrigerators, washing machines and bathrooms.',
          intro2: 'Our superb products are already chosen by global appliance companies, because of its excellent anti-pollution, anti-scratch and anti-corrosion characteristics.',
          point_title1: 'Customizing Design Solution',
          point_description1: 'Based on Global Trend Research, development capabilities of customizing design solution for local customers has been recognized around the world, particularly in India, America, China, Southeast Asia and Europe.',
          point_title2: 'Global No.1',
          point_description2: 'LX Hausys’ Home Appliance Surface Film is running for the 1st M/S as a partner for Global major home appliance companies.',
          point_title3: 'Excellent Quality',
          point_description3: 'LX Hausys’ technology provides Anti Finger prints, Contamination Resistance, Anti Scratch and High Elongation for customers to use home appliances beautifully for a long time',
          construction: 'Construction',
          construction_film1: 'Metallic Film',
          film1_item1: 'Eco PET',
          film1_item1_desc: 'Printed Hairline on metal pearl with PET base',
          film1_item2: 'Metalon',
          film1_item2_desc: 'Metalizing gives real metal look on the film.',
          film1_item3: 'SUS Film',
          film1_item3_desc: 'Embossed Hairline technology allows customized pattern including horizontal hairline which enables the exact same look of STS.',
          construction_film2: 'Pearl & Patterned Film',
          film2_item1: 'Hi-Gloss',
          film2_item1_desc: 'Excellent printing technology can offer customized patterns.',
          film2_item2: 'Galaxy',
          film2_item2_desc: 'Various pearl effects will allow fine and glittery surface.',
          film2_item3: 'Soft-matte',
          film2_item3_desc: 'Soft-matte Textures with various color or customized patterns',
          application: 'Application',
          application_sub_title: 'Home Appliance Surface Film',
          application_item1: 'Pastel Metal',
          application_item2: 'Soft Matte',
          application_item3: 'Horizontal Hairline (Silver, Short)',
          application_item4: 'Horizontal Hairline (Black)',
          application_item5: 'Iridium Hairline',
          application_item6: 'Horizontal Hairline (Dark-grey)',
          application_item7: 'Glass Fiber',
          application_item8: 'Horizontal Hairline (Silver, Long)'
        },

        automotive_skin: {
          title: 'Vegan Leather',
          sub_title: 'Sustainable & Innovative',
          title_description: 'Sustainable Products, Innovative Technology for Environment',
          intro: 'is a major supplier of interior skin for various automotive applications. With our advanced technology and innovative design, we are able to offer you a total interior solutions to decorate your vehicle beyond your expectations.',
          point_title1: 'SAFETY',
          point_description1: 'STANDARD 100 by OEKO-TEX® certified products have been tested for harmful substances to protect your health (Green Label)',
          point_title2: 'Sustainable Materials',
          point_description2: 'Sustainable development by using bio-based and post-consumer recycled materials (Bio / Eco Label)',
          seat_cover: 'Seat Cover',
          seat_cover_desc: 'LX Hausys automotive skin delivers innovative designs through our best-in-class technology so as to bring emotional qualities to the indoor driving space.',
          cover_item1: 'SOFINO®',
          cover_item2: 'VERNO®',
          cover_item3: 'Calfpelle®',
          cover_item4: 'LUSSINO™',
          sofino_item1: 'SOFINO® Green',
          sofino_desc1: 'Comply with Class 1 of the OEKO-TEX® Standard 100, which attests that the material is safe for babies and small children¹⁾',
          sofino_item2: 'SOFINO® Bio',
          sofino_desc2: '<span>Developing bio leather from bio based fillers</span>' +
            '        <br />' +
            '        <span>(e.g., Kenaf, Eucalyptus, and so on)</span>',
          sofino_item3: 'SOFINO® Eco',
          sofino_desc3: ' <span>• RCS (Recycled Claim Standard) certificated</span>' +
            '        <br />' +
            '        <span>• Recycled content 35 wt% (Recycled Post-Consumer Polyester)</span>',
          sofino_anno: '<span>1) Limit values of OEKO-TEX® Standard 100 Class 1 (Products for babies)</span>' +
            '      <br />' +
            '      <span>• Solvent residues of NMP (1-Methyl-2-pyrrolidone), DMF (Dimethylformamide) ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span>• Sum of phthalates ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span class="spacing">(DBP, BBP, DEP, DMP, DEHP, DEMP, DIHP, DHNUP, DHxP, DIDP, DPrP, DHP, DNOP, DNP, DPP)</span>' +
            '      <br />' +
            '      <span>• Do not contain any of the banned flame retardant substances</span>' +
            '      <br />' +
            '      <span class="spacing">(e.g., Polybrominated Diphenyl Ethers, Antimony Trioxide)</span>' +
            '      <br />',
          verno_item1: 'VERNO® Green',
          verno_desc1: 'Comply with Class 1 of the OEKO-TEX® Standard 100, which attests that the material is safe for babies and small children¹⁾',
          verno_item2: 'VERNO® Bio',
          verno_desc2: '<span>• Environmental Claim Validation of UL-Solutions for biobased content</span>' +
            '        <br />' +
            '        <span>• Bio-based content ≥ 19%</span>',
          verno_item3: 'VERNO® Eco',
          verno_desc3: '<span>• RCS (Recycled Claim Standard) certificated</span>' +
            '        <br />' +
            '        <span>• Recycled content 50 wt% (Recycled Post-Consumer Polyester)</span>',
          verno_anno: '<span>1) Limit values of OEKO-TEX® Standard 100 Class 1 (Products for babies)</span>' +
            '      <br />' +
            '      <span>• Solvent residues of NMP (1-Methyl-2-pyrrolidone), DMF (Dimethylformamide) ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span>• Sum of phthalates ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span class="spacing">(DBP, BBP, DEP, DMP, DEHP, DEMP, DIHP, DHNUP, DHxP, DIDP, DPrP, DHP, DNOP, DNP, DPP)</span>' +
            '      <br />' +
            '      <span>• Do not contain any of the banned flame retardant substances</span>' +
            '      <br />' +
            '      <span class="spacing">(e.g., Polybrominated Diphenyl Ethers, Antimony Trioxide)</span>' +
            '      <br />',
          calfpelle_item1: 'Calfpelle®',
          calfpelle_desc1: '<span>• Suede with excellent surface quality</span>' +
            '        <br />' +
            '        <span>• Soft haptic and superior durability</span>',
          calfpelle_item2: 'Calfpelle® Bio',
          calfpelle_desc2: '<span>• Environmental Claim Validation of UL-Solutions for biobased content</span>' +
            '        <br />' +
            '        <span>• Bio-based content ≥ 10%</span>',
          lussino_item1: 'LUSSINO™',
          lussino_desc1: '<span>• [Premium grade] High-perfomance and sustainable silicone based leather</span>' +
            '        <br />' +
            '        <span>• Composition of silicone based material (Topcoat, Skin, Binder)</span>',
          design_area: 'Design',
          design_area_desc: 'LX Hausys develops automotive fabrics that not only offer high quality but also research and develop surface texture designs that match the vehicle\'s concept. By utilizing various patterns and design post-processing techniques, we provide design solutions that cater to our customers\' preferences.',
          comm_vegan_leather: 'Commercial Vegan Leather',
          comm_vegan_leather_desc: 'We have applied automotive seat fabric technology to achieve excellent surface quality in terms of durability, resistance to contamination, and other factors. We are also able to provide products using bio-based materials such as Kenaf.',
          comm_prd_title: 'LXELLO™',
          comm_item1: 'LXELLO™ Green',
          comm_desc1: 'Comply with Class 1 of the OEKO-TEX® Standard 100, which attests that the material is safe for babies and small children',
          comm_item2: 'LXELLO™ Bio',
          comm_desc2: 'The skin and foam layers contain bio based materials such as kenaf',
          comm_item3: 'LXELLO™ Eco',
          comm_desc3: '<span>• RCS (Recycled Claim Standard) certificated</span><br /> <span>• Recycled content 35 wt% (Recycled Post-Consumer Polyester)</span>',
          comm_anno: '<span>• The skin and foam layers contain bio based materials such as kenaf</span>' +
            '            <br>' +
            '            <span>- Kenaf is one of the highest CO<sub>2</sub> absorption rates among plants 3 to 10 times higher than average ¹⁾</span>' +
            '            <br>' +
            '            <span>• Designed to meet automotive interior demands including that of stain resistance</span>' +
            '            <br>' +
            '            <span>- Excellent anti-staining performance enables bright interior design</span>' +
            '            <br>' +
            '            <span>1) Source: Ministry of Environment\'s \'Analytic Report on Eco-friendly Crops\' (2019)</span>' +
            '            <br>',
          lello_palette_title: 'LXELLO™ Color Palette'
        },

        automotive_lightweight: {
          title: 'Lightweight Component',
          sub_title: 'We provide lightweight materials consisting of reinforced plastics, which maintain the strength of conventional steel and contribute to cut fuel consumption by reducing the weight of components.',
          title_description: 'Eco friendly, fuel-efficient lightweight car components with high steel rigidity',
          point_title1: 'Lightweight',
          point_description1: 'Reducing weight by 25% against conventional steel',
          point_title2: 'High strength',
          point_description2: 'Maintaining the strength of conventional steel',
          point_title3: 'Cost reduction',
          point_description3: 'Reducing the number of parts through design optimization',
          component_item1: 'Bumper Beam',
          component_desc1: '- Reducing weight by 25% against conventional steel \n ' +
            '- Protecting passengers on impact by shock absorption',
          component_item2: 'Knee Bolster',
          component_desc2: '- Reducing weight by 56% against conventional steel \n' +
            '- Protecting knees on impact',
          component_item3: 'Seat Back',
          component_desc3: '- Reducing weight by 30% against conventional steel \n' +
            '- minimization the number of components \n' +
            '- Improving the impact safety',
          component_item4: 'Battery Pack Bottom Panel',
          component_desc4: '- Reducing weight by 30% against alumimun\n' +
            '- Protecting the lower part of the electric vehicle battery pack',
          component_info: '※ Weight reduction is based on simulation results of automotive design analysis programs (CATIA, LS-DYNA), and may vary depending on specifications when the actual product is manufactured.',
          material_title: 'Lightweight Material',
          material_lwn_title: 'LiteMax',
          material_lwn_desc: 'LX Hausys\' Thermoplastic Continuous Glass Fiber Sheet',
          lwn_item1: 'LiteMax PPGF60',
          lwn_desc1: '<p>- Polypropylene impregnated glass fiber sheet</p>' +
            '                  <p>- Glass fiber content : 60wt%</p>' +
            '                  <p>- Best for lightweight designs</p>' +
            '                  <p>- Application : Rear bumper beam</p>',
          lwn_item2: 'LiteMax PPGF80',
          lwn_desc2: '<p>- Polypropylene impregnated glass fiber sheet</p>' +
            '                  <p>- Glass fiber content : 80wt%</p>' +
            '                  <p>- High glass fiber content for high stiffness</p>' +
            '                  <p>- Application : Bettery pack bottom panel</p>',
          lwn_item3: 'LiteMax PAGF60',
          lwn_desc3: '<p>- Polyamide 6 impregnated glass fiber sheet</p>' +
            '                  <p>- Glass fiber content : 60wt%</p>' +
            '                  <p>- Excellent thermal and impact resistance</p>' +
            '                  <p>- Application : Seat back frame</p>',
          material_lcore_title: 'L-Core Panel',
          material_lcore_desc: 'Lightweight sandwich panels with fiber core are used as a wall for trailers in North America.\n' +
            '                  L-core panels are lighter, more corrosion-resistant, and more resilient than HDPE Core panels.',
          lcore_item1: 'HDPE Panel',
          lcore_item2: 'L-Core Panel',
          lcore_thick: 'Thickness',
          lcore_weight: 'Unit weight',
          lcore_redu: 'Weight reduction',
          lcore_resi: 'Corrosion resistance',
          lcore_defo: 'Deformation<br>before and after loading',
          lcore_testInfo: '*Based on our high temperature and humidity accelerated life test'
        },

        automotive_auto: {
          title: 'Automotive Component',
          sub_title: 'We make innovative automotive components with a multitude of material formulas. Our cutting-edge technology improve energy efficiency and reduce weight of autos.',
          title_description: 'Various components applied to the exterior and interior of automobiles',
          point_title1: 'Energy Efficiency',
          point_description1: 'Reducing weight to <br/> improve energy efficiency',
          point_title2: 'High Quality',
          point_description2: 'Excellent quality by a <br/> cutting edge technology',
          point_title3: 'Superior Design',
          point_description3: 'Realizing the sophiscated and luxury patterns for your driving space',
          ext_eng_title: 'Exterior & Engine Part',
          exterior_part: 'Exterior Part',
          engine_part: 'Engine Part',
          exterior_item1: 'Structural Bumper System',
          exterior_desc1: '- Front, rear bumper assembly\n' +
            '- Observance of Pedestrian Safety\n' +
            '- Compliance with IIHS, R-Car',
          exterior_item2: 'Side Sil',
          exterior_desc2: '- Injection molding + Painting\n' +
            '- Forming technology (Electric Injection molding)',
          engine_item1: 'Cylinder Head Cover',
          engine_desc1: '- Replacing Aluminum with Plastic\n' +
            '- Prevention of oil leakage\n' +
            '- Oil-water separating system\n' +
            '- Observance of Euro5 legislation',
          engine_item2: 'Air Intake Manifold',
          engine_desc2: '- Replacing Aluminum with Plastic\n' +
            '- Variable Induction System',
          engine_item3: 'Transmission Oil Pan',
          engine_desc3: '- Replacing Plastic with Steel\n' +
            '- Prevention of oil leakage\n' +
            '- System for circulating the oil',
          interior_title: 'Interior Part',
          interior_desc: 'Creating sophisticated designs with natural patterned real wood',
          inter_detail1: 'SRP (Superfine Real Printing)',
          inter_detail1_desc: '<li>Enables precision 3D object printing</li>\n' +
            '            <li>Delivers superior realism and textured effects</li>\n' +
            '            <li>Applicable to a wide range of automotive interiors</li>\n' +
            '            <li>Application : Crash pads, Garnish, Consoles, Steering wheels, etc.</li>',
          inter_detail2: 'Real Materials',
          inter_detail2_desc: '<li>Premium aesthetic from natural wood veneers and carbon fiber</li>\n' +
            '            <li>Exquisite crash pads, garnishes, consoles, and armrests for luxury\n' +
            '              interior parts</li>',
          inter_design1: 'SRP Design',
          inter_design1_item1: 'Wood',
          inter_design1_item2: 'Fabric',
          inter_design1_item3: 'Geometric, Technical',
          inter_design1_item4: 'Hair line',
          inter_design2: 'Real Materials',
          inter_design2_item1: 'Wood',
          inter_design2_item2: 'Aluminum',
          inter_design2_item3: 'Textile',
          inter_design2_item4: 'Stone',
          inter_design2_item5: 'Carbon'
        },

        SOLID_SURFACE: 'SOLID SURFACE',
        KV_brief: 'The New Generation of Design Inspiration',
        brief: 'HIMACS is composed of minerals, acrylic and natural pigments that come together to provide a durable, smooth, non-porous and visually seamless surface which meets the highest standards for quality, aesthetics, fabrication, functionality and hygiene - offering manifold advantages over conventional materials. HIMACS is durable, it can be shaped by a thermoforming process, and thanks to its huge colour spectrum and translucent properties can help to achieve outstanding and colourful designs. HIMACS uses a simple heating process to give three-dimensional thermoforming capabilities, allows visually seamless designs, offers a virtually limitless range of colours and - for some shades - exhibits a special translucency when exposed to light. Although HIMACS is almost as robust as stone, it can be worked in a similar way as wood: it can be sawn, routed, drilled or sanded. HIMACS is available in sheets of different dimensions and thicknesses. The collection is completed with our range of kitchen sinks, basins, baths and shower trays.',
        photo_credit: 'Photo Credits: Design Marc Fidelle and Andrei David - Paris Airport Engineering and Architectural Management, fabrication : LCCA, photo : Mathieu Ducros',

        Aurora_collection_title: 'AURORA & MARMO',
        Aurora_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        ASTER_collection_title: 'ASTER',
        ASTER_collection_brief: 'Aster is a collection of elegant shades of grey, ranging from almost white to a warm beige, all with a gorgeous mother of pearl shimmer.',

        CONCRETE_collection_title: 'CONCRETE',
        CONCRETE_collection_brief: 'The indusrial look of concrete combined with the incredible flexibility of HI-MACS. The Concrete Collection adds huge opportunities for great designs to architects and designers',

        EXTERIA_collection_title: 'EXTERIA',

        GRANITE_collection_title: 'GRANITE, SPARKLE, QUARTZ, SAND & PEARL',
        GRANITE_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        LUCIA_collection_title: 'LUCIA',
        LUCIA_collection_brief: 'This collection focuses on the natural trend colours black, white and grey. The lively and homogeneous structures add character and expression to the colours. Not surprising, as the renowned Dutch designer, Marcel Wanders, designed three of these colours. (W001, W003, W004)',

        LUCENT_collection_title: 'LUCENT',
        LUCENT_collection_brief: 'The shades of the Lucent Collection, with their exceptional light translucency, allow for spectacular designs. Whether effectively backlit or simply illuminated, the Lucent colours of the architecture always add an elegant touch thanks to their characteristic reaction to light.',

        SOLIDS_collection_title: 'SOLIDS',
        SOLIDS_collection_brief: 'The classic in terms of solid surfaces &ndash; a wide range of attractive shades of white lies at the heart of this collection. Complemented by colourful, dynamic uni-shade accents from Lemon Squash to Festival Pink. The timeless collection offers the perfect colour for every design.',

        STRATO_collection_title: 'STRATO',
        STRATO_collection_brief: 'The marked linear patterns of Strato collection creates geometry through its soft structure and subtle look. The skilful use of the new linear pattern, vertically or horizontally, allows for great variation in each and every project.',

        TERRAZZO_collection_title: 'TERRAZZO',
        TERRAZZO_collection_brief: 'Using a vibrant concrete-base as the canvas for each design, the Terrazzo Collection from HI-MACS offers a vibration of color and patterns that speak to your past, present, and future self in anesthetic. Textured shades, artistic designs, and a touch of modern class, this collection creates a one of a kind experience.',

        ULTRA_collection_title: 'ULTRA',
        ULTRA_collection_brief: 'HIMACS Intense Ultra is based on a brand-new material formulation and combines Intense Colour technology with Ultra-thermoforming. Dark colours become more “intense”, darker and also more resistant, with less visible scratches. The new HIMACS Intense Ultra, also has excellent thermoforming capabilities.',

        VOLCANICS_collection_title: 'VOLCANICS',
        VOLCANICS_collection_brief: 'The large particles of the Volcanics shades add a sense of style to any design. When used on a large scale the result is a dramatic showpiece.',

        Sustainability: 'Sustainability',

        /* GL feature benefits TAB */

        TAB_Quality_Design_title: 'Quality Design',
        TAB_Quality_Performance_title: 'Quality Performance',
        TAB_Quality_Fabrication_title: 'Quality Fabrication',
        TAB_Quality_Sustainability_title: 'Quality Sustainability',

        /* END GL feature benefits TAB */

        /* GL feature benefits - Quality Design - TAB */

        Design_title1: 'Wide Range of Shapes',
        Design_brief1: 'Every option is available to designers to create neat washrooms, kitchens, hospitals and much more with our wide range of HIMACS sinks and bowls. Perfectly coordinated and ideal for mixing and matching, the bowls and sinks guarantee a modern look that is easy ad simple to look after.',

        Design_title2: 'Dramatic Translucency',
        Design_brief2: 'Certain colours and thicknesses of HIMACS exhibit a special translucency when exposed to light.',
        Design_brief2_1: 'Various textures and patterns can be built into the material to intensify the HIMACS translucency effect.',

        Design_title3: '3-Dimensional Design',
        Design_brief3: 'HIMACS boasts a simple heating process and three-dimensional thermoplastic forming capabilities.',
        Design_brief3_1: 'This allows for greater forming flexibility compared with other conventional materials so that spectacular ideas can quickly take on a concrete shape.',

        Design_title4: 'Unlimited Spectrum of Colours',
        Design_brief4: 'HIMACS offers a virtually limitless range of colours in all conceivable shades.',
        Design_brief4_1: 'More are being added every year no matter what colour you choose, HIMACS remains 100% homogeneous.',

        /* END GL feature benefits - Quality Design - TAB */

        /* GL feature benefits - Quality Performance - TAB */

        Performance_title1: 'Strong',
        Performance_brief1: 'Stronger surface with durability similar to that of natural stone - HIMACS stands up to everyday scratches. Should you accidentally inflict a deeper scratch or surface impression, a trained professional can easily resurface your HIMACS thanks to its sealant-free consistency.',

        Performance_title2: 'Fire Resistant',
        Performance_brief2: 'Backed up with numerous certificates that attest of its fire resistance,',
        Performance_brief2_1: 'HIMACS is ideal for places where security is the number 1 criteria of choice.',

        Performance_title3: 'Hygienic',
        Performance_brief3: 'Thanks to its impermeability to dirt, bacteria, viruses and countless chemicals, HIMACS is the ideal material for the hospital,',
        Performance_brief3_1: 'medical practice or laboratory. And for all other areas where hygiene really counts.',

        Performance_title4: 'Water Resistant',
        Performance_brief4: 'Thanks to its non-porous surface HIMACS is suitable for humid areas where moisture can form such as wet rooms',
        Performance_brief4_1: 'and bathrooms.',

        /* END GL feature benefits - Quality Performance - TAB */

        /* GL feature benefits - Quality Fabrication - TAB */

        Fabrication_title1: 'Most Advanced Fabrication Technology',
        Fabrication_brief1: 'The material is heated in a progressive tempering process (Thermal Cure). which sets HIMACS apart from other mineral materials and produces a new and stronger compound in which any structural defects are perfectly evened out. This improved structure automatically affects the quality of the material.',

        Fabrication_title2: 'Simple Processing',
        Fabrication_brief2: 'Although HIMACS is almost as robust as stone, it can be worked in the same way as wood. ',
        Fabrication_brief2_1: 'Using conventional carpenter\'s tools, this solid surface material can be sawn, routed or drilled.',

        Fabrication_title3: 'Seamless Perfection',
        Fabrication_brief3: 'HIMACS allows for visually seamless manipulation.',
        Fabrication_brief3_1: 'Smooth integration enables large areas without joints or edges as well as flush mounting of sinks or bowls.',

        /* END GL feature benefits - Quality Fabrication - TAB */

        /* GL feature benefits - Quality Sustainability - TAB */

        Sustainability_title1: 'Renewable',
        Sustainability_brief1: 'With easy-to-care and repairable properties, no matter if it\'s a scratch, stain or crack,',
        Sustainability_brief1_1: 'HIMACS can be restored to its original state by a certified professional.',

        Sustainability_title2: 'Sustailable',
        Sustainability_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        /* END GL feature benefits - Quality Sustainability - TAB */

        /* GL certifications TAB */

        certifications_desc_p: 'Certification Description',
        certifications_desc_m: 'Certification <br> Description',

        TAB_Environment_title: 'Environment',
        TAB_Fire_Rating_title: 'Fire Rating',
        TAB_HIMACS_Exteria_title: 'HIMACS Exteria Certificates',
        TAB_Hygiene_title: 'Hygiene',
        TAB_Process_title: 'Process',

        /* END GL certifications TAB */

        /* GL certifications - Environment - TAB */

        Environment_title1: 'Ministry of Environment of the Republic of Korea',
        Environment_brief1: 'designates HIMACS as environmentally-friendly thanks to the demonstration of its commitment to ecological awareness in its product management activities.',

        Environment_title2: 'M1 Emissions Classification',
        Environment_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        Environment_title3: 'Leadership in Energy and Environnemental Design (LEED)',
        Environment_brief3: 'Is a standard voluntary system to certify high performance of buildings, from the US Green Building Council (USGBC). LEED certifies buildings using a credit system. The use of HIMACS contributes toward satisfying EQ Credit for Low-Emitting Materials with the category Indoor Environmental Quality (EQ).',

        Environment_title4: 'ISO 14001',
        Environment_brief4: 'The ISO 14000 family concerns the management of environmental quality. The most popular certificate in this group is ISO 14001. It encourages the minimisation of damage caused by our own activity to the environment and the continuous improvement of environmental performance. The objective is to contribute to protecting and stabilising our planet’s environment. This test certifies that the environment management system of HIMACS conforms to ISO 14001 standards.',

        Environment_title5: 'Greenguard',
        Environment_brief5: 'HI-MACS has been approved by Greenguard in the USA, as a “low emitting product”. The organisation establishes acceptable indoor air standards for indoor products, environments and buildings. The organisation’s goal is to improve public health and quality of life through programs that improve indoor air.',

        Environment_title6: 'Environmental Building Certificate – Grade "outstanding"',
        Environment_brief6: 'The Korean Air Cleaning Association certifies that HIMACS complies with the Korean regulations for environmental building materials.',

        Environment_title7: 'DGNB',
        Environment_brief7: 'The DGNB system, founded by the "German Sustainable Building Council”, evaluates buildings holistically on the basis of individual criteria within the categories Ecological Quality, Economic Quality, Sociocultural and Functional Quality, Technical Quality, Process Quality and Location Quality. Different profiles allow the certification of new buildings and existing buildings, as well as of quarters in Germany and Internationally. Buildings can achieve a certification in Bronze, Silver, Gold and Platinum. HIMACS has an Environmental Product Declaration (EPD), which can be used to calculate the building life cycle assessment (ENV1.1/2.1). Furthermore, HIMACS has achieved Quality Level 4 of 4 in DGNB 2018 criteria for local environmental impact for the entire product.',

        Environment_title8: 'BREEAM (Building Research Establishment Environmental Assessment Method)',
        Environment_brief8: 'BREEAM is the world’s leading sustainability assessment method for masterplanning rojects, infrastructure and buildings. It recognises and reflects the value in higher performing assets across the built environment lifecycle, from new construction to in-use and refurbishment. HIMACS can contribute to BREEAM International New Construction 2016 certification, as the entire product complies with Hea 02 Indoor air quality. Furthermore, HIMACS achieved RSCS summary score level in Mat 03, responsible sourcing of construction products for the entire product: RSCS level 1. “BREEAM is a registered trade mark of the Building Research Establishment Limited, a wholly owned subsidiary of BRE Group Limited, and is used by permission. LX Hausys and its products are not affiliated, endorsed or certified by BRE Global Limited, which is the operator of BREEAM, or any other subsidiary of BRE Group Limited. All rights are reserved.”',

        /* END GL certifications - Environment - TAB */

        /* GL certifications - Fire Rating - TAB */

        Fire_Rating_title1: 'Norm NFP 92-501 Class M1',
        Fire_Rating_brief1: 'LNE tests the reactivity to fire of a material. Class M1 certifies that HIMACS FR benefits from advanced resistance to fire. This certificate is recommended in France.',

        Fire_Rating_title2: 'Norm EN 45 545 Class R1 HZL3',
        Fire_Rating_brief2: 'Fire protection on railway vehicles: The measures and requirements specified in EN 45 545 are intended to protect passengers and staff in railway vehicles in the event of a fire on board. HIMACS has achieved the highest and best performance R1 HZL3 (Hazard Level). Valid for Alpine White S728.',

        Fire_Rating_title3: 'Norm EN 13501 - Class B-s1, d0',
        Fire_Rating_brief3: 'HIMACS successfully passed the European test EN 13501 – Class B-s1, d0, equivalent to the class 0 from Warrington Fire certification.',

        Fire_Rating_title4: 'Norm DIN 4102-1 - Class B1',
        Fire_Rating_brief4: 'Class B1 certifies that HIMACS has a low flammability. B1 class is the European fire resistance requirement. This test result is valid for all colour ranges in 12mm.',

        /* END GL certifications - Fire Rating - TAB */

        /* GL certifications - Exteria Certificates - TAB */

        Exteria_title1: 'IMO MED – Modules B and D',
        Exteria_brief1: 'MED stands for Marine Equipment Directive. Both modules are extremely important for the shipbuilding industry, as they are mandatory for fabrication materials used in ships. IMO B covers the fire resistance of the material per se and certifies that the material has low flame spread characteristics and is not capable of producing excessive quantities of smoke and toxic combustion products. Module D covers the overall production capacity and checks, among other production processes, the management and systems used.',

        Exteria_title2: 'ETA',
        Exteria_brief2: 'Fixed with Keil inserts and a BWM structure, HIMACS facade in S728 - Alpine White successfully passed the ETA tests (European Technical Agreement).',

        Exteria_title3: 'CSTB Certification',
        Exteria_brief3: 'HIMACS has obtained the French QB certification and CSTB ATec “Avis Technique” for facade applications (Avis Technique 2.2/18-1795_V1).',

        /* END GL certifications - Exteria Certificates - TAB */

        /* GL certifications - Hygiene - TAB */

        Hygiene_title1: 'NSF',
        Hygiene_brief1: 'NSF standards are generally accepted norms for a variety of public health related industries and fields. These include drinking water treatment and contact with materials, food equipment manufacturing etc. NSF recognises that HIMACS complies with NSF norms.',

        Hygiene_title2: 'LGA',
        Hygiene_brief2: 'Necessary in hospitals and environments where hygiene is critical, LGA assesses the ease of cleaning, resistance to bacteria and fungi and rates the design from a hygiene point of view. Thanks to its non-porosity, HIMACS has been approved for the LGA seal “hygiene tested”.',

        /* END GL certifications - Hygiene - TAB */

        /* GL certifications - Process - TAB */

        Process_title1: 'OHSAS 18001',
        Process_brief1: 'OHSAS 18001, Occupational Health and Safety Assessment Series, (officially BS OHSAS 18001) is a British Standard for occupational health and safety management systems. Compliance with it enables organizations to demonstrate that they have a system in place for occupational health and safety.',

        Process_title2: 'ISO 9001',
        Process_brief2: 'ISO 9001 criteria can guarantee the following points:',
        Process_brief3: 'The whole fabrication process, ensuring a good product quality',
        Process_brief4: 'Quality control, with an appropriate corrective procedure, when needed and regular control of quality control procedures.',
        Process_brief5: 'Process, which aims to continuously improve global efficiency',

        /* END GL certifications - Process - TAB */

        /* GL sustainbility - TAB */

        sustainbility_title1: 'Shaping the Future in Harmony with the Environment',
        sustainbility_brief1: 'Countless internationally recognized certificates attest to the fact that HIMACS has a strong focus on ecological aspects. Without exception, all HIMACS products are manufactured in accordance with the ISO 14001 environmental standard.',

        TAB_Commitment_title: 'Commitment',
        TAB_Material_Safety_title: 'Material Safety',
        TAB_Manufacturing_title: 'Manufacturing',
        TAB_Processing_title: 'Processing',
        TAB_Transport_title: 'Transport',

        /* END GL sustainbility - TAB */

        /* GL sustainbility - Commitment - TAB */

        Commitment_title1: 'Commitment',
        Commitment_brief1: 'LX Hausys conducts and publishes regular environmental audits along with energy consumption analyses. Thanks to the use of non-polluting fuels, greenhouse gas emissions have been cut by 15,000 tons per year since 2008.',

        /* END GL sustainbility - Commitment - TAB */

        /* GL sustainbility - Material Safety - TAB */

        Material_Safety_title1: 'Material Safety',
        Material_Safety_brief1: 'Extensive studies – within LX Hausys’ own laboratories as well as tests carried out by other renowned independent institutions – have shown that the HIMACS material itself, as well as the cured adhesive, are completely free from formaldehyde and emissions. HIMACS has been awarded the Greenguard Gold Indoor Air Quality Certificate.',

        /* END GL sustainbility - Material Safety - TAB */

        /* GL sustainbility - Manufacturing - TAB */

        Manufacturing_title1: 'Manufacturing',
        Manufacturing_brief1: 'The production of this solid surface material is marked by an excellent energy balance. In recent years, the company was very successful in achieving ambitious goals in terms of waste reduction and water conservation. In addition, HIMACS plants in Cheongju (Korea) and Atlanta (USA) meet all environmental standards.',

        /* END GL sustainbility - Manufacturing - TAB */

        /* GL sustainbility - Processing - TAB */

        Processing_title1: 'Processing',
        Processing_brief1: 'The material allows for virtually waste-free processing. In addition, HIMACS installations are extremely strong and durable. They can easily be renewed to their original appearance, meaning they don’t have to be replaced, thus giving a positive long-term  environmental footprint.',

        /* END GL sustainbility - Processing - TAB */

        /* GL sustainbility - Transport - TAB */

        Transport_title1: 'Transport',
        Transport_brief1: 'Within Europe, HIMACS observes the Euro-5 standards for reduced particulate emissions. The partner-network of LX Hausys Europe consists of carefully selected partners with the highest environmental standards: for example, the State-of-the-Art logistics centre in the Netherlands is one of the first buildings to have been constructed in accordance with the WELL Building Standards and awarded the BREEAM Certificate. This means that it meets the highest requirements for environmentally friendly and healthy construction. '

        /* END GL sustainbility - Transport - TAB */

      }, // End of PCD - text

      alert: {
        loginLike: 'Log in to save to your Likes'
      }, // End of PCD - alert

      button: {
        seeMore: 'See More',
        see_all: 'See all Designs',
        learnMore: 'Learn more',
        explore_collection: 'Explore Collection',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        close: 'close',
        find_a_sales_rep: 'Find a Sales Rep',
        btn_sustainbility_brochure: 'Download Sustainability Brochure',

        English: 'English',
        German: 'German',
        French: 'French',
        Italian: 'Italian',
        Spanish: 'Spanish',
        Dutch: 'Dutch',
        EnglishUK: 'English (UK)'

      }, // End of PCD - button

      popup: {
        /* Edge Profiles 시작 점 */
        edge_title: 'Viatera Edge Profile',
        edge_brief: 'Where quartz meets the edge. LX Hausys Surfaces offers a wide selection of edge treatments.' +
          '                    Select from a simple rounded corner to the complex multi-toned,' +
          '                    multi-tiered rolling edges that add that special finishing touch to your solid surface counter.' +
          '                    For more information on our edge treatments, please consult your local area distributor or' +
          '                    fabricator.',

        beveled_Edge: 'Beveled Edge',
        beveled_Edge_brief: 'Maintains the surface’s thickness,\n' +
          '                    but with a ¼” or ½” angular top edge.',
        bullnose_Edge: 'Bullnose Edge',
        bullnose_Edge_brief: 'A completed rounded edge.',

        eased_Edge: 'Eased Edge',
        eased_Edge_brief: 'A slightly rounded top edge that still\n' +
          "                    maintains the surface's thickness.",

        ellipse_Edge: 'Ellipse Edge',
        ellipse_Edge_brief: 'Rounded top and bottom edges\n' +
          '                    with a flat face.',

        knife_Edge: 'Knife Edge',
        knife_Edge_brief: 'A sharp, blade-like edge.',

        reverse_Ogee_Edge: 'Reverse Ogee Edge',
        reverse_Ogee_Edge_brief: 'Similar to Roman Edge, but reversed.',

        roman_Edge: 'Roman Edge',
        roman_Edge_brief: 'An elaborate ogee-style edge design\n' +
          '                    inspired by Roman architecture.',

        roundover_Edge: 'Roundover Edge',
        roundover_Edge_brief: 'A semi-circle rounded top edge.',

        /* Edge Profiles 끝 */

        /* Finish 시작 점 */
        finishInfo: 'Finish guide',
        finishTitle: 'Introducing New Viatera Finish Brushed',
        finishBrief: 'Select Viatera colors are now available with a “Brushed” finish to fulfill a wider range of aesthetics.\n' +
          '                  Enjoy the new classic beauty with a satin-like finish.',
        polished: 'POLISHED',
        polished_brief: 'Traditional reflective surface',

        brushed: 'BRUSHED',
        brushed_brief: 'Soft and smooth feel with\n' +
          '                    low-luster on the surface',

        leather: 'Leather',
        leather_brief: 'Leather finish has a slightly more matte texture than a polished finish, and makes you feel the soft touch of the leather.',

        velvet_Touch: 'Velvet Touch',
        velvet_Touch_brief: 'Velvet touch finish enables you to feel the texture of nature with the feeling of stone dents.',

        finish_viatera: 'Viatera',
        finish_viatera_info: 'Brushed Finish Care & Maintenance',
        finish_viatera_brief: 'Viatera products with Brushed Finish are the same as those with the standard Polished Finish.\n' +
          '                  The only manufacturing difference is how the final gloss level is achieved.',

        finish_viatera_brief_01: 'Brushed Finish may need more daily attention than Polished Finish. This is the nature of any material with a matte finish when compared to the same material\n' +
          '                  with a polished finish – smudges, fingerprints, and water spots are simply more visible on a matte surface. Promptly wipe up and buff dry routine spills, droplets,\n' +
          '                  and rings. A microfiber towel may be more effective than a paper towel because Brushed Finish has a slight surface texture when compared to Polished Finish.\n' +
          '                  These non-woven cleaning products work well on all surfaces and are especially helpful on products that feature anything other than a perfectly smooth surface.',

        finish_viatera_brief_02: 'Routine Care and Maintenance of Brushed Finish is easy with the same liquid household cleaners that are suitable for “Polished” finishes, including Formula 409\n' +
          '                  Natural Stone & Steel Cleaner.',

        finish_viatera_brief_03: 'Always read and follow that manufacturer’s label instructions. A textured sponge that’s suitable for non-stick coated cookware may be helpful in removing some\n' +
          '                  tougher spills. Avoid using abrasive cleaners like Ajax or Comet, as these more aggressive materials may dull or damage the surface of Brushed Finish.\n' +
          '                  After using any cleaning product always rinse the area and buff the area dry. A microfiber product is suggested but not required.'

        /* Finish 끝 */

      } // End of PCD - popup
    }, // End of PCD

    PD: {
      text: {
        new: 'NEW',
        coming: 'Coming soon',
        discontinued_Color: 'Discontinued Color',
        image_enlarged_view: 'IMAGE ENLARGED VIEW',
        image_download_view: 'IMAGE DOWNLOAD VIEW',
        finish: 'Finish',
        finishGuide: 'Finish guide',
        color: 'Color',
        product_Specs: 'Product Specs',
        product_type: 'Product Type',
        total_thickness: 'Total Thickness',
        wear_layer: 'Wear Layer',
        dimension: 'Dimensions',
        dimension1: 'Dimension &',
        weight: 'Weight',
        remark: 'Remark',
        pattern: 'Pattern',
        emboss: 'Emboss',
        installation: 'Installation',
        adhesive_code: 'Adhesive Code',
        adhesive_name: 'Adhesive Name',
        available_Countries: 'Available Countries',
        related_Products: 'Related Products',
        features_Benefits: 'Features & Benefits',
        certifications: 'Certifications',
        documentation_technical_details: 'DOCUMENTATION & TECHNICAL DETAILS',
        fabrication: 'Fabrication',
        test_report: 'Test Report',
        care_maintenance: 'Care & Maintenance',
        catalogue: 'Catalog',
        certification: 'Certification',
        technical_datasheet: 'Technical Datasheet',
        installation_guide: 'Installation Guide',
        warranty: 'Warranty',
        edge_profile: 'Edge Profile',
        inspiration: 'Inspiration',
        standard: 'Standard',
        image_viewer: 'For illustration purposes only. Image size:',
        in: 'in',
        zoom_out: 'zoom Out',
        zoom_in: 'zoom In',
        Thickness: 'Thickness',
        Use: 'Use',
        Pattern: 'Pattern',
        Notice: 'Notice',
        Notice_brief: 'Less suitable for surfaces which are subject to high traffic, due to their higher pigmented colour saturation, marks may be seen more easily.',
        Semi_Translucent: 'Semi-Translucent colour',
        Semi_Translucent_brief: 'Colours with this mark have a semi-translucent effect, evident when combined with light sources',
        Outdoor: 'Outdoor',
        Outdoor_brief: 'Suitable for exterior use. Please check conditions about level of suitability and warranty per colour. Indoor, Suitable for Kitchen & Bathroom',
        Recycled: 'Recycled',
        Recycled_brief: 'Certified to contain pre-consumer recycled content. Minimum',
        Designer: 'Designer Series',
        Designer_brief: 'Designed by Marcel Wanders',
        Lucent: 'Lucent',
        Lucent_brief: 'Lucent colours have a higher level of translucency, more evident when combined with light source. Translucent colour',
        Veined: 'Veined',
        Veined_brief: 'As Marmo is a randomly veined product, specific fabrication guidelines need to be followed.',
        construct: 'Construct',
        news_letter: 'Sign up for our Newsletter',
        news_letter_desc: 'Discover innovative projects, unique colors  and the latest news and trends',
        subscribe: 'Subscribe',

      }, // End of PD - text

      button: {
        virtual_Showroom: 'Virtual Showroom',
        prev: 'Prev',
        next: 'Next',
        list_view: 'list view',
        download: 'download',
        see_all_documentation: 'See All Documentation',
        see_all_case_studies: 'See All Case Studies',
        see_more: 'See More'
      } // End of PD - button

    }, // End of PD

    PF: {

      text: {
        category: 'CATEGORY',
        luxury_vinyl_tile: 'Luxury Vinyl Tile',
        looselay: 'Looselay',
        homogeneous_sheet: 'Homogeneous Sheet',
        heterogeneous_sheet: 'Heterogeneous Sheet',
        specialty: 'Specialty',
        filter_by: 'Filter By',
        patterns: 'Patterns',
        country: 'Country',
        new: 'New',
        new_a: 'NEW',
        coming: 'Coming soon',
        new_colors: 'NEW COLORS',
        product_type: 'Product Type',
        thickness: 'Thickness (inch)',
        weight: 'Weight (lbs)',
        finish: 'Finish',
        wear_layer: 'Wear Layer',
        dimension: 'Dimensions',
        searchText: 'Enter Item Number or Name',
        recycled: 'Recycled',
        exclusive: 'U.S. Exclusive',
        Tones: 'Tones',
        Use: 'Use',
        Recycled: 'Recycled',
        Thickness: 'Thickness',
        himacs: 'HIMACS',
        hflor: 'HFLOR',
        borte: 'BORTE',
        viatera: 'VIATERA',
        exteriorfilm: 'Exterior Film',
        decofilm: 'Deco Film',
        teracanto: 'TERACANTO',
        benif: 'BENIF',
        vizuon_a: 'VIZUON',
        lvt: 'Luxury Vinyl Tile',
        los: 'Looselay',
        spc: 'SPC Rigid Core',
        hom: 'Homogeneous Sheet',
        het: 'Heterogeneous Sheet',
        spt: 'Specialty',
        installation: 'Installation',
        results: 'Results',
        no_search_result: 'No Result Found',
        no_compare_item: 'No items to compare',
        no_option: 'Please select option',
        color: 'Color',
        filters: 'Filters',
        compare: {
          viatera: 'COMPARE VIATERA PRODUCTS',
          hflor: 'COMPARE HFLOR PRODUCTS',
          teracanto: 'COMPARE TERACANTO PRODUCTS',
          himacs: 'COMPARE HIMACS PRODUCTS',
          exteriorfilm: 'COMPARE Exterior Film PRODUCTS',
          decofilm: 'COMPARE Deco Film PRODUCTS',
          benif: 'COMPARE BENIF PRODUCTS',
          vizuon_a: 'COMPARE VIZUON PRODUCTS',
          borte: 'COMPARE BORTE PRODUCTS'
        },
        compare_full: {
          text: 'Do you want to replace the first Products <br>' +
            'you added by the one you selected?',
          footer: 'Edit products in compare'
        },
        slab_size: 'Slab Size(inch)',
        bookmatch: 'Bookmatch',
        remark: 'Remark',
        key_visual_desc: {
          all_colors: 'Discover the ideal color and design option for your upcoming projects, from quartz countertops to solid surfaces, porcelain, panels, and resilient <br>' +
            'flooring. <br>' +
            'LX Hausys provides a broad spectrum of colors, finishes, and aesthetic choices across its entire portfolio of surfacing and flooring materials.',

          all_samples: 'Find the perfect samples for your next project, whether you need quartz countertops, solid surfaces, porcelain surfaces, or resilient flooring. <br>' +
            'LX Hausys offers a diverse array of samples across its entire surfacing and flooring portfolio.',

          hflor_color: 'Explore the vast world of design possibilities with HFLOR resilient flooring. <br>' +
            'Our diverse palette of colors and patterns extends across all our resilient flooring materials, including luxury vinyl tile and vinyl sheet flooring',

          hflor_sample: 'Find the perfect resilient flooring samples for your next demanding project. <br>' +
            'HFLOR offers a diverse array of samples to help you select from its innovative and high-performance LVT collections.',

          viatera_color: 'Raise the style quotient of every space with the beautiful range of quartz worktops from VIATERA. <br>' +
            'Explore our vast selection to find the ideal quartz countertop solution that blends exceptional performance with timeless design.',

          viatera_sample: 'Find the perfect quartz countertop samples for your next design project. <br>' +
            'VIATERA offers a diverse array of samples across its beautiful and highly durable quartz collection.',

          himacs_color: 'With HIMACS, rethink the limitations of design and push the boundaries of what’s possible. <br>' +
            'Discover the limitless palette of colors and designs that make HIMACS the ideal solid surface for both commercial and residential applications.',

          himacs_sample: 'Find the perfect solid surface samples for your next creative project. <br>' +
            'HIMACS offers a diverse array of samples to help you explore its flexible and seamless solid surface collection.',

          teracanto_color: 'Let the bold and exquisite designs of TERACANTO worktops transform your space into a memorable experience. <br>' +
            'Discover the extensive range of colors and patterns that establish TERACANTO porcelain surface as a true masterpiece of nature and superior <br>' +
            'engineering.',

          teracanto_sample: 'Find the perfect porcelain surface samples for your next sophisticated design. <br>' +
            'TERACANTO offers a diverse array of samples across its durable, large-format porcelain collection.',

          benif_color: 'Unlock exceptional design versatility with BENIF architectural film. <br>' +
            'Explore our extensive selection of colors and patterns to easily transform walls, ceilings, and furniture, using the specialized self-adhesive backing <br>' +
            'for quick and easy application.',

          borte_color: 'Designed for the spaces you live in every day, BORTE is a premium panel defined by surfaces that invite touch, <br>' +
            'materials that feel considered, and details that elevate a room.',

          exterior_color: 'Elegant solutions engineered to last',

          vizuon_color: 'Explore the full VIZUON collection of LX Hausys Sign & Graphic Film, designed to bring your ideas to life with vibrant visual imagery and easy application.<br>' +
            'Scroll through our wide range of solutions, perfectly suited for Vehicles and Transportation, large Signs and Displays, detailed Illuminated Signs, and custom Architectural<br>' +
            'projects. Discover available colors and styles, including our Eco Solutions and comprehensive Corporate Branding options, to find the ideal match for your visual needs.',
          deco_color: 'Rethink the design limitations of furniture and millwork with LX Hausys Deco film.<br>' +
            'Discover our vast and limitless palette of colors and patterns to bring exceptional aesthetic versatility and customized design to any interior.',

          default_desc: '',
        },
        allColors: {
          himacs: 'HIMACS Colors',
          hflor: 'HFLOR Colors',
          viatera: 'VIATERA Colors',
          exteriorfilm: 'Exterior Film Colors',
          decofilm: 'Deco Film Colors',
          teracanto: 'TERACANTO Colors',
          benif: 'BENIF Colors',
          vizuon_a: 'VIZUON Colors',
          borte: 'BORTE Colors',
          himacs_ac: 'HIMACS',
          hflor_ac: 'HFLOR',
          viatera_ac: 'VIATERA',
          exteriorfilm_ac: 'EXTERIOR Film',
          decofilm_ac: 'DECO Film',
          borte_ac: 'BORTE',
          teracanto_ac: 'TERACANTO',
          benif_ac: 'BENIF',
          vizuon_ac: 'VIZUON',
          products: 'Products',
          all_colors: 'All Colors',
          filter: 'Filter',
          filter_by: 'Filter By',
          brand: 'Brand',
          color: 'Color',
          searchText: 'Enter Item Number or Name',
          results: 'Results',
          no_result: 'No Result found',
          no_result_text: 'If you do not find what you are looking for, please try different search terms or filters.',
          apply: 'Apply',
          clear_all: 'Clear All',
          clear_all2: 'clear all',
          products_a_to_z: 'Products A to Z',
          products_z_to_a: 'Products Z to A',
          new_products_first: 'Most Recent',
          your_compare_is_full: 'Your compare is full',
          new: 'New',
          new_a: 'NEW',
          brandLabel: 'BRAND',
          colorLabel: 'COLOR',
          white: 'White',
          cream: 'Cream',
          beige: 'Beige',
          brown: 'Brown',
          gray: 'Gray',
          black: 'Black',
          green: 'Green',
          blue: 'Blue',
          pink: 'Pink',
          purple: 'Purple',
          ivory: 'Ivory',
          orange: 'Orange',
          red: 'Red'
        }
      }, // End of PF - text

      filter: {
        filter_by: 'Filter by',
        vizuon: 'VIZUON',
        vt: 'Vehicles and Transportation',
        sd: 'Signs and Displays',
        is: 'Illuminated Sign',
        ar: 'Architecture',
        es: 'Eco Solution',
        cb: 'Corporate Branding',
        feature: 'Feature',
        country: 'COUNTRY',
        compare: 'COMPARE',
        bookmatch: 'Bookmatch',
        application: 'APPLICATION',
        weatherability: 'WEATHERABILITY',
        remark: 'Remark',
        hflor: 'HFLOR',
        pet: 'PET',
        installation: 'Installation',
        productType: 'Product Type',
        filter: 'Filter',
        color: 'Color',
        collection: 'Collection',
        patterns: 'Pattern',
        finish: 'Finish',
        recycled: 'Recycled',
        thickness: 'Thickness',
        format: 'Format',
        wearlayer: 'Wear Layer',
        dimensions: 'Dimension',
        prdtype: 'Installation', // installation
        adhesivetype: 'Adhesive Type',
        productclassification: 'Product Classification',
        airfree: 'Air Free',
        solidcolor: 'Solid Color',
        solidPatterns: 'Solid Pattern',
        stoneColor: 'Stone Color',
        metalColor: 'Metal Color',
        woodColor: 'Wood Color',
        metalPattern: 'Metal Pattern',
        woodPattern: 'Wood Pattern',
        stonePattern: 'Stone Pattern',
        pvc: 'PVC',
        petFurnitureFilm: 'PET',
        acrylicFurnitureFilm: 'Acrylic',
        woodSpecies: 'Wood Species',
        new: 'NEW',
        fireresistance: 'Fire Resistance',
        stonetype: 'Stone Type',
        textiletype: 'Textile Type',
        slabsize: 'Slab Size',
        category: 'Category',
        type: 'Type'
      },
      popup: {
        filter_by: 'FILTER BY',
        your_compare_is_full: 'Your compare is full',
        compare_tool: 'Compare tool',
        compare_alert1: 'Do you want to replace the first product',
        compare_alert2: 'you added by the one you selected?',
        edit_products_in_compare: 'EDIT PRODUCTS IN COMPARE',
        replace: 'REPLACE',
        close: 'close',
        characteristics_technical_performance: 'Characteristics & Technical Performance',
        pvc: 'PVC',
        acrylic: 'Acrylic',
        adhesive_type: 'Adhesive Type',
        adhesive_code: 'Adhesive Code',
        adhesive_name: 'Adhesive Name',
        air_free: 'Air Free',
        film_type: 'Film Type',
        material: 'Material',
        liner: 'Liner',
        width: 'Width',
        grade: 'Grade',
        length: 'Length',
        repeatImage: 'Repeat Image',
        fireResis: 'Fire Resistance',
        pet: 'PET',
        thickness: 'Thickness',
        thickness_mminch: 'Thickness (mm/inch)',
        thickness_cm: 'Thickness (cm)',
        dimension: 'Dimension',
        dimensions: 'Dimensions',
        dimensions_inch: 'Dimensions (inch)',
        dimensions_cm: 'Dimensions (cm)',
        dimension_mm: 'Dimension (mm)',
        weight_kg: 'Weight (kg)',
        slabsize_mminch: 'Slab Size (mm/inch)',
        slabsize_mm: 'Slab Size (mm)'
      },

      button: {
        all: 'All',
        lux: 'Luxury Vinyl Tile',
        hom: 'Homogeneous Sheet',
        het: 'Heterogeneous Sheet',
        spt: 'Specialty',
        compare: 'Compare',
        compare_your_colors: 'Compare your colors',
        remove: 'Remove',
        add_more: 'Add more',
        search: 'search',
        color: 'Color',
        collection: 'Collection',
        patterns: 'Patterns',
        finish: 'Finish',
        country: 'Country',
        new: 'New',
        coming: 'Coming soon',
        all_products: 'All products',
        grouped_by_collections: 'Grouped by collections',
        filter_by: 'Filter By',
        products_a_to_z: 'Products A to Z',
        products_z_to_a: 'Products Z to A',
        new_products_first: 'Most Recent',
        clear_all: 'Clear All',
        load_more: 'Load More',
        see_all_colors: 'See all colors',
        download: 'Download',
        Popularity: 'Popularity',
        lvt: 'Luxury Vinyl Tile',
        los: 'Looselay',
        spc: 'SPC Rigid Core',
        compare_on: 'ON',
        filter: 'Filter',
        most_recent: 'Most Recent',
        apply: 'Apply',
        all_filters: 'All Filters',
        reset: 'Reset',
        reset_all: 'Reset All',
      } // End of PF - button
    }, // End of PF

    other: {
      text: {
        sales_rep: 'Find a Sales Rep',
        showroom: 'Virtual Showroom',
        home: 'Home',
        products: 'Products',
        viatera: 'VIATERA',
        himacs: 'HIMACS',
        otherPD: 'Other Products',
        overall: 'Overall Dimensions',
        inner: 'Inner Dimensions',
        contactus: 'Contact Us',
        close: 'close',
        arctic: 'Arctic White',
        ivory: 'Ivory White',
        cream: 'Cream',
        almond: 'Almond',
        otheroverall: 'Overall Dimensions',
        otherinner: 'Inner Dimensions',
        all: 'All',
        kitchen: 'Kitchen',
        bathroom: 'Bathroom',
        ada: 'ADA Compliance',
        himacs_sink_banner_desc: 'Explore the complete line of HIMACS vanity and kitchen sinks designed for superior aesthetics and functionality.<br>' +
          'Every HIMACS solid surface sink is engineered to be seamlessly integrated with a HIMACS countertop,<br>' +
          'providing a beautifully smooth, clean, and well-designed surface.',
        viatera_sink_banner_desc: 'Discover the Lovello™ stainless steel sink collection, designed to perfectly complement VIATERA Quartz Countertops.<br>' +
          'These high-quality sinks offer unique styling to enhance any kitchen or vanity,<br>' +
          'providing the ideal finishing touch when paired with your VIATERA surface.'
      },
      button: {
        learn_more: 'Learn more',
        view_more: 'View more',
        load_more: 'Load more',
        certi_more: 'What These Certifications Mean'
      }
    }

  }, // End of GL

  CA: {
    PCD: {
      text: {
        home: 'Home',
        contact_us: 'Contact Us',
        products: 'Products',
        himacs: 'HIMACS',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        teracanto: 'TERACANTO',
        viateraquartzsurface: 'VIATERA',
        himacssolidsurface: 'HIMACS',
        teracantoporcelainsurface: 'TERACANTO',
        bortepanel: 'BORTE',
        home_film: 'Home Appliance Surface Film',
        automotive: 'Automotive',
        sub: {
          lvt: 'Luxury Vinyl Tile',
          los: 'Looselay',
          spc: 'SPC Rigid Core',
          homo: 'Homogeneous Sheet',
          het: 'Heterogeneous Sheet',
          spt: 'Specialty',
          veh: 'Vehicles and Transportation',
          sd: 'Signs and Displays',
          illum: 'Illuminated Sign',
          arch: 'Architecture',
          eco: 'Eco Solutions',
          corp: 'Corporate Branding',
          home_film: 'About Home Appliance Surface Film',
          automotive: {
            vegan_leather: 'Vegan Leather',
            light_comm: 'Lightweight Component',
            auto_comm: 'Automotive Component'
          }
        },
        vizuon_a: 'VIZUON',
        deco: 'Deco Film',
        exterior: 'Exterior Film',
        about: {
          himacs: 'About HIMACS',
          hflor: 'About HFLOR',
          viatera: 'About VIATERA',
          teracanto: 'About TERACANTO',
          borte: 'About BORTE',
          home_film: 'О поверхностной пленке для бытовой техники',
          automotive: {
            vegan_leather: 'Vegan Leather',
            light_comm: 'Lightweight Component',
            auto_comm: 'Automotive Component'
          }
        },
        featured_products: 'Featured Products',
        cart: 'cart',
        wish_list: 'wish list',
        new: 'New',
        coming: 'Coming soon',
        collection: 'Collection',
        explore_collection: 'Explore Collection',
        online_book: 'Online Book',
        load_more: 'Load More',
        certi_more: 'What These Certifications Mean',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        awards: 'Awards',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        order_a_sample: 'Order a Sample',
        documentation: 'Documentation',
        care_maintenance: 'Care & Maintenance',
        warranty: 'Warranty',
        where_to_buy: 'Where to buy',

        home_app_film: {
          title: 'Home Appliance Surface Film',
          title_description: 'Film laminated steel surface finishing material of home appliances, UBR and Elevator.',
          intro1: 'LX Hausys Home Appliance Surface Film is a high quality surface material with a variety of colors and patterns for refrigerators, washing machines and bathrooms.',
          intro2: 'Our superb products are already chosen by global appliance companies, because of its excellent anti-pollution, anti-scratch and anti-corrosion characteristics.',
          point_title1: 'Customizing Design Solution',
          point_description1: 'Based on Global Trend Research, development capabilities of customizing design solution for local customers has been recognized around the world, particularly in India, America, China, Southeast Asia and Europe.',
          point_title2: 'Global No.1',
          point_description2: 'LX Hausys’ Home Appliance Surface Film is running for the 1st M/S as a partner for Global major home appliance companies.',
          point_title3: 'Excellent Quality',
          point_description3: 'LX Hausys’ technology provides Anti Finger prints, Contamination Resistance, Anti Scratch and High Elongation for customers to use home appliances beautifully for a long time',
          construction: 'Construction',
          construction_film1: 'Metallic Film',
          film1_item1: 'Eco PET',
          film1_item1_desc: 'Printed Hairline on metal pearl with PET base',
          film1_item2: 'Metalon',
          film1_item2_desc: 'Metalizing gives real metal look on the film.',
          film1_item3: 'SUS Film',
          film1_item3_desc: 'Embossed Hairline technology allows customized pattern including horizontal hairline which enables the exact same look of STS.',
          construction_film2: 'Pearl & Patterned Film',
          film2_item1: 'Hi-Gloss',
          film2_item1_desc: 'Excellent printing technology can offer customized patterns.',
          film2_item2: 'Galaxy',
          film2_item2_desc: 'Various pearl effects will allow fine and glittery surface.',
          film2_item3: 'Soft-matte',
          film2_item3_desc: 'Soft-matte Textures with various color or customized patterns',
          application: 'Application',
          application_sub_title: 'Home Appliance Surface Film',
          application_item1: 'Pastel Metal',
          application_item2: 'Soft Matte',
          application_item3: 'Horizontal Hairline (Silver, Short)',
          application_item4: 'Horizontal Hairline (Black)',
          application_item5: 'Iridium Hairline',
          application_item6: 'Horizontal Hairline (Dark-grey)',
          application_item7: 'Glass Fiber',
          application_item8: 'Horizontal Hairline (Silver, Long)'
        },

        SOLID_SURFACE: 'SOLID SURFACE',
        KV_brief: 'The New Generation of Design Inspiration',
        brief: 'HIMACS is composed of minerals, acrylic and natural pigments that come together to provide a durable, smooth, non-porous and visually seamless surface which meets the highest standards for quality, aesthetics, fabrication, functionality and hygiene - offering manifold advantages over conventional materials. HIMACS is durable, it can be shaped by a thermoforming process, and thanks to its huge colour spectrum and translucent properties can help to achieve outstanding and colourful designs. HIMACS uses a simple heating process to give three-dimensional thermoforming capabilities, allows visually seamless designs, offers a virtually limitless range of colours and - for some shades - exhibits a special translucency when exposed to light. Although HIMACS is almost as robust as stone, it can be worked in a similar way as wood: it can be sawn, routed, drilled or sanded. HIMACS is available in sheets of different dimensions and thicknesses. The collection is completed with our range of kitchen sinks, basins, baths and shower trays.',
        photo_credit: 'Photo Credits: Design Marc Fidelle and Andrei David - Paris Airport Engineering and Architectural Management, fabrication : LCCA, photo : Mathieu Ducros',

        Aurora_collection_title: 'AURORA & MARMO',
        Aurora_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        ASTER_collection_title: 'ASTER',
        ASTER_collection_brief: 'Aster is a collection of elegant shades of grey, ranging from almost white to a warm beige, all with a gorgeous mother of pearl shimmer.',

        CONCRETE_collection_title: 'CONCRETE',
        CONCRETE_collection_brief: 'The indusrial look of concrete combined with the incredible flexibility of HI-MACS. The Concrete Collection adds huge opportunities for great designs to architects and designers',

        EXTERIA_collection_title: 'EXTERIA',

        GRANITE_collection_title: 'GRANITE, SPARKLE, QUARTZ, SAND & PEARL',
        GRANITE_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        LUCIA_collection_title: 'LUCIA',
        LUCIA_collection_brief: 'This collection focuses on the natural trend colours black, white and grey. The lively and homogeneous structures add character and expression to the colours. Not surprising, as the renowned Dutch designer, Marcel Wanders, designed three of these colours. (W001, W003, W004)',

        LUCENT_collection_title: 'LUCENT',
        LUCENT_collection_brief: 'The shades of the Lucent Collection, with their exceptional light translucency, allow for spectacular designs. Whether effectively backlit or simply illuminated, the Lucent colours of the architecture always add an elegant touch thanks to their characteristic reaction to light.',

        SOLIDS_collection_title: 'SOLIDS',
        SOLIDS_collection_brief: 'The classic in terms of solid surfaces &ndash; a wide range of attractive shades of white lies at the heart of this collection. Complemented by colourful, dynamic uni-shade accents from Lemon Squash to Festival Pink. The timeless collection offers the perfect colour for every design.',

        STRATO_collection_title: 'STRATO',
        STRATO_collection_brief: 'The marked linear patterns of Strato collection creates geometry through its soft structure and subtle look. The skilful use of the new linear pattern, vertically or horizontally, allows for great variation in each and every project.',

        TERRAZZO_collection_title: 'TERRAZZO',
        TERRAZZO_collection_brief: 'Using a vibrant concrete-base as the canvas for each design, the Terrazzo Collection from HI-MACS offers a vibration of color and patterns that speak to your past, present, and future self in anesthetic. Textured shades, artistic designs, and a touch of modern class, this collection creates a one of a kind experience.',

        ULTRA_collection_title: 'ULTRA',
        ULTRA_collection_brief: 'HIMACS Intense Ultra is based on a brand-new material formulation and combines Intense Colour technology with Ultra-thermoforming. Dark colours become more “intense”, darker and also more resistant, with less visible scratches. The new HIMACS Intense Ultra, also has excellent thermoforming capabilities.',

        VOLCANICS_collection_title: 'VOLCANICS',
        VOLCANICS_collection_brief: 'The large particles of the Volcanics shades add a sense of style to any design. When used on a large scale the result is a dramatic showpiece.',

        Sustainability: 'Sustainability',

        /* US feature benefits TAB */

        TAB_Quality_Design_title: 'Quality Design',
        TAB_Quality_Performance_title: 'Quality Performance',
        TAB_Quality_Fabrication_title: 'Quality Fabrication',
        TAB_Quality_Sustainability_title: 'Quality Sustainability',

        /* END US feature benefits TAB */

        /* US feature benefits - Quality Design - TAB */

        Design_title1: 'Wide Range of Shapes',
        Design_brief1: 'Every option is available to designers to create neat washrooms, kitchens, hospitals and much more with our wide range of HIMACS sinks and bowls. Perfectly coordinated and ideal for mixing and matching, the bowls and sinks guarantee a modern look that is easy ad simple to look after.',

        Design_title2: 'Dramatic Translucency',
        Design_brief2: 'Certain colours and thicknesses of HIMACS exhibit a special translucency when exposed to light.',
        Design_brief2_1: 'Various textures and patterns can be built into the material to intensify the HIMACS translucency effect.',

        Design_title3: '3-Dimensional Design',
        Design_brief3: 'HIMACS boasts a simple heating process and three-dimensional thermoplastic forming capabilities.',
        Design_brief3_1: 'This allows for greater forming flexibility compared with other conventional materials so that spectacular ideas can quickly take on a concrete shape.',

        Design_title4: 'Unlimited Spectrum of Colours',
        Design_brief4: 'HIMACS offers a virtually limitless range of colours in all conceivable shades.',
        Design_brief4_1: 'More are being added every year no matter what colour you choose, HIMACS remains 100% homogeneous.',

        /* END US feature benefits - Quality Design - TAB */

        /* US feature benefits - Quality Performance - TAB */

        Performance_title1: 'Strong',
        Performance_brief1: 'Stronger surface with durability similar to that of natural stone - HIMACS stands up to everyday scratches. Should you accidentally inflict a deeper scratch or surface impression, a trained professional can easily resurface your HIMACS thanks to its sealant-free consistency.',

        Performance_title2: 'Fire Resistant',
        Performance_brief2: 'Backed up with numerous certificates that attest of its fire resistance,',
        Performance_brief2_1: 'HIMACS is ideal for places where security is the number 1 criteria of choice.',

        Performance_title3: 'Hygienic',
        Performance_brief3: 'Thanks to its impermeability to dirt, bacteria, viruses and countless chemicals, HIMACS is the ideal material for the hospital,',
        Performance_brief3_1: 'medical practice or laboratory. And for all other areas where hygiene really counts.',

        Performance_title4: 'Water Resistant',
        Performance_brief4: 'Thanks to its non-porous surface HIMACS is suitable for humid areas where moisture can form such as wet rooms',
        Performance_brief4_1: 'and bathrooms.',

        /* END US feature benefits - Quality Performance - TAB */

        /* US feature benefits - Quality Fabrication - TAB */

        Fabrication_title1: 'Most Advanced Fabrication Technology',
        Fabrication_brief1: 'The material is heated in a progressive tempering process (Thermal Cure). which sets HIMACS apart from other mineral materials and produces a new and stronger compound in which any structural defects are perfectly evened out. This improved structure automatically affects the quality of the material.',

        Fabrication_title2: 'Simple Processing',
        Fabrication_brief2: 'Although HIMACS is almost as robust as stone, it can be worked in the same way as wood. ',
        Fabrication_brief2_1: 'Using conventional carpenter\'s tools, this solid surface material can be sawn, routed or drilled.',

        Fabrication_title3: 'Seamless Perfection',
        Fabrication_brief3: 'HIMACS allows for visually seamless manipulation.',
        Fabrication_brief3_1: 'Smooth integration enables large areas without joints or edges as well as flush mounting of sinks or bowls.',

        /* END US feature benefits - Quality Fabrication - TAB */

        /* US feature benefits - Quality Sustainability - TAB */

        Sustainability_title1: 'Renewable',
        Sustainability_brief1: 'With easy-to-care and repairable properties, no matter if it\'s a scratch, stain or crack,',
        Sustainability_brief1_1: 'HIMACS can be restored to its original state by a certified professional.',

        Sustainability_title2: 'Sustailable',
        Sustainability_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        /* END US feature benefits - Quality Sustainability - TAB */

        /* US certifications TAB */

        TAB_Environment_title: 'Environment',
        TAB_Fire_Rating_title: 'Fire Rating',
        TAB_HIMACS_Exteria_title: 'HIMACS Exteria Certificates',
        TAB_Hygiene_title: 'Hygiene',
        TAB_Process_title: 'Process',

        /* END US certifications TAB */

        /* US certifications - Environment - TAB */

        Environment_title1: 'Ministry of Environment of the Republic of Korea',
        Environment_brief1: 'designates HIMACS as environmentally-friendly thanks to the demonstration of its commitment to ecological awareness in its product management activities.',

        Environment_title2: 'M1 Emissions Classification',
        Environment_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        Environment_title3: 'Leadership in Energy and Environnemental Design (LEED)',
        Environment_brief3: 'Is a standard voluntary system to certify high performance of buildings, from the US Green Building Council (USGBC). LEED certifies buildings using a credit system. The use of HIMACS contributes toward satisfying EQ Credit for Low-Emitting Materials with the category Indoor Environmental Quality (EQ).',

        Environment_title4: 'ISO 14001',
        Environment_brief4: 'The ISO 14000 family concerns the management of environmental quality. The most popular certificate in this group is ISO 14001. It encourages the minimisation of damage caused by our own activity to the environment and the continuous improvement of environmental performance. The objective is to contribute to protecting and stabilising our planet’s environment. This test certifies that the environment management system of HIMACS conforms to ISO 14001 standards.',

        Environment_title5: 'Greenguard',
        Environment_brief5: 'HI-MACS has been approved by Greenguard in the USA, as a “low emitting product”. The organisation establishes acceptable indoor air standards for indoor products, environments and buildings. The organisation’s goal is to improve public health and quality of life through programs that improve indoor air.',

        Environment_title6: 'Environmental Building Certificate – Grade "outstanding"',
        Environment_brief6: 'The Korean Air Cleaning Association certifies that HIMACS complies with the Korean regulations for environmental building materials.',

        Environment_title7: 'DGNB',
        Environment_brief7: 'The DGNB system, founded by the "German Sustainable Building Council”, evaluates buildings holistically on the basis of individual criteria within the categories Ecological Quality, Economic Quality, Sociocultural and Functional Quality, Technical Quality, Process Quality and Location Quality. Different profiles allow the certification of new buildings and existing buildings, as well as of quarters in Germany and Internationally. Buildings can achieve a certification in Bronze, Silver, Gold and Platinum. HIMACS has an Environmental Product Declaration (EPD), which can be used to calculate the building life cycle assessment (ENV1.1/2.1). Furthermore, HIMACS has achieved Quality Level 4 of 4 in DGNB 2018 criteria for local environmental impact for the entire product.',

        Environment_title8: 'BREEAM (Building Research Establishment Environmental Assessment Method)',
        Environment_brief8: 'BREEAM is the world’s leading sustainability assessment method for masterplanning rojects, infrastructure and buildings. It recognises and reflects the value in higher performing assets across the built environment lifecycle, from new construction to in-use and refurbishment. HIMACS can contribute to BREEAM International New Construction 2016 certification, as the entire product complies with Hea 02 Indoor air quality. Furthermore, HIMACS achieved RSCS summary score level in Mat 03, responsible sourcing of construction products for the entire product: RSCS level 1. “BREEAM is a registered trade mark of the Building Research Establishment Limited, a wholly owned subsidiary of BRE Group Limited, and is used by permission. LX Hausys and its products are not affiliated, endorsed or certified by BRE Global Limited, which is the operator of BREEAM, or any other subsidiary of BRE Group Limited. All rights are reserved.”',

        /* END US certifications - Environment - TAB */

        /* US certifications - Fire Rating - TAB */

        Fire_Rating_title1: 'Norm NFP 92-501 Class M1',
        Fire_Rating_brief1: 'LNE tests the reactivity to fire of a material. Class M1 certifies that HIMACS FR benefits from advanced resistance to fire. This certificate is recommended in France.',

        Fire_Rating_title2: 'Norm EN 45 545 Class R1 HZL3',
        Fire_Rating_brief2: 'Fire protection on railway vehicles: The measures and requirements specified in EN 45 545 are intended to protect passengers and staff in railway vehicles in the event of a fire on board. HIMACS has achieved the highest and best performance R1 HZL3 (Hazard Level). Valid for Alpine White S728.',

        Fire_Rating_title3: 'Norm EN 13501 - Class B-s1, d0',
        Fire_Rating_brief3: 'HIMACS successfully passed the European test EN 13501 – Class B-s1, d0, equivalent to the class 0 from Warrington Fire certification.',

        Fire_Rating_title4: 'Norm DIN 4102-1 - Class B1',
        Fire_Rating_brief4: 'Class B1 certifies that HIMACS has a low flammability. B1 class is the European fire resistance requirement. This test result is valid for all colour ranges in 12mm.',

        /* END US certifications - Fire Rating - TAB */

        /* US certifications - Exteria Certificates - TAB */

        Exteria_title1: 'IMO MED – Modules B and D',
        Exteria_brief1: 'MED stands for Marine Equipment Directive. Both modules are extremely important for the shipbuilding industry, as they are mandatory for fabrication materials used in ships. IMO B covers the fire resistance of the material per se and certifies that the material has low flame spread characteristics and is not capable of producing excessive quantities of smoke and toxic combustion products. Module D covers the overall production capacity and checks, among other production processes, the management and systems used.',

        Exteria_title2: 'ETA',
        Exteria_brief2: 'Fixed with Keil inserts and a BWM structure, HIMACS facade in S728 - Alpine White successfully passed the ETA tests (European Technical Agreement).',

        Exteria_title3: 'CSTB Certification',
        Exteria_brief3: 'HIMACS has obtained the French QB certification and CSTB ATec “Avis Technique” for facade applications (Avis Technique 2.2/18-1795_V1).',

        /* END US certifications - Exteria Certificates - TAB */

        /* US certifications - Hygiene - TAB */

        Hygiene_title1: 'NSF',
        Hygiene_brief1: 'NSF standards are generally accepted norms for a variety of public health related industries and fields. These include drinking water treatment and contact with materials, food equipment manufacturing etc. NSF recognises that HIMACS complies with NSF norms.',

        Hygiene_title2: 'LGA',
        Hygiene_brief2: 'Necessary in hospitals and environments where hygiene is critical, LGA assesses the ease of cleaning, resistance to bacteria and fungi and rates the design from a hygiene point of view. Thanks to its non-porosity, HIMACS has been approved for the LGA seal “hygiene tested”.',

        /* END US certifications - Hygiene - TAB */

        /* US certifications - Process - TAB */

        Process_title1: 'OHSAS 18001',
        Process_brief1: 'OHSAS 18001, Occupational Health and Safety Assessment Series, (officially BS OHSAS 18001) is a British Standard for occupational health and safety management systems. Compliance with it enables organizations to demonstrate that they have a system in place for occupational health and safety.',

        Process_title2: 'ISO 9001',
        Process_brief2: 'ISO 9001 criteria can guarantee the following points:',
        Process_brief3: 'The whole fabrication process, ensuring a good product quality',
        Process_brief4: 'Quality control, with an appropriate corrective procedure, when needed and regular control of quality control procedures.',
        Process_brief5: 'Process, which aims to continuously improve global efficiency',

        /* END US certifications - Process - TAB */

        /* US sustainbility - TAB */

        sustainbility_title1: 'Shaping the Future in Harmony with the Environment',
        sustainbility_brief1: 'Countless internationally recognized certificates attest to the fact that HIMACS has a strong focus on ecological aspects. Without exception, all HIMACS products are manufactured in accordance with the ISO 14001 environmental standard.',

        TAB_Commitment_title: 'Commitment',
        TAB_Material_Safety_title: 'Material Safety',
        TAB_Manufacturing_title: 'Manufacturing',
        TAB_Processing_title: 'Processing',
        TAB_Transport_title: 'Transport',

        /* END US sustainbility - TAB */

        /* US sustainbility - Commitment - TAB */

        Commitment_title1: 'Commitment',
        Commitment_brief1: 'LX Hausys conducts and publishes regular environmental audits along with energy consumption analyses. Thanks to the use of non-polluting fuels, greenhouse gas emissions have been cut by 15,000 tons per year since 2008.',

        /* END US sustainbility - Commitment - TAB */

        /* US sustainbility - Material Safety - TAB */

        Material_Safety_title1: 'Material Safety',
        Material_Safety_brief1: 'Extensive studies – within LX Hausys’ own laboratories as well as tests carried out by other renowned independent institutions – have shown that the HIMACS material itself, as well as the cured adhesive, are completely free from formaldehyde and emissions. HIMACS has been awarded the Greenguard Gold Indoor Air Quality Certificate.',

        /* END US sustainbility - Material Safety - TAB */

        /* US sustainbility - Manufacturing - TAB */

        Manufacturing_title1: 'Manufacturing',
        Manufacturing_brief1: 'The production of this solid surface material is marked by an excellent energy balance. In recent years, the company was very successful in achieving ambitious goals in terms of waste reduction and water conservation. In addition, HIMACS plants in Cheongju (Korea) and Atlanta (USA) meet all environmental standards.',

        /* END US sustainbility - Manufacturing - TAB */

        /* US sustainbility - Processing - TAB */

        Processing_title1: 'Processing',
        Processing_brief1: 'The material allows for virtually waste-free processing. In addition, HIMACS installations are extremely strong and durable. They can easily be renewed to their original appearance, meaning they don’t have to be replaced, thus giving a positive long-term  environmental footprint.',

        /* END US sustainbility - Processing - TAB */

        /* US sustainbility - Transport - TAB */

        Transport_title1: 'Transport',
        Transport_brief1: 'Within Europe, HIMACS observes the Euro-5 standards for reduced particulate emissions. The partner-network of LX Hausys Europe consists of carefully selected partners with the highest environmental standards: for example, the State-of-the-Art logistics centre in the Netherlands is one of the first buildings to have been constructed in accordance with the WELL Building Standards and awarded the BREEAM Certificate. This means that it meets the highest requirements for environmentally friendly and healthy construction. '

        /* END US sustainbility - Transport - TAB */

      }, // End of PCD - text

      alert: {
        loginLike: 'Log in to save to your Likes'
      }, // End of PCD - alert

      button: {
        seeMore: 'See More',
        see_all: 'See all Designs',
        learnMore: 'Learn more',
        explore_collection: 'Explore Collection',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        close: 'close',
        find_a_sales_rep: 'Find a Sales Rep',
        btn_sustainbility_brochure: 'Download Sustainability Brochure',

        English: 'English',
        German: 'German',
        French: 'French',
        Italian: 'Italian',
        Spanish: 'Spanish',
        Dutch: 'Dutch',
        EnglishUK: 'English (UK)'

      }, // End of PCD - button

      popup: {
        /* Edge Profiles 시작 점 */
        edge_title: 'Viatera Edge Profile',
        edge_brief: 'Where quartz meets the edge. LX Hausys Surfaces offers a wide selection of edge treatments.' +
          '                    Select from a simple rounded corner to the complex multi-toned,' +
          '                    multi-tiered rolling edges that add that special finishing touch to your solid surface counter.' +
          '                    For more information on our edge treatments, please consult your local area distributor or' +
          '                    fabricator.',

        beveled_Edge: 'Beveled Edge',
        beveled_Edge_brief: 'Maintains the surface’s thickness,\n' +
          '                    but with a ¼” or ½” angular top edge.',
        bullnose_Edge: 'Bullnose Edge',
        bullnose_Edge_brief: 'A completed rounded edge.',

        eased_Edge: 'Eased Edge',
        eased_Edge_brief: 'A slightly rounded top edge that still\n' +
          "                    maintains the surface's thickness.",

        ellipse_Edge: 'Ellipse Edge',
        ellipse_Edge_brief: 'Rounded top and bottom edges\n' +
          '                    with a flat face.',

        knife_Edge: 'Knife Edge',
        knife_Edge_brief: 'A sharp, blade-like edge.',

        reverse_Ogee_Edge: 'Reverse Ogee Edge',
        reverse_Ogee_Edge_brief: 'Similar to Roman Edge, but reversed.',

        roman_Edge: 'Roman Edge',
        roman_Edge_brief: 'An elaborate ogee-style edge design\n' +
          '                    inspired by Roman architecture.',

        roundover_Edge: 'Roundover Edge',
        roundover_Edge_brief: 'A semi-circle rounded top edge.',

        /* Edge Profiles 끝 */

        /* Finish 시작 점 */
        finishInfo: 'Finish guide',
        finishTitle: 'Introducing New Viatera Finish Brushed',
        finishBrief: 'Select Viatera colors are now available with a “Brushed” finish to fulfill a wider range of aesthetics.\n' +
          '                  Enjoy the new classic beauty with a satin-like finish.',
        polished: 'POLISHED',
        polished_brief: 'Traditional reflective surface',

        brushed: 'BRUSHED',
        brushed_brief: 'Soft and smooth feel with\n' +
          '                    low-luster on the surface',

        leather: 'Leather',
        leather_brief: 'Leather finish has a slightly more matte texture than a polished finish, and makes you feel the soft touch of the leather.',

        velvet_Touch: 'Velvet Touch',
        velvet_Touch_brief: 'Velvet touch finish enables you to feel the texture of nature with the feeling of stone dents.',

        finish_viatera: 'Viatera',
        finish_viatera_info: 'Brushed Finish Care & Maintenance',
        finish_viatera_brief: 'Viatera products with Brushed Finish are the same as those with the standard Polished Finish.\n' +
          '                  The only manufacturing difference is how the final gloss level is achieved.',

        finish_viatera_brief_01: 'Brushed Finish may need more daily attention than Polished Finish. This is the nature of any material with a matte finish when compared to the same material\n' +
          '                  with a polished finish – smudges, fingerprints, and water spots are simply more visible on a matte surface. Promptly wipe up and buff dry routine spills, droplets,\n' +
          '                  and rings. A microfiber towel may be more effective than a paper towel because Brushed Finish has a slight surface texture when compared to Polished Finish.\n' +
          '                  These non-woven cleaning products work well on all surfaces and are especially helpful on products that feature anything other than a perfectly smooth surface.',

        finish_viatera_brief_02: 'Routine Care and Maintenance of Brushed Finish is easy with the same liquid household cleaners that are suitable for “Polished” finishes, including Formula 409\n' +
          '                  Natural Stone & Steel Cleaner.',

        finish_viatera_brief_03: 'Always read and follow that manufacturer’s label instructions. A textured sponge that’s suitable for non-stick coated cookware may be helpful in removing some\n' +
          '                  tougher spills. Avoid using abrasive cleaners like Ajax or Comet, as these more aggressive materials may dull or damage the surface of Brushed Finish.\n' +
          '                  After using any cleaning product always rinse the area and buff the area dry. A microfiber product is suggested but not required.'

        /* Finish 끝 */

      } // End of PCD - popup
    }, // End of PCD

    PD: {
      text: {
        new: 'NEW',
        coming: 'Coming soon',
        discontinued_Color: 'Discontinued Color',
        image_enlarged_view: 'IMAGE ENLARGED VIEW',
        image_download_view: 'IMAGE DOWNLOAD VIEW',
        finish: 'Finish',
        finishGuide: 'Finish guide',
        color: 'Color',
        product_Specs: 'Product Specs',
        product_type: 'Product Type',
        total_thickness: 'Total Thickness',
        wear_layer: 'Wear Layer',
        dimension: 'Dimensions',
        dimension1: 'Dimension &',
        weight: 'Weight',
        remark: 'Remark',
        pattern: 'Pattern',
        emboss: 'Emboss',
        installation: 'Installation',
        adhesive_code: 'Adhesive Code',
        adhesive_name: 'Adhesive Name',
        available_Countries: 'Available Countries',
        related_Products: 'Related Products',
        features_Benefits: 'Features & Benefits',
        certifications: 'Certifications',
        documentation_technical_details: 'DOCUMENTATION & TECHNICAL DETAILS',
        fabrication: 'Fabrication',
        test_report: 'Test Report',
        care_maintenance: 'Care & Maintenance',
        catalogue: 'Catalog',
        certification: 'Certification',
        technical_datasheet: 'Technical Datasheet',
        installation_guide: 'Installation Guide',
        warranty: 'Warranty',
        edge_profile: 'Edge Profile',
        inspiration: 'Inspiration',
        standard: 'Standard',
        image_viewer: 'For illustration purposes only. Image size:',
        in: 'in',
        zoom_out: 'zoom Out',
        zoom_in: 'zoom In',
        Thickness: 'Thickness',
        Use: 'Use',
        Pattern: 'Pattern',
        Notice: 'Notice',
        Notice_brief: 'Less suitable for surfaces which are subject to high traffic, due to their higher pigmented colour saturation, marks may be seen more easily.',
        Semi_Translucent: 'Semi-Translucent colour',
        Semi_Translucent_brief: 'Colours with this mark have a semi-translucent effect, evident when combined with light sources',
        Outdoor: 'Outdoor',
        Outdoor_brief: 'Suitable for exterior use. Please check conditions about level of suitability and warranty per colour. Indoor, Suitable for Kitchen & Bathroom',
        Recycled: 'Recycled',
        Recycled_brief: 'Certified to contain pre-consumer recycled content. Minimum',
        Designer: 'Designer Series',
        Designer_brief: 'Designed by Marcel Wanders',
        Lucent: 'Lucent',
        Lucent_brief: 'Lucent colours have a higher level of translucency, more evident when combined with light source. Translucent colour',
        Veined: 'Veined',
        Veined_brief: 'As Marmo is a randomly veined product, specific fabrication guidelines need to be followed.',
        prd_specs: 'PRODUCT SPECS',
        news_letter: 'Sign up for our Newsletter',
        news_letter_desc: 'Discover innovative projects, unique colors  and the latest news and trends',
        subscribe: 'Subscribe',
      }, // End of PD - text

      button: {
        virtual_Showroom: 'Virtual Showroom',
        prev: 'Prev',
        next: 'Next',
        list_view: 'list view',
        download: 'download',
        see_all_documentation: 'See All Documentation',
        see_all_case_studies: 'See All Case Studies',
        see_more: 'See More'

      } // End of PD - button

    }, // End of PD

    PF: {
      text: {
        category: 'CATEGORY',
        luxury_vinyl_tile: 'Luxury Vinyl Tile',
        looselay: 'Looselay',
        homogeneous_sheet: 'Homogeneous Sheet',
        heterogeneous_sheet: 'Heterogeneous Sheet',
        specialty: 'Specialty',
        home: 'Home',
        filter_by: 'Filter By',
        patterns: 'Patterns',
        country: 'Country',
        new: 'New',
        new_a: 'NEW',
        isNeoQ: 'NEOQ™ (Less Than 1% Crystalline Silica)',
        coming: 'Coming soon',
        new_colors: 'NEW COLORS',
        product_type: 'Product Type',
        thickness: 'Thickness (inch)',
        thicknesscm: 'Thickness (cm)',
        weight: 'Weight (lbs)',
        finish: 'Finish',
        wear_layer: 'Wear Layer',
        dimension: 'Dimensions (inch)',
        dimensions: 'Dimensions',
        searchText: 'Enter Item Number or Name',
        Tones: 'Tones',
        Use: 'Use',
        Recycled: 'Recycled',
        Thickness: 'Thickness',
        himacs: 'HIMACS',
        borte: 'BORTE',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        exteriorfilm: 'EXTERIOR Film',
        decofilm: 'DECO Film',
        teracanto: 'TERACANTO',
        benif: 'BENIF',
        vizuon_a: 'VIZUON',
        lvt: 'Luxury Vinyl Tile',
        los: 'Looselay',
        spc: 'SPC Rigid Core',
        hom: 'Homogeneous Sheet',
        het: 'Heterogeneous Sheet',
        spt: 'Specialty',
        installation: 'Installation',
        results: 'Results',
        no_search_result: 'No Result Found',
        no_compare_item: 'No items to compare',
        no_option: 'Please select option',
        color: 'Color',
        filters: 'Filters',
        compare: {
          viatera: 'COMPARE VIATERA PRODUCTS',
          hflor: 'COMPARE HFLOR PRODUCTS',
          teracanto: 'COMPARE TERACANTO PRODUCTS',
          himacs: 'COMPARE HIMACS PRODUCTS'
        },
        compare_full: {
          text: 'Do you want to replace the first Products <br>' +
            'you added by the one you selected?',
          footer: 'Edit products in compare'
        },
        slab_size: 'Slab Size(inch)',
        bookmatch: 'Bookmatch',
        remark: 'Remark',
        key_visual_desc: {
          all_colors: 'Discover the ideal color and design option for your upcoming projects, from quartz countertops to solid surfaces, porcelain, panels, and resilient <br>' +
            'flooring. <br>' +
            'LX Hausys provides a broad spectrum of colors, finishes, and aesthetic choices across its entire portfolio of surfacing and flooring materials.',

          all_samples: 'Find the perfect samples for your next project, whether you need quartz countertops, solid surfaces, porcelain surfaces, or resilient flooring. <br>' +
            'LX Hausys offers a diverse array of samples across its entire surfacing and flooring portfolio.',

          hflor_color: 'Explore the vast world of design possibilities with HFLOR resilient flooring. <br>' +
            'Our diverse palette of colors and patterns extends across all our resilient flooring materials, including luxury vinyl tile and vinyl sheet flooring',

          hflor_sample: 'Find the perfect resilient flooring samples for your next demanding project. <br>' +
            'HFLOR offers a diverse array of samples to help you select from its innovative and high-performance LVT collections.',

          viatera_color: 'Raise the style quotient of every space with the beautiful range of quartz worktops from VIATERA. <br>' +
            'Explore our vast selection to find the ideal quartz countertop solution that blends exceptional performance with timeless design.',

          viatera_sample: 'Find the perfect quartz countertop samples for your next design project. <br>' +
            'VIATERA offers a diverse array of samples across its beautiful and highly durable quartz collection.',

          himacs_color: 'With HIMACS, rethink the limitations of design and push the boundaries of what’s possible. <br>' +
            'Discover the limitless palette of colors and designs that make HIMACS the ideal solid surface for both commercial and residential applications.',

          himacs_sample: 'Find the perfect solid surface samples for your next creative project. <br>' +
            'HIMACS offers a diverse array of samples to help you explore its flexible and seamless solid surface collection.',

          teracanto_color: 'Let the bold and exquisite designs of TERACANTO worktops transform your space into a memorable experience. <br>' +
            'Discover the extensive range of colors and patterns that establish TERACANTO porcelain surface as a true masterpiece of nature and superior <br>' +
            'engineering.',

          teracanto_sample: 'Find the perfect porcelain surface samples for your next sophisticated design. <br>' +
            'TERACANTO offers a diverse array of samples across its durable, large-format porcelain collection.',

          benif_color: 'Unlock exceptional design versatility with BENIF architectural film. <br>' +
            'Explore our extensive selection of colors and patterns to easily transform walls, ceilings, and furniture, using the specialized self-adhesive backing <br>' +
            'for quick and easy application.',

          borte_color: 'Your Doorway to Sustainable Home Innovation',

          default_desc: '',
        },
        allColors: {
          himacs: 'HIMACS Colors',
          hflor: 'HFLOR Colors',
          viatera: 'VIATERA Colors',
          teracanto: 'TERACANTO Colors',
          borte: 'BORTE Colors',
          himacs_ac: 'HIMACS',
          hflor_ac: 'HFLOR',
          viatera_ac: 'VIATERA',
          exteriorfilm_ac: 'EXTERIOR Film',
          decofilm_ac: 'DECO Film',
          borte_ac: 'BORTE',
          teracanto_ac: 'TERACANTO',
          benif_ac: 'BENIF',
          vizuon_ac: 'VIZUON',
          products: 'Products',
          all_colors: 'All Colors',
          filter: 'Filter',
          filter_by: 'Filter By',
          brand: 'Brand',
          color: 'Color',
          searchText: 'Enter Item Number or Name',
          results: 'Results',
          no_result: 'No Result found',
          no_result_text: 'If you do not find what you are looking for, please try different search terms or filters.',
          apply: 'Apply',
          clear_all: 'Clear All',
          clear_all2: 'clear all',
          products_a_to_z: 'Products A to Z',
          products_z_to_a: 'Products Z to A',
          new_products_first: 'Most Recent',
          your_compare_is_full: 'Your compare is full',
          new: 'New',
          new_a: 'NEW',
          brandLabel: 'BRAND',
          colorLabel: 'COLOR',
          white: 'White',
          cream: 'Cream',
          beige: 'Beige',
          brown: 'Brown',
          gray: 'Gray',
          black: 'Black',
          green: 'Green',
          blue: 'Blue',
          pink: 'Pink',
          purple: 'Purple',
          ivory: 'Ivory',
          orange: 'Orange',
          red: 'Red',
        }
      }, // End of PF - text
      filter: {
        filter_by: 'Filter By',
        vizuon: 'VIZUON',
        vt: 'Vehicles and Transportation',
        sd: 'Signs and Displays',
        is: 'Illuminated Sign',
        ar: 'Architecture',
        es: 'Eco Solution',
        cb: 'Corporate Branding',
        feature: 'Feature',
        country: 'COUNTRY',
        compare: 'COMPARE',
        bookmatch: 'Bookmatch',
        application: 'APPLICATION',
        weatherability: 'WEATHERABILITY',
        remark: 'Remark',
        hflor: 'HFLOR',
        pet: 'PET',
        installation: 'Installation',
        productType: 'Product Type',
        filter: 'Filter',
        slabsize: 'Slab Size',
        color: 'Color',
        collection: 'Collection',
        patterns: 'Pattern',
        finish: 'Finish',
        recycled: 'Recycled',
        thickness: 'Thickness',
        format: 'Format',
        wearlayer: 'Wear Layer',
        dimensions: 'Dimension (inch)',
        prdtype: 'Installation', // installation
        adhesivetype: 'Adhesive Type',
        productclassification: 'Product Classification',
        airfree: 'Air Free',
        solidcolor: 'Solid Color',
        solidPatterns: 'Solid Pattern',
        stoneColor: 'Stone Color',
        metalColor: 'Metal Color',
        woodColor: 'Wood Color',
        metalPattern: 'Metal Pattern',
        woodPattern: 'Wood Pattern',
        stonePattern: 'Stone Pattern',
        pvc: 'PVC',
        petFurnitureFilm: 'PET',
        acrylicFurnitureFilm: 'Acrylic',
        woodSpecies: 'Wood Species',
        new: 'NEW',
        isNeoQ: 'Remark',
        category: 'Category',
        type: 'Type'
      },
      popup: {
        filter_by: 'FILTER',
        your_compare_is_full: 'Your compare is full',
        compare_tool: 'Compare tool',
        compare_alert1: 'Do you want to replace the first product',
        compare_alert2: 'you added by the one you selected?',
        edit_products_in_compare: 'EDIT PRODUCTS IN COMPARE',
        replace: 'REPLACE',
        close: 'close',
        characteristics_technical_performance: 'Characteristics & Technical Performance',
        pvc: 'PVC',
        acrylic: 'Acrylic',
        adhesive_type: 'Adhesive Type',
        adhesive_code: 'Adhesive Code',
        adhesive_name: 'Adhesive Name',
        air_free: 'Air Free',
        film_type: 'Film Type',
        material: 'Material',
        liner: 'Liner',
        width: 'Width',
        grade: 'Grade',
        length: 'Length',
        pet: 'PET',
        thickness: 'Thickness',
        thickness_cm: 'Thickness (cm)',
        dimension_inch: 'Dimension (inch)'
      },
      button: {
        all: 'All',
        hom: 'Homogeneous Sheet',
        het: 'Heterogeneous Sheet',
        spt: 'Specialty',
        compare: 'Compare',
        compare_your_colors: 'Compare your colors',
        remove: 'Remove',
        add_more: 'Add more',
        search: 'search',
        color: 'Color',
        collection: 'Collection',
        patterns: 'Patterns',
        finish: 'Finish',
        country: 'Country',
        new: 'New',
        coming: 'Coming soon',
        all_products: 'All products',
        grouped_by_collections: 'Grouped by collections',
        filter_by: 'Filter By',
        products_a_to_z: 'Products A to Z',
        products_z_to_a: 'Products Z to A',
        new_products_first: 'Most Recent',
        clear_all: 'Clear All',
        load_more: 'Load More',
        see_all_colors: 'See all colors',
        download: 'Download',
        Popularity: 'Popularity',
        lvt: 'Luxury Vinyl Tile',
        los: 'Looselay',
        spc: 'SPC Rigid Core',
        compare_on: 'ON',
        filter: 'Filter',
        most_recent: 'Most Recent',
        apply: 'Apply',
        all_filters: 'All Filters',
        reset: 'Reset',
        reset_all: 'Reset All',
      } // End of PF - button
    }, // End of PF
    other: {
      text: {
        sales_rep: 'Find a Sales Rep',
        showroom: 'Virtual Showroom',
        home: 'Home',
        products: 'Products',
        viatera: 'VIATERA',
        himacs: 'HIMACS',
        hotherPD: 'HIMACS Sinks',
        votherPD: 'VIATERA Sinks',
        overall: 'Overall Dimensions',
        inner: 'Inner Dimensions',
        contactus: 'Contact Us',
        close: 'close',
        arctic: 'Arctic White',
        ivory: 'Ivory White',
        cream: 'Cream',
        almond: 'Almond',
        all: 'All',
        kitchen: 'Kitchen',
        bathroom: 'Bathroom',
        ada: 'ADA Compliance',
        himacs_sink_banner_desc: 'Explore the complete line of HIMACS vanity and kitchen sinks designed for superior aesthetics and functionality.<br>' +
          'Every HIMACS solid surface sink is engineered to be seamlessly integrated with a HIMACS countertop,<br>' +
          'providing a beautifully smooth, clean, and well-designed surface.',
        viatera_sink_banner_desc: 'Discover the Lovello™ stainless steel sink collection, designed to perfectly complement VIATERA Quartz Countertops.<br>' +
          'These high-quality sinks offer unique styling to enhance any kitchen or vanity,<br>' +
          'providing the ideal finishing touch when paired with your VIATERA surface.'
      },
      button: {
        learn_more: 'Learn more',
        view_more: 'View more',
        load_more: 'Load more',
        certi_more: 'What These Certifications Mean'
      }
    }

  }, // End of CA

  CF: {
    PCD: {
      text: {
        home: 'Accueil',
        contact_us: 'Contactez-nous',
        products: 'Produits',
        hflor: 'HFLOR',
        viateraquartzsurface: 'VIATERA',
        himacssolidsurface: 'HIMACS',
        teracantoporcelainsurface: 'TERACANTO',
        bortepanel: 'BORTE',
        home_film: 'Home Appliance Surface Film',
        automotive: 'Automotive',
        about: {
          himacs: 'À propos de HIMACS',
          hflor: 'À propos de HFLOR',
          viatera: 'À propos de VIATERA',
          teracanto: 'À propos de TERACANTO',
          borte: 'À propos de BORTE',
          home_film: 'About Home Appliance Surface Film',
          automotive: {
            vegan_leather: 'Vegan Leather',
            light_comm: 'Lightweight Component',
            auto_comm: 'Automotive Component'
          }
        },
        sub: {
          lvt: 'Carrelage Vinyle de Luxe(LVT)',
          los: 'Pose Libre',
          spc: 'Noyau rigide SPC',
          homo: 'Homogène',
          het: 'Hétérogène',
          spt: 'Spécialité'
        },
        featured_products: 'Caractéristiques et avantages',
        cart: 'cart',
        wish_list: 'wish list',
        new: 'NEW',
        collection: 'Collection',
        explore_collection: 'Explore Collection',
        online_book: 'Brochure en ligne',
        see_more: 'Voir plus',
        feature_benefits: 'Caractéristiques et avantages',
        certifications: 'Certifications',
        awards: 'Distinctions',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        order_a_sample: 'Order a Sample',
        documentation: 'Documentation',
        care_maintenance: 'Entretien et utilisation',
        warranty: 'Garantie',
        where_to_buy: 'Où acheter',

        SOLID_SURFACE: 'SOLID SURFACE',
        KV_brief: 'The New Generation of Design Inspiration',
        brief: 'HIMACS is composed of minerals, acrylic and natural pigments that come together to provide a durable, smooth, non-porous and visually seamless surface which meets the highest standards for quality, aesthetics, fabrication, functionality and hygiene - offering manifold advantages over conventional materials. HIMACS is durable, it can be shaped by a thermoforming process, and thanks to its huge colour spectrum and translucent properties can help to achieve outstanding and colourful designs. HIMACS uses a simple heating process to give three-dimensional thermoforming capabilities, allows visually seamless designs, offers a virtually limitless range of colours and - for some shades - exhibits a special translucency when exposed to light. Although HIMACS is almost as robust as stone, it can be worked in a similar way as wood: it can be sawn, routed, drilled or sanded. HIMACS is available in sheets of different dimensions and thicknesses. The collection is completed with our range of kitchen sinks, basins, baths and shower trays.',
        photo_credit: 'Photo Credits: Design Marc Fidelle and Andrei David - Paris Airport Engineering and Architectural Management, fabrication : LCCA, photo : Mathieu Ducros',

        Aurora_collection_title: 'AURORA & MARMO',
        Aurora_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        ASTER_collection_title: 'ASTER',
        ASTER_collection_brief: 'Aster is a collection of elegant shades of grey, ranging from almost white to a warm beige, all with a gorgeous mother of pearl shimmer.',

        CONCRETE_collection_title: 'CONCRETE',
        CONCRETE_collection_brief: 'The indusrial look of concrete combined with the incredible flexibility of HI-MACS. The Concrete Collection adds huge opportunities for great designs to architects and designers',

        EXTERIA_collection_title: 'EXTERIA',

        GRANITE_collection_title: 'GRANITE, SPARKLE, QUARTZ, SAND & PEARL',
        GRANITE_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        LUCIA_collection_title: 'LUCIA',
        LUCIA_collection_brief: 'This collection focuses on the natural trend colours black, white and grey. The lively and homogeneous structures add character and expression to the colours. Not surprising, as the renowned Dutch designer, Marcel Wanders, designed three of these colours. (W001, W003, W004)',

        LUCENT_collection_title: 'LUCENT',
        LUCENT_collection_brief: 'The shades of the Lucent Collection, with their exceptional light translucency, allow for spectacular designs. Whether effectively backlit or simply illuminated, the Lucent colours of the architecture always add an elegant touch thanks to their characteristic reaction to light.',

        SOLIDS_collection_title: 'SOLIDS',
        SOLIDS_collection_brief: 'The classic in terms of solid surfaces &ndash; a wide range of attractive shades of white lies at the heart of this collection. Complemented by colourful, dynamic uni-shade accents from Lemon Squash to Festival Pink. The timeless collection offers the perfect colour for every design.',

        STRATO_collection_title: 'STRATO',
        STRATO_collection_brief: 'The marked linear patterns of Strato collection creates geometry through its soft structure and subtle look. The skilful use of the new linear pattern, vertically or horizontally, allows for great variation in each and every project.',

        TERRAZZO_collection_title: 'TERRAZZO',
        TERRAZZO_collection_brief: 'Using a vibrant concrete-base as the canvas for each design, the Terrazzo Collection from HI-MACS offers a vibration of color and patterns that speak to your past, present, and future self in anesthetic. Textured shades, artistic designs, and a touch of modern class, this collection creates a one of a kind experience.',

        ULTRA_collection_title: 'ULTRA',
        ULTRA_collection_brief: 'HIMACS Intense Ultra is based on a brand-new material formulation and combines Intense Colour technology with Ultra-thermoforming. Dark colours become more “intense”, darker and also more resistant, with less visible scratches. The new HIMACS Intense Ultra, also has excellent thermoforming capabilities.',

        VOLCANICS_collection_title: 'VOLCANICS',
        VOLCANICS_collection_brief: 'The large particles of the Volcanics shades add a sense of style to any design. When used on a large scale the result is a dramatic showpiece.',

        Sustainability: 'Écologie',

        /* FR feature benefits TAB */

        TAB_Quality_Design_title: 'Qualité de design',
        TAB_Quality_Performance_title: 'Qualité des performances',
        TAB_Quality_Fabrication_title: 'Qualité de la fabrication',
        TAB_Quality_Sustainability_title: 'Qualité de durabilité',

        /* END FR feature benefits TAB */

        /* FR feature benefits - Quality Design - TAB */

        Design_title1: 'Un large éventail de formes',
        Design_brief1: 'La riche collection de vasques et d\'éviers en HIMACS offre aux designers inventifs de multiples possibilités de créer des installations soignées destinées à des cuisines, des hôpitaux et à de nombreuses autres applications. Parfaitement assorties, ces vasques peuvent se combiner à volonté et sont le garant d’une esthétique moderne et d’une facilité d’entretien remarquable.',

        Design_title2: 'Une translucidité spectaculaire',
        Design_brief2: 'Certaines couleurs et certaines épaisseurs de plaques HIMACS sont particulièrement translucides quand elles sont exposées à la lumière.',
        Design_brief2_1: 'De nombreux motifs et textures peuvent être usinés sur le matériau de manière à intensifier les effets de translucidité du HIMACS.',

        Design_title3: 'Design en trois dimensions',
        Design_brief3: 'HIMACS peut être chauffé grâce à un procédé simple, puis thermoformé en trois dimensions.',
        Design_brief3_1: 'Cette propriété permet d’obtenir une plus grande flexibilité dans la variété des formes qu’avec des matériaux conventionnels. Ainsi, des idées spectaculaires ont vite fait de prendre une forme Concrète : tous les rayons, formes ou angles sont réalisables. Conséquence logique : c\'est le matériau qui s’adapte à vos idées et à vos projets – et non le contraire. Exactement comme ça doit être.',

        Design_title4: 'Gamme de coloris illimitée',
        Design_brief4: 'HIMACS offre une gamme de couleurs quasiment illimitée dans toutes les nuances imaginables.',
        Design_brief4_1: 'Chaque année de nouvelles nuances sont ajoutées. Quelle que soit la couleur choisie, HIMACS reste 100% homogène.',

        /* END FR feature benefits - Quality Design - TAB */

        /* FR feature benefits - Quality Performance - TAB */

        Performance_title1: 'Robustesse',
        Performance_brief1: 'Surface plus robuste avec une longévité similaire à celle de la pierre naturelle, HIMACS résiste aux rayures du quotidien. De plus, la composition sans enduit de votre HIMACS permet à un professionnel qualifié d\'en restaurer facilement la surface en cas de rayures et d\'impacts accidentels plus profonds.',

        Performance_title2: 'Résistant au feu',
        Performance_brief2: 'Soutenu par de nombreux certificats qui attestent de sa résistance au feu (DIN 4102-1 - classe B1, Warrington Fire - classe 0),',
        Performance_brief2_1: 'HIMACS est idéal pour les endroits où la sécurité est le critère prioritaire.',

        Performance_title3: 'Hygiene',
        Performance_brief3: 'Thanks to its impermeability to dirt, bacteria, viruses and countless chemicals, HIMACS is the ideal material for the hospital,',
        Performance_brief3_1: 'medical practice or laboratory. And for all other areas where hygiene really counts.',

        Performance_title4: 'Résistant à l\'eau',
        Performance_brief4: 'Grâce à sa surface non-poreuse, HIMACS est adaptée aux zones humides où l\'humidité peut se former comme les pièces humides et les salles',
        Performance_brief4_1: 'de bains.',

        /* END FR feature benefits - Quality Performance - TAB */

        /* FR feature benefits - Quality Fabrication - TAB */

        Fabrication_title1: 'La technologie de fabrication la plus avancée',
        Fabrication_brief1: 'Le matériau est chauffé lors d\'un processus de mélange progressif (traitement thermique). C\'est ce processus qui distingue HIMACS des autres matériaux minéraux en produisant une liaison plus solide des éléments, dans laquelle d’éventuels défauts de structure sont parfaitement compensés. Cette amélioration de la structure influence automatiquement la qualité du matériau.',

        Fabrication_title2: 'Un matériau facile à travailler',
        Fabrication_brief2: 'HIMACS est presque aussi solide que la pierre, mais il se travaille comme le bois.',
        Fabrication_brief2_1: 'Le solid surface peut être scié, fraisé ou percé avec des outils de menuiserie ordinaires.',

        Fabrication_title3: 'La perfection sans joints',
        Fabrication_brief3: 'Les plaques de HIMACS peuvent être assemblées sans joints visibles.',
        Fabrication_brief3_1: 'L’absence de joints permet d’obtenir de grandes surfaces sans arêtes. Les éléments moulés tels que les éviers et les vasques peuvent également être encastrés à fleur.',

        /* END FR feature benefits - Quality Fabrication - TAB */

        /* FR feature benefits - Quality Sustainability - TAB */

        Sustainability_title1: 'Renouvelable',
        Sustainability_brief1: 'Facile à entretenir et réparable, peu importe que ce soit une rayure, une tache ou un impact,',
        Sustainability_brief1_1: 'HIMACS peut être restauré à son état d\'origine par un professionnel certifié.',

        Sustainability_title2: 'Durabilité',
        Sustainability_brief2: 'HIMACS contribue à préserver l\'environnement en utilisant un matériau durable, un processus de fabrication respectueux et en ayant recours au recyclage en fin de vie. LX Hausys assure totalement la qualité de HIMACS, en offrant une garantie transférable de 15 ans avec le meilleur intérêt de ses clients à l\'esprit.',

        /* END FR feature benefits - Quality Sustainability - TAB */

        /* FR certifications TAB */
        certifications_desc_p: 'À propos des certifications',
        certifications_desc_m: 'À propos des <br> certifications',

        TAB_Environment_title: 'Umwelt',
        TAB_Fire_Rating_title: 'Résistance au feu',
        TAB_HIMACS_Exteria_title: 'Certificats HIMACS Exteria',
        TAB_Hygiene_title: 'Hygiene',
        TAB_Process_title: 'Processus',

        /* END FR certifications TAB */

        /* FR certifications - Environment - TAB */

        Environment_title1: 'Ministre de l’environnement de la République de Corée',
        Environment_brief1: 'En raison de ses engagements environnementaux volontaires et de ses activités dans le domaine du management de produit, HIMACS a été qualifiée d’entreprise écologique par le Ministre de l’environnement de la République de Corée.',

        Environment_title2: 'Classification Emissions M1',
        Environment_brief2: 'a classification M1 de la Finnish Society of Indoor Air Quality and Climate : elle présente les exigences en matière d’émissions pour une bonne qualité de l’air en intérieur pour les matériaux de construction utilisés dans les bureaux et les bâtiments résidentiels.',

        Environment_title3: 'Leadership en conception énergétique et environnementale (LEED)',
        Environment_brief3: 'Le LEED est un système volontaire standard visant à certifier la haute performance des bâtiments auprès de l’US Green Building Council (USGBC, conseil américain pour les bâtiments verts). Il certifie les bâtiments selon un système de crédits. Le recours à HIMACS contribue à répondre aux exigences en matière de crédits EQ pour les matériaux à faibles émissions dans la catégorie de la qualité de l’environnement intérieur (IEQ).',

        Environment_title4: 'ISO 14001',
        Environment_brief4: 'La famille des ISO 14000 concerne la qualité du management environnemental. Le certificat le plus connu de ce groupe est ISO 14001. Il exige de réduire les dégâts environnementaux provoqués par l’activité propre et d’améliorer de façon continue son bilan écologique. L’objectif est de faire participer les entreprises à la protection et à la stabilisation de l’environnement. Ce test certifie que le système de management environnemental de HIMACS satisfait aux standards ISO 14001.',

        Environment_title5: 'Greenguard',
        Environment_brief5: 'Aux Etats-Unis, HIMACS a été reconnu par Greenguard comme « un produit à basse à mission ». Cette organisation établit des standards permettant d’évaluer la qualité de l’air intérieur pour les produits d’aménagement dans les lieux de résidence et les bâtiments. Ces standards ont pour objectif d’améliorer la santé générale et la qualité de vie grâce des programmes améliorant l’air dans les pièces intérieures.',

        Environment_title6: 'Environmental Building Certificate – « Niveau excellent »',
        Environment_brief6: 'a Korean Air Cleaning Association certifie que HIMACS satisfait aux normes environnementales coréennes concernant les matériaux de construction. ',

        Environment_title7: 'DGNB',
        Environment_brief7: 'Le système DGNB, fondé par le « Conseil allemand du bâtiment durable », évalue chaque construction de manière holistique en se basant sur des critères individuels répartis dans les catégories suivantes : Qualité écologique, Qualité économique, Qualité socioculturelle et fonctionnelle, Qualité technique, Qualité des processus et Qualité d’implantation. Divers profils permettent d\'homologuer les constructions neuves et existantes ainsi que des quartiers entiers, en Allemagne comme dans le reste du monde. Les bâtiments peuvent obtenir une certification Bronze, Argent, Or et Platine. HIMACS dispose d’une Déclaration Environnementale de Produit (DEP), qui peut être utilisée dans l’évaluation du cycle de vie des bâtiments (ENV1.1/2.1). De plus, HIMACS a obtenu un niveau de qualité de 4 sur 4 en matière d’impact environnemental local selon le critère DGNB 2018, pour le produit dans son ensemble.',

        Environment_title8: 'BREEAM (Méthode d’évaluation du comportement environnemental des bâtiments)',
        Environment_brief8: 'La BREEAM est la méthode dominante au niveau international pour l’évaluation de la durabilité en matière de conception pilote des projets, des infrastructures et des bâtiments. Il reconnaît et reflète la valeur des éléments à haute performance dans le cycle de vie de l’environnement bâti, qu’il s’agisse de nouvelles constructions, de bâtiments actuellement utilisés ou de rénovations. HIMACS peut également contribuer à l’homologation « BREEAM International New Construction 2016 », ce matériau se conformant intégralement au critère Hea 02 relatif à la qualité de l’air intérieur. Par ailleurs, HIMACS a obtenu une évaluation d’ensemble RSCS de niveau 1 sur le critère Mat 03, approvisionnement responsable des produits de construction: RSCS de niveau 1 BREEAM est une marque de commerce déposée de Building Research Establishment Limited, une filiale en propriété exclusive de BRE Group Limited, et est utilisée avec autorisation. LX Hausys et ses produits ne sont pas affiliés à, ni approuvés ou certifiés par BRE Global Limited, qui est l’exploitant de la BREEAM, ni une quelconque autre filiale de BRE Group Limited. Tous droits réservés.',

        /* END FR certifications - Environment - TAB */

        /* FR certifications - Fire Rating - TAB */

        Fire_Rating_title1: 'Norm NFP 92-501 Class M1',
        Fire_Rating_brief1: 'Norme NFP 92-501 Classe M1 LNE teste la capacité de réaction au feu du matériau. La classe M1 certifie que HIMACS FR possède une haute résistance au feu. Ce certificat est essentiellement recommandé en France.',

        Fire_Rating_title2: 'Norm EN 45 545 Class R1 HZL3',
        Fire_Rating_brief2: 'Protection contre les incendies sur véhicule ferroviaire: Les mesures et exigences spécifiées dans la norme EN 45 545 sont destinés à protéger les passagers et le personnel des véhicules ferroviaires en cas de le feu à bord. HIMACS a atteint la plus haute et la meilleure performance R1 HZL3 (niveau de risque). Valable pour le coloris Alpine White S728.',

        Fire_Rating_title3: 'Norm EN 13501 - Class B-s1, d0',
        Fire_Rating_brief3: 'HIMACS a passé avec succès le test européen EN13501 – classe B-s1-d0, équivalent à la classe 0 du certificat Warrington Fire. ',

        Fire_Rating_title4: 'Norm DIN 4102-1 - Class B1',
        Fire_Rating_brief4: 'La classe B1 certifie que HIMACS est un matériau à faible degré d’inflammabilité. B1 satisfait à la norme européenne de résistance au feu.',

        /* END FR certifications - Fire Rating - TAB */

        /* FR certifications - Exteria Certificates - TAB */

        Exteria_title1: 'IMO MED – Modules B and D',
        Exteria_brief1: 'MED est l’abréviation de Marine Equipment Directive. Ces deux modules sont d’une grande importance pour l’industrie de la construction navale, car ils sont obligatoires pour les matériaux de construction utilisés dans les bateaux. De son côté, le module B de l’IMO concerne la résistance au feu du matériau per se. Il certifie que le matériau concerné présente une faible propagation des flammes et ne peut pas produire de grandes quantités de fumée ni de produits de combustion toxiques. Le module D recouvre l’ensemble des capacités de production et contrôle les processus de production, notamment la gestion et les systèmes employés.',

        Exteria_title2: 'ATE',
        Exteria_brief2: 'Fixées avec des inserts Keil et une structure BWM, les façades HIMACS S728 - Alpine White ont passé avec succès les tests du certificat ATE (Accord Technique Européen).',

        Exteria_title3: 'CSTB Certification',
        Exteria_brief3: 'HIMACS a obtenu la certification QB  délivrée par le CSTB pour les applications en façades (Avis Technique 2.2/18-1795_V1).',

        /* END FR certifications - Exteria Certificates - TAB */

        /* FR certifications - Hygiene - TAB */

        Hygiene_title1: 'NSF',
        Hygiene_brief1: 'Les standards NSF sont des normes universellement reconnues concernant un grand nombre de branches et de domaines en rapport avec la santé publique. Elles concernent le traitement de l’eau potable et des matériaux de c ontact, les objets utilisés pour la fabrication de produits alimentaires, etc. NSF reconnaît que HIMACS satisfait aux normes NSF.',

        Hygiene_title2: 'LGA',
        Hygiene_brief2: 'Nécessaire dans les hôpitaux et dans les environnement où l’hygiène a une importance centrale. LGA évalue la facilité d’entretien, la résistance aux bactéries et aux moisissures et juge la qualité du design du point de vue hygiénique. En raison de sa surface non poreuse, HIMACS a reçu le label LGA « produit hygiénique ».',

        /* END FR certifications - Hygiene - TAB */

        /* FR certifications - Process - TAB */

        Process_title1: 'OHSAS 18001',
        Process_brief1: 'La norme britannique BS OHSAS 18001 (pour « British Standard Occupational Health and Safety Assessment Series ») est un modèle de système de management de la santé et de la sécurité au travail (SMS&ST). Son objectif est de fournir aux entreprises un support d\'évaluation et de certification de leur système de management de la santé et de la sécurité au travail, compatible avec les normes internationales de systèmes de management.',

        Process_title2: 'ISO 9001',
        Process_brief2: 'Les critères ISO 9001 permettent de garantir les processus suivants :',
        Process_brief3: 'L’ensemble du processus de fabrication vise à obtenir une bonne qualité de produit',
        Process_brief4: 'n contrôle de qualité, accompagné, si nécessaire, d’un processus de correction adapté, ainsi qu’un contrôle régulier du procédé de contrôle de la qualité',
        Process_brief5: 'Un processus visant à améliorer l’efficience globale de façon continue',

        /* END FR certifications - Process - TAB */

        /* FR sustainbility - TAB */

        sustainbility_title1: 'Donner forme à l’avenir. En harmonie avec l’environnement.',
        sustainbility_brief1: 'D’innombrables certifications de renom international attestent que les aspects écologiques sont une préoccupation marquante pour HIMACS. Les produits HIMACS sont tous fabriqués selon les standards de protection environnementale conformes à la norme ISO 14001.',

        TAB_Commitment_title: 'Engagement',
        TAB_Material_Safety_title: 'Sécurité du matériau',
        TAB_Manufacturing_title: 'Fabrication',
        TAB_Processing_title: 'Transformation',
        TAB_Transport_title: 'Transport',

        /* END FR sustainbility - TAB */

        /* FR sustainbility - Commitment - TAB */

        Commitment_title1: 'Sécurité du matériau',
        Commitment_brief1: 'Régulièrement, LX Hausys contrôle l’impact environnemental de ses prestations et effectue des analyses de la consommation énergétique. Depuis 2008, les émissions de gaz à effet de serre ont pu être diminuées de 15.000 tonnes par an en utilisant des combustibles exempts de polluants.',

        /* END FR sustainbility - Commitment - TAB */

        /* FR sustainbility - Material Safety - TAB */

        Material_Safety_title1: 'Sécurité du matériau',
        Material_Safety_brief1: 'Des études extensives (effectuées au sein des propres laboratoires de LX Hausys, mais aussi par des institutions indépendantes reconnues) ont montré que le matériau HIMACS lui-même ainsi que ses adhésifs durcis ne contiennent pas de formaldéhyde et ne dégagent aucune émission. HIMACS a reçu le Greenguard Gold Indoor Air Quality Certificate, qui récompense la qualité de l’air en intérieur.',

        /* END FR sustainbility - Material Safety - TAB */

        /* FR sustainbility - Manufacturing - TAB */

        Manufacturing_title1: 'Fabrication',
        Manufacturing_brief1: 'La production de ce matériau Solid Surface est caractérisée par son excellent équilibre énergétique. Au cours des dernières années, la société a réussi à atteindre des objectifs ambitieux en termes de réduction des déchets et d’économies d’eau. Par ailleurs, les usines HIMACS de Cheongju (Corée) et d’Atlanta (États-Unis) répondent à toutes les normes environnementales en vigueur.',

        /* END FR sustainbility - Manufacturing - TAB */

        /* FR sustainbility - Processing - TAB */

        Processing_title1: 'Transformation',
        Processing_brief1: 'HIMACS peut être travaillé en ne produisant quasiment aucun déchet. De plus, les installations en HIMACS sont extrêmement solides et durables. Il est facile de leur rendre leur apparence d’origine, ce qui évite de devoir les remplacer et leur assure ainsi une empreinte environnementale positive sur le long terme. Transport',

        /* END FR sustainbility - Processing - TAB */

        /* FR sustainbility - Transport - TAB */

        Transport_title1: 'Transport',
        Transport_brief1: 'Sur le territoire européen, HIMACS respecte les normes Euro-5 relatives à la réduction des émissions de particules. Le réseau de partenaires de LX Hausys Europe rassemble des professionnels sélectionnés avec soin pour leur respect des normes environnementales les plus strictes: par exemple, notre centre logistique de pointe aux Pays-Bas est l’un des premiers bâtiments construits selon les normes WELL et à recevoir la certification BREEAM, qui confirme qu’il répond aux plus hautes exigences en matière de constructions saines et respectueuses de l’environnement.'

        /* END FR sustainbility - Transport - TAB */

      }, // End of PCD - text

      alert: {
        loginLike: 'Log in to save to your Likes'
      }, // End of PCD - alert

      button: {
        seeMore: 'Voir plus',
        see_all: 'Voir tous les designs',
        learnMore: 'En savoir plus',
        explore_collection: 'Explorer la collection',
        feature_benefits: 'Caractéristiques et avantages',
        certifications: 'Certifications',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        close: 'close',
        find_a_sales_rep: 'Trouver un représentant',
        btn_sustainbility_brochure: 'Télécharger la brochure sur le développement durable',

        English: 'Anglais',
        German: 'Allemand',
        French: 'Français',
        Italian: 'Italien',
        Spanish: 'Espagnol',
        Dutch: 'Néerlandais',
        EnglishUK: 'Anglais (UK)'

      }, // End of PCD - button

      popup: {
        /* Edge Profiles 시작 점 */
        edge_title: 'Viatera Edge Profile',
        edge_brief: 'Where quartz meets the edge. LX Hausys Surfaces offers a wide selection of edge treatments.' +
          '                    Select from a simple rounded corner to the complex multi-toned,' +
          '                    multi-tiered rolling edges that add that special finishing touch to your solid surface counter.' +
          '                    For more information on our edge treatments, please consult your local area distributor or' +
          '                    fabricator.',

        beveled_Edge: 'Beveled Edge',
        beveled_Edge_brief: 'Maintains the surface’s thickness,\n' +
          '                    but with a ¼” or ½” angular top edge.',
        bullnose_Edge: 'Bullnose Edge',
        bullnose_Edge_brief: 'A completed rounded edge.',

        eased_Edge: 'Eased Edge',
        eased_Edge_brief: 'A slightly rounded top edge that still\n' +
          "                    maintains the surface's thickness.",

        ellipse_Edge: 'Ellipse Edge',
        ellipse_Edge_brief: 'Rounded top and bottom edges\n' +
          '                    with a flat face.',

        knife_Edge: 'Knife Edge',
        knife_Edge_brief: 'A sharp, blade-like edge.',

        reverse_Ogee_Edge: 'Reverse Ogee Edge',
        reverse_Ogee_Edge_brief: 'Similar to Roman Edge, but reversed.',

        roman_Edge: 'Roman Edge',
        roman_Edge_brief: 'An elaborate ogee-style edge design\n' +
          '                    inspired by Roman architecture.',

        roundover_Edge: 'Roundover Edge',
        roundover_Edge_brief: 'A semi-circle rounded top edge.',

        /* Edge Profiles 끝 */

        /* Finish 시작 점 */
        finishInfo: 'Finish guide',
        finishTitle: 'Introducing New Viatera Finish Brushed',
        finishBrief: 'Select Viatera colors are now available with a “Brushed” finish to fulfill a wider range of aesthetics.\n' +
          '                  Enjoy the new classic beauty with a satin-like finish.',
        polished: 'POLISHED',
        polished_brief: 'Traditional reflective surface',

        brushed: 'BRUSHED',
        brushed_brief: 'Soft and smooth feel with\n' +
          '                    low-luster on the surface',

        leather: 'Leather',
        leather_brief: 'Leather finish has a slightly more matte texture than a polished finish, and makes you feel the soft touch of the leather.',

        velvet_Touch: 'Velvet Touch',
        velvet_Touch_brief: 'Velvet touch finish enables you to feel the texture of nature with the feeling of stone dents.',

        finish_viatera: 'Viatera',
        finish_viatera_info: 'Brushed Finish Care & Maintenance',
        finish_viatera_brief: 'Viatera products with Brushed Finish are the same as those with the standard Polished Finish.\n' +
          '                  The only manufacturing difference is how the final gloss level is achieved.',

        finish_viatera_brief_01: 'Brushed Finish may need more daily attention than Polished Finish. This is the nature of any material with a matte finish when compared to the same material\n' +
          '                  with a polished finish – smudges, fingerprints, and water spots are simply more visible on a matte surface. Promptly wipe up and buff dry routine spills, droplets,\n' +
          '                  and rings. A microfiber towel may be more effective than a paper towel because Brushed Finish has a slight surface texture when compared to Polished Finish.\n' +
          '                  These non-woven cleaning products work well on all surfaces and are especially helpful on products that feature anything other than a perfectly smooth surface.',

        finish_viatera_brief_02: 'Routine Care and Maintenance of Brushed Finish is easy with the same liquid household cleaners that are suitable for “Polished” finishes, including Formula 409\n' +
          '                  Natural Stone & Steel Cleaner.',

        finish_viatera_brief_03: 'Always read and follow that manufacturer’s label instructions. A textured sponge that’s suitable for non-stick coated cookware may be helpful in removing some\n' +
          '                  tougher spills. Avoid using abrasive cleaners like Ajax or Comet, as these more aggressive materials may dull or damage the surface of Brushed Finish.\n' +
          '                  After using any cleaning product always rinse the area and buff the area dry. A microfiber product is suggested but not required.'

        /* Finish 끝 */

      } // End of PCD - popup
    }, // End of PCD

    PD: {
      text: {
        new: 'Nouveautés',
        discontinued_Color: 'Couleur interrompue',
        image_enlarged_view: 'IMAGE ENLARGED VIEW',
        image_download_view: 'IMAGE DOWNLOAD VIEW',
        finish: 'Finish',
        finishGuide: 'Finish guide',
        color: 'couleurs',
        product_Specs: 'Spécification de produit',
        product_type: 'Type de produit',
        total_thickness: 'Épaisseur totale',
        wear_layer: "Couche d'usure",
        dimension: 'Dimensions',
        dimension1: 'Dimensions',
        weight: 'poids',
        remark: 'Remark',
        pattern: 'Motif',
        emboss: 'Estampage',
        installation: 'Installation',
        adhesive_code: 'Adhesive Code',
        adhesive_name: 'Adhesive Name',
        available_Countries: 'Available Countries',
        related_Products: 'Produits Connexes',
        features_Benefits: 'Caractéristiques et avantages',
        certifications: 'Certifications',
        documentation_technical_details: 'Documentation et Détails Techniques',
        fabrication: 'Herstellung',
        test_report: 'Rapports de tests',
        care_maintenance: 'Soin et Entretien',
        catalogue: 'Catalogue',
        certification: 'Certification',
        technical_datasheet: 'Fiche Technique',
        installation_guide: "Guide d'Installation",
        warranty: 'Garantie',
        edge_profile: 'Profil de Bord',
        inspiration: 'Inspiration',
        standard: 'Standard',
        image_viewer: "À des fins d'illustration uniquement. Taille standard des dalles :",
        in: 'in',
        zoom_out: 'zoom Out',
        zoom_in: 'zoom In',
        Thickness: 'Épaisseur totale',
        Use: 'Utilisation',
        Pattern: 'Motif',
        Notice: 'Avis',
        Notice_brief: 'Moins adapté aux surfaces soumises à un trafic intense en raison de la saturation plus élevée de la couleur pigmentée, les marques peuvent être plus facilement visibles.',
        Semi_Translucent: 'Semi translucide',
        Semi_Translucent_brief: "Les couleurs portant cette marque ont un effet semi-translucide, qui devient évident lorsqu'elles sont combinées à des sources de lumière",
        Outdoor: 'Extérieur',
        Outdoor_brief: 'Suitable for exterior use. Please check conditions about level of suitability and warranty per colour. Indoor, Suitable for Kitchen & Bathroom',
        Recycled: 'Recyclé',
        Recycled_brief: 'Certifié comme incorporant des contenus recyclés pré-consommation. Au moins',
        Designer: 'Gammes Design',
        Designer_brief: 'Design par Marcel Wanders',
        Lucent: 'Lucent',
        Lucent_brief: "Les couleurs Lucent ont un niveau de translucidité plus élevé, qui devient plus évident lorsqu'elles sont associées à une source de lumière. Couleur translucide",
        Veined: 'Veiné',
        Veined_brief: 'Marmo étant un produit dont le veinage est aléatoire, il est nécessaire de respecter des consignes de fabrication spécifiques.',
        construct: 'Construct',
        news_letter: 'Sign up for our Newsletter',
        news_letter_desc: 'Discover innovative projects, unique colors  and the latest news and trends',
        subscribe: 'Subscribe',
      }, // End of PD - text

      button: {
        virtual_Showroom: 'Showroom virtuel',
        prev: 'Précédent',
        next: 'Suivant',
        list_view: 'list view',
        download: 'téléchargement',
        see_all_documentation: 'Voir tous les documents ',
        see_all_case_studies: 'Voir toutes les études de cas',
        see_more: 'Voir plus'

      } // End of PD - button

    }, // End of PD

    PF: {
      text: {
        dimensionCf: 'Dimensions des dalles (pouce)',
        thicknesscm: 'Épaisseur(cm)',
        category: 'CATEGORY',
        luxury_vinyl_tile: 'Carrelage Vinyle de Luxe',
        looselay: 'Pose Libre',
        spc: 'Noyau rigide SPC',
        homogeneous_sheet: 'Feuille Homogène',
        heterogeneous_sheet: 'Feuille Hétérogène',
        specialty: 'Spécialité',
        filter_by: 'Filter By',
        patterns: 'Motif',
        country: 'Pays',
        new: 'Nouveau',
        new_a: 'NEW',
        isNeoQ: 'NeoQ™ (Recycled Content)',
        new_colors: 'Nouvelles Couleurs',
        product_type: 'Type de produit',
        thickness: 'Épaisseur (pouce)',
        weight: 'Poids (lbs)',
        finish: 'Finition',
        wear_layer: "Couche d'usure",
        dimension: 'Dimension (mm)',
        searchText: 'Entrez numéro/nom',
        recycled: 'Recyclé',
        exclusive: 'U.S. Exclusive',
        Tones: 'Teinte',
        Use: 'Utilisation',
        Recycled: 'Recyclé',
        Thickness: 'Épaisseur',
        himacs: 'HIMACS',
        borte: 'BORTE',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        teracanto: 'TERACANTO',
        installation: 'Installation',
        results: 'Results',
        no_search_result: 'Aucun résultat trouvé',
        no_compare_item: 'Aucun élément à comparer',
        no_option: 'Veuillez sélectionner une option',
        color: 'Couleur',
        filters: 'Filtrer',
        compare: {
          viatera: 'COMPARER le PRODUITS VIATERA',
          hflor: 'COMPARER le PRODUITS HFLOR',
          teracanto: 'COMPARER le PRODUITS TERACANTO',
          himacs: 'COMPARER le PRODUITS HIMACS'
        },
        compare_full: {
          text: 'Voulez-vous remplacer les premiers produits <br>' +
            'ajoutés par celui que vous avez sélectionné ?',
          footer: 'Edit products in compare'
        },
        slab_size: 'Dimensions des plaques (pouce)',
        bookmatch: 'Effet miroir',
        remark: 'Remarque',
        key_visual_desc: {
          all_colors: 'Découvrez la couleur et le design idéals pour vos projets à venir, qu’il s’agisse de comptoirs en quartz, de surfaces solides, de panneaux en porcelaine ou de revêtements de sol résilients. <br>' +
            'LX Hausys offre une vaste gamme de couleurs, de finis et de choix esthétiques dans l’ensemble de son portfolio de matériaux de surface et de revêtement de sol.',

          all_samples: 'Find the perfect samples for your next project, whether you need quartz countertops, solid surfaces, porcelain surfaces, or resilient flooring. <br>' +
            'LX Hausys offers a diverse array of samples across its entire surfacing and flooring portfolio.',

          hflor_color: 'Explorez le vaste univers des possibilités de design avec les revêtements de sol résilients HFLOR. <br>' +
            'Notre palette diversifiée de couleurs et de motifs s’étend à travers tous nos matériaux, incluant le luxe vinyle (LVT) et les feuilles de vinyle.',

          hflor_sample: 'Find the perfect resilient flooring samples for your next demanding project. <br>' +
            'HFLOR offers a diverse array of samples to help you select from its innovative and high-performance LVT collections.',

          viatera_color: 'Rehaussez le style de chaque espace grâce à la superbe collection de comptoirs en quartz VIATERA. <br>' +
            'Explorez notre vaste sélection pour trouver la solution idéale alliant performance exceptionnelle et design intemporel.',

          viatera_sample: 'Find the perfect quartz countertop samples for your next design project. <br>' +
            'VIATERA offers a diverse array of samples across its beautiful and highly durable quartz collection.',

          himacs_color: 'Avec HIMACS, repensez les limites du design et explorez une palette infinie de couleurs et de motifs. <br>' +
            'HIMACS est la surface solide idéale pour les applications commerciales et résidentielles.',

          himacs_sample: 'Find the perfect solid surface samples for your next creative project. <br>' +
            'HIMACS offers a diverse array of samples to help you explore its flexible and seamless solid surface collection.',

          teracanto_color: 'Laissez les designs saisissants des surfaces TERACANTO sublimer votre espace. <br>' +
            'Découvrez la vaste gamme de couleurs et de motifs qui font de TERACANTO une véritable œuvre de la nature et de l’innovation.',

          teracanto_sample: 'Find the perfect porcelain surface samples for your next sophisticated design. <br>' +
            'TERACANTO offers a diverse array of samples across its durable, large-format porcelain collection.',

          benif_color: 'Unlock exceptional design versatility with BENIF architectural film. <br>' +
            'Explore our extensive selection of colors and patterns to easily transform walls, ceilings, and furniture, using the specialized self-adhesive backing <br>' +
            'for quick and easy application.',

          borte_color: 'Your Doorway to Sustainable Home Innovation',

          default_desc: '',
        },
        allColors: {
          himacs: 'HIMACS couleurs',
          hflor: 'HFLOR couleurs',
          viatera: 'VIATERA couleurs',
          teracanto: 'TERACANTO couleurs',
          borte: 'BORTE couleurs',
          himacs_ac: 'HIMACS',
          hflor_ac: 'HFLOR',
          viatera_ac: 'VIATERA',
          exteriorfilm_ac: 'EXTERIOR Film',
          decofilm_ac: 'DECO Film',
          borte_ac: 'BORTE',
          teracanto_ac: 'TERACANTO',
          benif_ac: 'BENIF',
          vizuon_ac: 'VIZUON',
          products: 'Produits',
          all_colors: 'Toutes les couleurs',
          filter: 'Filtrer',
          filter_by: 'Filtrer',
          brand: 'Marque',
          color: 'Couleur',
          searchText: 'Entrez numéro/nom',
          results: 'Résultats',
          no_result: 'Aucun résultat trouvé',
          no_result_text: 'Si vous ne trouvez pas ce que vous cherchez, veuillez essayer d\'autres termes de recherche ou filtres.',
          apply: 'Appliquer',
          clear_all: 'Tout effacer',
          clear_all2: 'Tout effacer',
          products_a_to_z: 'Produits de A à Z',
          products_z_to_a: 'Produits de Z à A',
          new_products_first: 'Les plus récents',
          your_compare_is_full: 'Votre comparateur est plein.',
          new: 'Nouveau',
          new_a: 'NEW',
          brandLabel: 'Marque',
          colorLabel: 'Couleur',
          white: 'Blanc',
          cream: 'Crème',
          beige: 'Beige',
          brown: 'Brun',
          gray: 'Gris',
          black: 'Noir',
          green: 'Vert',
          blue: 'Bleu',
          pink: 'Pink',
          purple: 'Purple',
          ivory: 'Ivoire',
          orange: 'Orange',
          red: 'Rouge'
        }
      }, // End of PF - text

      filter: {
        filter_by: 'Filtrer',
        vizuon: 'VIZUON',
        vt: 'Vehicles and Transportation',
        sd: 'Signs and Displays',
        is: 'Illuminated Sign',
        ar: 'Architecture',
        es: 'Eco Solution',
        cb: 'Corporate Branding',
        feature: 'FEATURE',
        country: 'COUNTRY',
        compare: 'COMPARER',
        bookmatch_CF: 'BOOKMATCH',
        bookmatch: 'Effet miroir',
        application: 'APPLICATION',
        weatherability: 'WEATHERABILITY',
        remark: 'Remarque',
        remark_CF: 'REMARK',
        hflor: 'HFLOR',
        pet: 'PET',
        installation: 'Installation',
        productType: 'Product Type',
        filter: 'Filtrer',
        color: 'Couleurs',
        collection: 'Collection',
        patterns: 'Motifs',
        finish: 'Finition',
        recycled: 'Recycled',
        thickness: 'Épaisseur',
        format: 'Format',
        wearlayer: 'Couche d\'usure',
        dimensions: 'Dimensions des dalles (pouce)',
        prdtype: 'Installation', // installation
        adhesivetype: 'Adhesive Type',
        productclassification: 'Product Classification',
        airfree: 'Air Free',
        solidcolor: 'Solid Color',
        solidPatterns: 'Solid Pattern',
        stoneColor: 'Stone Color',
        metalColor: 'Metal Color',
        woodColor: 'Wood Color',
        metalPattern: 'Metal Pattern',
        woodPattern: 'Wood Pattern',
        stonePattern: 'Stone Pattern',
        pvc: 'PVC',
        petFurnitureFilm: 'PET',
        acrylicFurnitureFilm: 'Acrylic',
        woodSpecies: 'Wood Species',
        new: 'NEW',
        thruvein: 'Thru Vein ',
        slabsize: '',
        isNeoQ: 'Remark',
        category: 'Category',
        type: 'Type'
      },
      popup: {
        weight_kg: 'Poids (kg)',
        filter_by: 'FILTRER',
        your_compare_is_full: 'Votre comparateur est plein',
        compare_tool: 'Outil de comparaison',
        compare_alert1: 'Voulez-vous remplacer le premier produit',
        compare_alert2: 'que vous avez ajouté par celui que vous avez sélectionné ?',
        edit_products_in_compare: 'MODIFIER LES PRODUITS À COMPARER',
        replace: 'REMPLACER',
        close: 'close',
        characteristics_technical_performance: 'Caractéristiques et performances techniques ',
        pvc: 'PVC',
        acrylic: 'Acrylic',
        adhesive_type: 'Adhesive Type',
        adhesive_code: 'Code Adhésif',
        adhesive_name: 'Nom Adhésif',
        air_free: 'Air Free',
        film_type: 'Film Type',
        material: 'Material',
        liner: 'Liner',
        width: 'Width',
        grade: 'Grade',
        length: 'Length',
        pet: 'PET',
        thickness: 'Épaisseur',
        thickness_cm: 'Épaisseur (cm)',
        dimension_inch: 'Dimension (pouce)'
      },

      button: {
        all: 'Tout',
        los: 'Pose Libre',
        spc: 'Noyau rigide SPC',
        lvt: 'Carrelage Vinyle de Luxe',
        hom: 'Feuille Homogène',
        het: 'Feuille Hétérogène',
        spt: 'Spécialité',
        compare: 'Comparer',
        compare_your_colors: 'Comparer vos couleurs',
        remove: 'Supprimer',
        add_more: 'Ajouter',
        search: 'search',
        color: 'couleurs',
        collection: 'Collection',
        patterns: 'Motifs',
        finish: 'Finition',
        country: 'Pays',
        new: 'Nouveau',
        all_products: 'Tous les produits',
        grouped_by_collections: 'Regroupés par collections',
        filter_by: 'Filter By',
        products_a_to_z: 'Produits de A à Z',
        products_z_to_a: 'Produits de Z à A',
        new_products_first: 'Les plus récents',
        clear_all: 'Tout effacer',
        see_more: 'Voir plus',
        see_all_colors: 'Voir toutes les couleurs',
        download: 'Téléchargement',
        Popularity: 'Popularité',
        compare_on: 'ON',
        filter: 'Filtrer',
        most_recent: 'Les plus récents',
        apply: 'Appliquer'
      } // End of PF - button
    }, // End of PF

    other: {
      text: {
        hotherPD: 'HIMACS Sinks',
        votherPD: 'VIATERA Sinks',
        sortby: 'Trier par',
        Asc: 'Produits de A à Z',
        Desc: 'Produits de Z à A',
        Newest: 'Neuste',
        popu: 'Popularité',
        use: 'Utilisation',
        kbb: 'Cuisine et salle de bain - Brochure',
        bim: 'Objets BIM',
        prd_ref: 'Référence du produit',
        dim: 'Dimensions',
        install: 'Installation',
        more: "Plus d'informations",
        sales_rep: 'Trouver un représentant commercial',
        showroom: 'Showroom virtuel',
        home: 'Accueil',
        products: 'produits',
        viatera: 'VIATERA',
        himacs: 'HIMACS',
        otherPD: 'Autres produits',
        overall: 'Overall Dimensions',
        otheroverall: 'Dimensions générales',
        inner: 'Inner Dimensions',
        otherinner: 'Dimensions intérieures',
        contactus: 'Contactez-nous',
        close: 'close',
        arctic: 'Arctic White',
        ivory: 'Ivory White',
        cream: 'Cream',
        almond: 'Almond',
        all: 'Tout',
        kitchen: 'Cuisine',
        bathroom: 'Salle de bain',
        ada: 'Conformité ADA',
        note: 'Attention',
        noteText1: 'La livraison comprend soit la baignoire, soit le receveur de douche (comme illustré sur le schéma) et le matériel d’installation correspondant : des pieds ajustables en hauteur, un matériau d’isolation phonique et un panneau de stabilisation en bois.',
        noteText2: 'Une plaque de matériau supplémentaire est également nécessaire pour obtenir l’installation illustrée sur les photos.',
        noteText_basins: 'La bonde de vidange avec couvercle en solide surface est également disponible et doit être acheté séparément.',
        himacs_sink_banner_desc: 'Explore the complete line of HIMACS vanity and kitchen sinks designed for superior aesthetics and functionality.<br>' +
          'Every HIMACS solid surface sink is engineered to be seamlessly integrated with a HIMACS countertop,<br>' +
          'providing a beautifully smooth, clean, and well-designed surface.',
        viatera_sink_banner_desc: 'Discover the Lovello™ stainless steel sink collection, designed to perfectly complement VIATERA Quartz Countertops.<br>' +
          'These high-quality sinks offer unique styling to enhance any kitchen or vanity,<br>' +
          'providing the ideal finishing touch when paired with your VIATERA surface.'
      },
      button: {
        learn_more: 'En savoir plus',
        view_more: 'Voir plus',
        load_more: 'Charger plus',
        certi_more: 'What These Certifications Mean'
      }
    }
  }, // End of FR

  JP: {
    PCD: {
      text: {
        home: 'Home',
        contact_us: 'Contact Us',
        products: '製品情報',
        himacs: 'HIMACS',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        teracanto: 'TERACANTO',
        vizuonsigngraphic: 'VIZUON',
        himacssolidsurface: 'HIMACS',
        viateraquartzsurface: 'VIATERA',
        teracantoporcelainsurface: 'TERACANTO',
        benifarchitecturalfilm: 'BENIF',
        exteriorfilm: '屋外用フィルム',
        decofilm: '化粧シート',
        home_film: '家電用表面素材',
        automotive: '自動車用原反＆部品',
        sub: {
          lvt: 'ラグジュアリービニルタイル',
          los: 'ルーズレイフローリング',
          spc: 'SPCタイル',
          homo: '単層床シート',
          het: '複層床シート',
          spt: '機能性床シート',
          veh: 'カーラッピング用',
          sd: '看板用',
          illum: '照明用',
          arch: '建築用',
          eco: 'エコソリューション',
          corp: '企業ブランディング'
        },
        vizuon_a: 'VIZUON',
        deco: 'Deco Film',
        exterior: 'Exterior Film',
        about: {
          himacs: 'HIMACSについて',
          hflor: 'HFORについて',
          teracanto: 'TERACANTOについて',
          vizuon_a: 'VIZUONについて',
          deco: '化粧シートについて',
          exterior: '屋外用フィルムについて',
          home_film: '家電用表面素材について',
          automotive: {
            vegan_leather: '自動車用原反',
            light_comm: '軽量化部品',
            auto_comm: '自動車用部品'
          }
        },
        featured_products: 'Featured Products',
        cart: 'cart',
        wish_list: 'wish list',
        new: 'New',
        coming: 'Coming soon',
        collection: 'Collection',
        explore_collection: 'Explore Collection',
        online_book: 'Online Book',
        load_more: 'Load More',
        certi_more: 'もっと詳しく知る',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        awards: 'Awards',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        order_a_sample: 'Order a Sample',
        documentation: 'Documentation',
        care_maintenance: 'Care & Maintenance',
        warranty: 'Warranty',
        where_to_buy: 'Where to buy',
        home_app_film: {
          title: '家電用表面素材',
          title_description: '家電、ユニットバス、エレベーターのフィルムラミネート鋼板表面仕上げ材。',
          intro1: 'LX Hausys 家電表面フィルムは、冷蔵庫、洗濯機、バスルーム向けのさまざまな色と柄を備えた高品質の表面材です。',
          intro2: '当社の優れた製品は、その優れた耐汚染性、耐傷性、耐腐食性により、すでに世界中の家電メーカーに選ばれています。',
          point_title1: 'デザインソリューションのカスタマイズ',
          point_description1: 'グローバルトレンドリサーチに基づき、現地の顧客向けにカスタマイズした設計ソリューションの開発能力は、特にインド、アメリカ、中国、東南アジア、ヨーロッパなど、で世界中で認められています。',
          point_title2: 'Global No.1',
          point_description2: 'LX Hausysの家電表面フィルムは、世界的な大手家電メーカーのパートナーとして第1のM/Sを目指しています。',
          point_title3: '優れた品質',
          point_description3: 'LX Hausysの技術は、指紋防止、汚れ防止、傷防止、高伸率を実現し、お客様が家電製品を長期間美しくご使用いただけるようにしています。',
          construction: '構造',
          construction_film1: 'Metallic Film',
          film1_item1: 'エコ PET',
          film1_item1_desc: 'PET ベースのメタル パールにヘアラインをプリント',
          film1_item2: 'Metalon',
          film1_item2_desc: 'メタライジングにより、フィルムに本物の金属のような外観を与えます。',
          film1_item3: 'SUS Film',
          film1_item3_desc: 'エンボスヘアライン技術により、水平ヘアラインを含むカスタマイズされた柄が可能になり、STS とまったく同じ外観を実現します。',
          construction_film2: 'パール＆柄フィルム',
          film2_item1: 'Hi-Gloss',
          film2_item1_desc: '優れた印刷技術により、カスタマイズされた柄を提供できます。',
          film2_item2: 'Galaxy',
          film2_item2_desc: 'さまざまなパール効果により、きめ細やかでキラキラとした表面を実現します。',
          film2_item3: 'Soft-matte',
          film2_item3_desc: 'さまざまな色やカスタマイズされた柄のソフトマットテクスチャ。',
          application: '用途',
          application_sub_title: '家電用表面素材',
          application_item1: 'パステルメタル',
          application_item2: 'ソフトマット',
          application_item3: '水平ヘアライン（シルバー、ショート）',
          application_item4: '水平ヘアライン（ブラック）',
          application_item5: 'イリジウムヘアライン',
          application_item6: '水平ヘアライン（ダークグレー）',
          application_item7: 'グラスファイバー',
          application_item8: '水平ヘアライン（シルバー、ロング）'
        },
        automotive_skin: {
          title: '合成皮革自動車用シートカバー',
          sub_title: 'Sustainable & Innovative',
          title_description: 'サステナブル製品、環境に優しい革新技術',
          intro: 'は, さまざまな自動車用途の内装スキンの大手サプライヤーです。当社の高度な技術と革新的なデザインにより、お客様の期待を超えて車両を装飾するトータルな内装ソリューションを提供できます。',
          point_title1: '安全性',
          point_description1: 'OEKO-TEX® STANDARD 100 (エコテックス®スタンダード100)有害化学物質に関する安定性試験にクリアした認証製品です（グリーンラベル）',
          point_title2: 'サステナブル素材',
          point_description2: 'バイオ及びリサイクル材料を用いたサステナブル製品の開発(バイオ/エコラベル）',
          seat_cover: 'シートカバー',
          seat_cover_desc: 'LX Hausys 自動車用スキンは、クラス最高のテクノロジーを通じて革新的なデザインを実現し、室内の運転空間に感動的な品質をもたらします。',
          cover_item1: 'SOFINO®',
          cover_item2: 'VERNO®',
          cover_item3: 'Calfpelle®',
          cover_item4: 'LUSSINO™',
          sofino_item1: 'SOFINO® Green',
          sofino_desc1: 'OEKO-TEX®　Standard　100のクラス１に準じた素材で幼児やお子様に安全であることを証明しています¹⁾',
          sofino_item2: 'SOFINO® Bio',
          sofino_desc2: '<span>バイオマスフィラー（ケナフ、ユーカリなど）からバイオレザーを開発中</span>',
          sofino_item3: 'SOFINO® Eco',
          sofino_desc3: ' <span>•  RCS (リサイクルクレームスタンダード) 認証済み</span>' +
            '        <br />' +
            '        <span>• リサイクル含有量 35 重量% (廃ペットボトルをリサイクルしたポリエステル）</span>',
          sofino_anno: '<span>1) OEKO-TEX® Standard 100 クラス 1 (乳児用製品) の制限値</span>' +
            '      <br />' +
            '      <span>• NMP (1-メチル-2-ピロリドン)、DMF (ジメチルホルムアミド) の溶媒残留物 ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span>• フタル酸エステルの合計 ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span class="spacing">(DBP, BBP, DEP, DMP, DEHP, DEMP, DIHP, DHNUP, DHxP, DIDP, DPrP, DHP, DNOP, DNP, DPP)</span>' +
            '      <br />' +
            '      <span>• 禁止されている難燃性物質を一切含まない</span>' +
            '      <br />' +
            '      <span class="spacing">(例: ポリ臭化ジフェニルエーテル、三酸化アンチモン)</span>' +
            '      <br />',
          verno_item1: 'VERNO® Green',
          verno_desc1: 'OEKO-TEX®　Standard　100のクラス１に準じた素材で幼児やお子様に安全であることを証明しています¹⁾',
          verno_item2: 'VERNO® Bio',
          verno_desc2: '<span>• ULソリユーションによるバイオベース材料含有量に関する環境性検証</span>' +
            '        <br />' +
            '        <span>• バイオベース材料含有量</span>',
          verno_item3: 'VERNO® Eco',
          verno_desc3: '<span>• RCS (リサイクルクレームスタンダード) 認証済み</span>' +
            '        <br />' +
            '        <span>• リサイクル含有量 50 重量% (廃ペットボトルをリサイクルしたポリエステル)</span>',
          verno_anno: '<span>1) OEKO-TEX® Standard 100 クラス 1 (乳児用製品) の制限値</span>' +
            '      <br />' +
            '      <span>• NMP (1-メチル-2-ピロリドン)、DMF (ジメチルホルムアミド) の溶媒残留物 ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span>• フタル酸エステルの合計 ≤ 0.05 wt%</span>' +
            '      <br />' +
            '      <span class="spacing">(DBP, BBP, DEP, DMP, DEHP, DEMP, DIHP, DHNUP, DHxP, DIDP, DPrP, DHP, DNOP, DNP, DPP)</span>' +
            '      <br />' +
            '      <span>• 禁止されている難燃性物質を一切含まない</span>' +
            '      <br />' +
            '      <span class="spacing">(例: ポリ臭化ジフェニルエーテル、三酸化アンチモン)</span>' +
            '      <br />',
          calfpelle_item1: 'Calfpelle®',
          calfpelle_desc1: '<span> • 表面品質に優れたスエード</span>' +
            '        <br />' +
            '        <span>• ソフトな質感と優れた耐久性</span>',
          calfpelle_item2: 'Calfpelle® Bio',
          calfpelle_desc2: '<span>•ULソリユーションによるバイオベース材料含有量に関する環境性</span>' +
            '        <br />' +
            '        <span>• バイオベース材料含有量 ≥ 10%</span>',
          lussino_item1: 'LUSSINO™',
          lussino_desc1: '<span>• 高性能のサステナブルシリコーンベースのレザー</span>' +
            '        <br />' +
            '        <span>• シリコーンベースの構成(トップコーティング、表面層、接着層）</span>',
          design_area: 'デザイン',
          design_area_desc: 'LX Hausysは、高品質を提供するだけでなく、車両のコンセプトに合わせた表面テクスチャデザインの研究開発も行う自動車用ファブリックを開発しています。さまざまなパターンとデザイン後処理技術を活用して、お客様の好みに合わせたデザインソリューションを提供します。',
          comm_vegan_leather: '商業用人造皮革',
          comm_vegan_leather_desc: '自動車シート生地の技術を応用し、耐久性、耐汚染性など優れた表面品質を実現。ケナフなどのバイオ由来の 素材を使用した製品も提供可能です。',
          comm_prd_title: 'LXELLO™',
          comm_item1: 'LXELLO™ Green',
          comm_desc1: 'OEKO-TEX®　Standard　100のクラス１に準じた素材で幼児やお子様に安全であることを証明しています',
          comm_item2: 'LXELLO™ Bio',
          comm_desc2: '表面層と発泡層にはケナフなどのバイオベースの素材が含まれています',
          comm_item3: 'LXELLO™ Eco',
          comm_desc3: '<span>• RCS (リサイクルクレームスタンダード) 認証済み</span><br /> <span>• リサイクル含有量 35 重量% (廃ペットボトルをリサイクルしたポリエステル）</span>',
          comm_anno: '<span>• 表面層と発泡層にはケナフなどのバイオベースの材料が含まれています</span>' +
            '            <br>' +
            '            <span>- ケナフは植物の中で最も二酸化炭素吸収率が高く、平均の3～10倍です ¹⁾</span>' +
            '            <br>' +
            '            <span>• 汚れ防止などの自動車内装材のニーズに応じた設計をしています</span>' +
            '            <br>' +
            '            <span>- 優れた汚れ防止性能により明るい内装デザインが可能になります</span>' +
            '            <br>' +
            '            <span>1) 出典: 環境省「環境に優しい作物に関する分析レポート」(2019)</span>' +
            '            <br>',
          lello_palette_title: 'LXELLO™ Color Palette'
        },

        automotive_lightweight: {
          title: '軽量コンポーネント',
          sub_title: '従来の鉄鋼と同等の強度を保ちながら、部品の軽量化による燃費削減に貢献する強化プラスチックでによる軽量素材を提供します。',
          title_description: '環境に優しく、燃費効率に優れた 軽量自動車部品で、高い鋼鉄剛性を実現',
          point_title1: '軽量',
          point_description1: '従来の鋼材に比べて25%軽量化',
          point_title2: '高強度',
          point_description2: '従来の鋼の強度を維持',
          point_title3: 'コスト削減',
          point_description3: '設計の最適化による部品点数の削減',
          component_item1: 'バンパービーム',
          component_desc1: '- 従来の鋼鉄に比べて 25% 軽量 \n' +
            '- 衝撃吸収により衝突時に乗員を保護',
          component_item2: 'ニーボルスター',
          component_desc2: '- 従来のスチールに比べて 56% 軽量 \n' +
            '- 衝撃から膝を保護',
          component_item3: 'シートバック',
          component_desc3: '- 従来のスチールに比べて 30% 軽量化 \n' +
            '- 部品数の最小化 \n' +
            '- 衝撃安全性の向上',
          component_item4: 'バッテリーパックの底部パネル',
          component_desc4: '- アルミニウムに比べて 30% 軽量 \n' +
            '- 電気自動車のバッテリーパックの下部を保護',
          component_info: '※軽量化は自動車設計解析プログラム（CATIA、LS-DYNA）のシミュレーション結果に基づいたものであり、実際の製品製造時の仕様の限りにより異なる場合があります。',
          material_title: '軽量素材',
          material_lwn_title: 'LiteMax',
          material_lwn_desc: 'LX Hausysの熱可塑性連続ガラス繊維シート',
          lwn_item1: 'LiteMax PPGF60',
          lwn_desc1: '<p>- ポリプロピレン含浸ガラス繊維シート</p>' +
            '                  <p>- ガラス繊維含有量: 60wt%</p>' +
            '                  <p>- 軽量設計に最適</p>' +
            '                  <p>- 用途 : リアバンパービーム</p>',
          lwn_item2: 'LiteMax PPGF80',
          lwn_desc2: '<p>- ポリプロピレン含浸ガラス繊維シート</p>' +
            '                  <p>- ガラス繊維含有量: 80wt%</p>' +
            '                  <p>- 高い剛性のための高ガラス繊維含有量</p>' +
            '                  <p>- 用途 : バッテリーパックの底パネル</p>',
          lwn_item3: 'LiteMax PAGF60',
          lwn_desc3: '<p>- ポリアミド 6 含浸ガラス繊維シート</p>' +
            '                  <p>- ガラス繊維含有量 : 60wt%</p>' +
            '                  <p>- 優れた耐熱性と耐衝撃性</p>' +
            '                  <p>- 用途 : シートバックフレーム</p>',
          material_lcore_title: 'L-Core Panel',
          material_lcore_desc: '北米では、ファイバーコアを使用した軽量サンドイッチパネルがトレーラーの壁として使用されています。L-コアパネルはHDPEコアパネルよりも軽量で、耐腐食性・弾力性に優れています。',
          lcore_item1: 'HDPE Panel',
          lcore_item2: 'L-Core Panel',
          lcore_thick: '厚み',
          lcore_weight: '単位重量',
          lcore_redu: '減量',
          lcore_resi: '耐腐食性',
          lcore_defo: '荷重前と荷重後の変形',
          lcore_testInfo: '*高温多湿の加速寿命試験に基づく'
        },

        automotive_auto: {
          title: '自動車部品',
          sub_title: '当社は、多様な材料配合で革新的な自動車部品を製造しています。当社の最先端技術はエネルギー効率を向上させ自動車の重量を軽減します。',
          title_description: '自動車の外装や内装に用いられる各種部品',
          point_title1: 'エネルギー効率',
          point_description1: '重量を減らしてエネルギー効率を向上',
          point_title2: '高品質',
          point_description2: '最先端技術による優れた品質',
          point_title3: '優れたデザイン',
          point_description3: '洗練された高級感のあるドライビングスペースを実現',
          ext_eng_title: '外装・エンジン部品',
          exterior_part: '外装部品',
          engine_part: 'エンジン部品',
          exterior_item1: 'ストラクチュアバンパーシステム',
          exterior_desc1: '- フロント、リアバンパーアセンブリ \n' +
            '- 歩行者安全の遵守 \n' +
            '- IIHS、R-Car への準拠',
          exterior_item2: 'サイドシル',
          exterior_desc2: '- 射出成形 + 塗装 \n' +
            '- 成形技術 (電動射出成形)',
          engine_item1: 'シリンダー ヘッド カバー',
          engine_desc1: '- アルミニウムをプラスチックに交換 \n' +
            '- オイル漏れの防止 \n' +
            '- 油水分離システム \n' +
            '- Euro5 法規制の遵守',
          engine_item2: 'エアインテークマニホールド',
          engine_desc2: '- アルミニウムをプラスチックに置き換える \n' +
            '- 可変吸気システム',
          engine_item3: 'トランスミッションオイルパン',
          engine_desc3: '- プラスチックをスチールに置き換える \n' +
            '- オイル漏れの防止 \n' +
            '- オイルを循環させるシステム',
          interior_title: '内装部品',
          interior_desc: '自然な模様の本物の木材で洗練されたデザインを創造',
          inter_detail1: 'SRP (Superfine Real Printing)',
          inter_detail1_desc: '<li>精密な 3D オブジェクト印刷が可能</li>\n' +
            '            <li>優れたリアリズムとテクスチャ効果を実現</li>\n' +
            '            <li>幅広い自動車内装に適用可能</li>\n' +
            '            <li>用途: クラッシュ パッド、ガーニッシュ、コンソール、ステアリング ホイールなど</li>',
          inter_detail2: '本物の素材',
          inter_detail2_desc: '<li>天然木のベニヤとカーボンファイバーによる最高級の美しさ</li>\n' +
            '            <li>高級インテリアパーツのための精巧なクラッシュパッド、ガーニッシュ、コンソール、アームレスト</li>',
          inter_design1: 'SRPデザイン',
          inter_design1_item1: 'Wood',
          inter_design1_item2: 'Fabric',
          inter_design1_item3: 'Geometric, Technical',
          inter_design1_item4: 'Hair line',
          inter_design2: 'Real Materials',
          inter_design2_item1: 'Wood',
          inter_design2_item2: 'Aluminum',
          inter_design2_item3: 'Textile',
          inter_design2_item4: 'Stone',
          inter_design2_item5: 'Carbon'
        },

        SOLID_SURFACE: 'SOLID SURFACE',
        KV_brief: 'The New Generation of Design Inspiration',
        brief: 'HIMACS is composed of minerals, acrylic and natural pigments that come together to provide a durable, smooth, non-porous and visually seamless surface which meets the highest standards for quality, aesthetics, fabrication, functionality and hygiene - offering manifold advantages over conventional materials. HIMACS is durable, it can be shaped by a thermoforming process, and thanks to its huge colour spectrum and translucent properties can help to achieve outstanding and colourful designs. HIMACS uses a simple heating process to give three-dimensional thermoforming capabilities, allows visually seamless designs, offers a virtually limitless range of colours and - for some shades - exhibits a special translucency when exposed to light. Although HIMACS is almost as robust as stone, it can be worked in a similar way as wood: it can be sawn, routed, drilled or sanded. HIMACS is available in sheets of different dimensions and thicknesses. The collection is completed with our range of kitchen sinks, basins, baths and shower trays.',
        photo_credit: 'Photo Credits: Design Marc Fidelle and Andrei David - Paris Airport Engineering and Architectural Management, fabrication : LCCA, photo : Mathieu Ducros',

        Aurora_collection_title: 'AURORA & MARMO',
        Aurora_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        ASTER_collection_title: 'ASTER',
        ASTER_collection_brief: 'Aster is a collection of elegant shades of grey, ranging from almost white to a warm beige, all with a gorgeous mother of pearl shimmer.',

        CONCRETE_collection_title: 'CONCRETE',
        CONCRETE_collection_brief: 'The indusrial look of concrete combined with the incredible flexibility of HI-MACS. The Concrete Collection adds huge opportunities for great designs to architects and designers',

        EXTERIA_collection_title: 'EXTERIA',

        GRANITE_collection_title: 'GRANITE, SPARKLE, QUARTZ, SAND & PEARL',
        GRANITE_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        LUCIA_collection_title: 'LUCIA',
        LUCIA_collection_brief: 'This collection focuses on the natural trend colours black, white and grey. The lively and homogeneous structures add character and expression to the colours. Not surprising, as the renowned Dutch designer, Marcel Wanders, designed three of these colours. (W001, W003, W004)',

        LUCENT_collection_title: 'LUCENT',
        LUCENT_collection_brief: 'The shades of the Lucent Collection, with their exceptional light translucency, allow for spectacular designs. Whether effectively backlit or simply illuminated, the Lucent colours of the architecture always add an elegant touch thanks to their characteristic reaction to light.',

        SOLIDS_collection_title: 'SOLIDS',
        SOLIDS_collection_brief: 'The classic in terms of solid surfaces &ndash; a wide range of attractive shades of white lies at the heart of this collection. Complemented by colourful, dynamic uni-shade accents from Lemon Squash to Festival Pink. The timeless collection offers the perfect colour for every design.',

        STRATO_collection_title: 'STRATO',
        STRATO_collection_brief: 'The marked linear patterns of Strato collection creates geometry through its soft structure and subtle look. The skilful use of the new linear pattern, vertically or horizontally, allows for great variation in each and every project.',

        TERRAZZO_collection_title: 'TERRAZZO',
        TERRAZZO_collection_brief: 'Using a vibrant concrete-base as the canvas for each design, the Terrazzo Collection from HI-MACS offers a vibration of color and patterns that speak to your past, present, and future self in anesthetic. Textured shades, artistic designs, and a touch of modern class, this collection creates a one of a kind experience.',

        ULTRA_collection_title: 'ULTRA',
        ULTRA_collection_brief: 'HIMACS Intense Ultra is based on a brand-new material formulation and combines Intense Colour technology with Ultra-thermoforming. Dark colours become more “intense”, darker and also more resistant, with less visible scratches. The new HIMACS Intense Ultra, also has excellent thermoforming capabilities.',

        VOLCANICS_collection_title: 'VOLCANICS',
        VOLCANICS_collection_brief: 'The large particles of the Volcanics shades add a sense of style to any design. When used on a large scale the result is a dramatic showpiece.',

        Sustainability: 'Sustainability',

        /* US feature benefits TAB */

        TAB_Quality_Design_title: 'Quality Design',
        TAB_Quality_Performance_title: 'Quality Performance',
        TAB_Quality_Fabrication_title: 'Quality Fabrication',
        TAB_Quality_Sustainability_title: 'Quality Sustainability',

        /* END US feature benefits TAB */

        /* US feature benefits - Quality Design - TAB */

        Design_title1: 'Wide Range of Shapes',
        Design_brief1: 'Every option is available to designers to create neat washrooms, kitchens, hospitals and much more with our wide range of HIMACS sinks and bowls. Perfectly coordinated and ideal for mixing and matching, the bowls and sinks guarantee a modern look that is easy ad simple to look after.',

        Design_title2: 'Dramatic Translucency',
        Design_brief2: 'Certain colours and thicknesses of HIMACS exhibit a special translucency when exposed to light.',
        Design_brief2_1: 'Various textures and patterns can be built into the material to intensify the HIMACS translucency effect.',

        Design_title3: '3-Dimensional Design',
        Design_brief3: 'HIMACS boasts a simple heating process and three-dimensional thermoplastic forming capabilities.',
        Design_brief3_1: 'This allows for greater forming flexibility compared with other conventional materials so that spectacular ideas can quickly take on a concrete shape.',

        Design_title4: 'Unlimited Spectrum of Colours',
        Design_brief4: 'HIMACS offers a virtually limitless range of colours in all conceivable shades.',
        Design_brief4_1: 'More are being added every year no matter what colour you choose, HIMACS remains 100% homogeneous.',

        /* END US feature benefits - Quality Design - TAB */

        /* US feature benefits - Quality Performance - TAB */

        Performance_title1: 'Strong',
        Performance_brief1: 'Stronger surface with durability similar to that of natural stone - HIMACS stands up to everyday scratches. Should you accidentally inflict a deeper scratch or surface impression, a trained professional can easily resurface your HIMACS thanks to its sealant-free consistency.',

        Performance_title2: 'Fire Resistant',
        Performance_brief2: 'Backed up with numerous certificates that attest of its fire resistance,',
        Performance_brief2_1: 'HIMACS is ideal for places where security is the number 1 criteria of choice.',

        Performance_title3: 'Hygienic',
        Performance_brief3: 'Thanks to its impermeability to dirt, bacteria, viruses and countless chemicals, HIMACS is the ideal material for the hospital,',
        Performance_brief3_1: 'medical practice or laboratory. And for all other areas where hygiene really counts.',

        Performance_title4: 'Water Resistant',
        Performance_brief4: 'Thanks to its non-porous surface HIMACS is suitable for humid areas where moisture can form such as wet rooms',
        Performance_brief4_1: 'and bathrooms.',

        /* END US feature benefits - Quality Performance - TAB */

        /* US feature benefits - Quality Fabrication - TAB */

        Fabrication_title1: 'Most Advanced Fabrication Technology',
        Fabrication_brief1: 'The material is heated in a progressive tempering process (Thermal Cure). which sets HIMACS apart from other mineral materials and produces a new and stronger compound in which any structural defects are perfectly evened out. This improved structure automatically affects the quality of the material.',

        Fabrication_title2: 'Simple Processing',
        Fabrication_brief2: 'Although HIMACS is almost as robust as stone, it can be worked in the same way as wood. ',
        Fabrication_brief2_1: 'Using conventional carpenter\'s tools, this solid surface material can be sawn, routed or drilled.',

        Fabrication_title3: 'Seamless Perfection',
        Fabrication_brief3: 'HIMACS allows for visually seamless manipulation.',
        Fabrication_brief3_1: 'Smooth integration enables large areas without joints or edges as well as flush mounting of sinks or bowls.',

        /* END US feature benefits - Quality Fabrication - TAB */

        /* US feature benefits - Quality Sustainability - TAB */

        Sustainability_title1: 'Renewable',
        Sustainability_brief1: 'With easy-to-care and repairable properties, no matter if it\'s a scratch, stain or crack,',
        Sustainability_brief1_1: 'HIMACS can be restored to its original state by a certified professional.',

        Sustainability_title2: 'Sustailable',
        Sustainability_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        /* END US feature benefits - Quality Sustainability - TAB */

        /* US certifications TAB */
        certifications_desc_p: '各種認定',
        certifications_desc_m: '各種認定',

        TAB_Environment_title: 'Environment',
        TAB_Fire_Rating_title: 'Fire Rating',
        TAB_HIMACS_Exteria_title: 'HIMACS Exteria Certificates',
        TAB_Hygiene_title: 'Hygiene',
        TAB_Process_title: 'Process',

        /* END US certifications TAB */

        /* US certifications - Environment - TAB */

        Environment_title1: 'Ministry of Environment of the Republic of Korea',
        Environment_brief1: 'designates HIMACS as environmentally-friendly thanks to the demonstration of its commitment to ecological awareness in its product management activities.',

        Environment_title2: 'M1 Emissions Classification',
        Environment_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        Environment_title3: 'Leadership in Energy and Environnemental Design (LEED)',
        Environment_brief3: 'Is a standard voluntary system to certify high performance of buildings, from the US Green Building Council (USGBC). LEED certifies buildings using a credit system. The use of HIMACS contributes toward satisfying EQ Credit for Low-Emitting Materials with the category Indoor Environmental Quality (EQ).',

        Environment_title4: 'ISO 14001',
        Environment_brief4: 'The ISO 14000 family concerns the management of environmental quality. The most popular certificate in this group is ISO 14001. It encourages the minimisation of damage caused by our own activity to the environment and the continuous improvement of environmental performance. The objective is to contribute to protecting and stabilising our planet’s environment. This test certifies that the environment management system of HIMACS conforms to ISO 14001 standards.',

        Environment_title5: 'Greenguard',
        Environment_brief5: 'HI-MACS has been approved by Greenguard in the USA, as a “low emitting product”. The organisation establishes acceptable indoor air standards for indoor products, environments and buildings. The organisation’s goal is to improve public health and quality of life through programs that improve indoor air.',

        Environment_title6: 'Environmental Building Certificate – Grade "outstanding"',
        Environment_brief6: 'The Korean Air Cleaning Association certifies that HIMACS complies with the Korean regulations for environmental building materials.',

        Environment_title7: 'DGNB',
        Environment_brief7: 'The DGNB system, founded by the "German Sustainable Building Council”, evaluates buildings holistically on the basis of individual criteria within the categories Ecological Quality, Economic Quality, Sociocultural and Functional Quality, Technical Quality, Process Quality and Location Quality. Different profiles allow the certification of new buildings and existing buildings, as well as of quarters in Germany and Internationally. Buildings can achieve a certification in Bronze, Silver, Gold and Platinum. HIMACS has an Environmental Product Declaration (EPD), which can be used to calculate the building life cycle assessment (ENV1.1/2.1). Furthermore, HIMACS has achieved Quality Level 4 of 4 in DGNB 2018 criteria for local environmental impact for the entire product.',

        Environment_title8: 'BREEAM (Building Research Establishment Environmental Assessment Method)',
        Environment_brief8: 'BREEAM is the world’s leading sustainability assessment method for masterplanning rojects, infrastructure and buildings. It recognises and reflects the value in higher performing assets across the built environment lifecycle, from new construction to in-use and refurbishment. HIMACS can contribute to BREEAM International New Construction 2016 certification, as the entire product complies with Hea 02 Indoor air quality. Furthermore, HIMACS achieved RSCS summary score level in Mat 03, responsible sourcing of construction products for the entire product: RSCS level 1. “BREEAM is a registered trade mark of the Building Research Establishment Limited, a wholly owned subsidiary of BRE Group Limited, and is used by permission. LX Hausys and its products are not affiliated, endorsed or certified by BRE Global Limited, which is the operator of BREEAM, or any other subsidiary of BRE Group Limited. All rights are reserved.”',

        /* END US certifications - Environment - TAB */

        /* US certifications - Fire Rating - TAB */

        Fire_Rating_title1: 'Norm NFP 92-501 Class M1',
        Fire_Rating_brief1: 'LNE tests the reactivity to fire of a material. Class M1 certifies that HIMACS FR benefits from advanced resistance to fire. This certificate is recommended in France.',

        Fire_Rating_title2: 'Norm EN 45 545 Class R1 HZL3',
        Fire_Rating_brief2: 'Fire protection on railway vehicles: The measures and requirements specified in EN 45 545 are intended to protect passengers and staff in railway vehicles in the event of a fire on board. HIMACS has achieved the highest and best performance R1 HZL3 (Hazard Level). Valid for Alpine White S728.',

        Fire_Rating_title3: 'Norm EN 13501 - Class B-s1, d0',
        Fire_Rating_brief3: 'HIMACS successfully passed the European test EN 13501 – Class B-s1, d0, equivalent to the class 0 from Warrington Fire certification.',

        Fire_Rating_title4: 'Norm DIN 4102-1 - Class B1',
        Fire_Rating_brief4: 'Class B1 certifies that HIMACS has a low flammability. B1 class is the European fire resistance requirement. This test result is valid for all colour ranges in 12mm.',

        /* END US certifications - Fire Rating - TAB */

        /* US certifications - Exteria Certificates - TAB */

        Exteria_title1: 'IMO MED – Modules B and D',
        Exteria_brief1: 'MED stands for Marine Equipment Directive. Both modules are extremely important for the shipbuilding industry, as they are mandatory for fabrication materials used in ships. IMO B covers the fire resistance of the material per se and certifies that the material has low flame spread characteristics and is not capable of producing excessive quantities of smoke and toxic combustion products. Module D covers the overall production capacity and checks, among other production processes, the management and systems used.',

        Exteria_title2: 'ETA',
        Exteria_brief2: 'Fixed with Keil inserts and a BWM structure, HIMACS facade in S728 - Alpine White successfully passed the ETA tests (European Technical Agreement).',

        Exteria_title3: 'CSTB Certification',
        Exteria_brief3: 'HIMACS has obtained the French QB certification and CSTB ATec “Avis Technique” for facade applications (Avis Technique 2.2/18-1795_V1).',

        /* END US certifications - Exteria Certificates - TAB */

        /* US certifications - Hygiene - TAB */

        Hygiene_title1: 'NSF',
        Hygiene_brief1: 'NSF standards are generally accepted norms for a variety of public health related industries and fields. These include drinking water treatment and contact with materials, food equipment manufacturing etc. NSF recognises that HIMACS complies with NSF norms.',

        Hygiene_title2: 'LGA',
        Hygiene_brief2: 'Necessary in hospitals and environments where hygiene is critical, LGA assesses the ease of cleaning, resistance to bacteria and fungi and rates the design from a hygiene point of view. Thanks to its non-porosity, HIMACS has been approved for the LGA seal “hygiene tested”.',

        /* END US certifications - Hygiene - TAB */

        /* US certifications - Process - TAB */

        Process_title1: 'OHSAS 18001',
        Process_brief1: 'OHSAS 18001, Occupational Health and Safety Assessment Series, (officially BS OHSAS 18001) is a British Standard for occupational health and safety management systems. Compliance with it enables organizations to demonstrate that they have a system in place for occupational health and safety.',

        Process_title2: 'ISO 9001',
        Process_brief2: 'ISO 9001 criteria can guarantee the following points:',
        Process_brief3: 'The whole fabrication process, ensuring a good product quality',
        Process_brief4: 'Quality control, with an appropriate corrective procedure, when needed and regular control of quality control procedures.',
        Process_brief5: 'Process, which aims to continuously improve global efficiency',

        /* END US certifications - Process - TAB */

        /* US sustainbility - TAB */

        sustainbility_title1: 'Shaping the Future in Harmony with the Environment',
        sustainbility_brief1: 'Countless internationally recognized certificates attest to the fact that HIMACS has a strong focus on ecological aspects. Without exception, all HIMACS products are manufactured in accordance with the ISO 14001 environmental standard.',

        TAB_Commitment_title: 'Commitment',
        TAB_Material_Safety_title: 'Material Safety',
        TAB_Manufacturing_title: 'Manufacturing',
        TAB_Processing_title: 'Processing',
        TAB_Transport_title: 'Transport',

        /* END US sustainbility - TAB */

        /* US sustainbility - Commitment - TAB */

        Commitment_title1: 'Commitment',
        Commitment_brief1: 'LX Hausys conducts and publishes regular environmental audits along with energy consumption analyses. Thanks to the use of non-polluting fuels, greenhouse gas emissions have been cut by 15,000 tons per year since 2008.',

        /* END US sustainbility - Commitment - TAB */

        /* US sustainbility - Material Safety - TAB */

        Material_Safety_title1: 'Material Safety',
        Material_Safety_brief1: 'Extensive studies – within LX Hausys’ own laboratories as well as tests carried out by other renowned independent institutions – have shown that the HIMACS material itself, as well as the cured adhesive, are completely free from formaldehyde and emissions. HIMACS has been awarded the Greenguard Gold Indoor Air Quality Certificate.',

        /* END US sustainbility - Material Safety - TAB */

        /* US sustainbility - Manufacturing - TAB */

        Manufacturing_title1: 'Manufacturing',
        Manufacturing_brief1: 'The production of this solid surface material is marked by an excellent energy balance. In recent years, the company was very successful in achieving ambitious goals in terms of waste reduction and water conservation. In addition, HIMACS plants in Cheongju (Korea) and Atlanta (USA) meet all environmental standards.',

        /* END US sustainbility - Manufacturing - TAB */

        /* US sustainbility - Processing - TAB */

        Processing_title1: 'Processing',
        Processing_brief1: 'The material allows for virtually waste-free processing. In addition, HIMACS installations are extremely strong and durable. They can easily be renewed to their original appearance, meaning they don’t have to be replaced, thus giving a positive long-term  environmental footprint.',

        /* END US sustainbility - Processing - TAB */

        /* US sustainbility - Transport - TAB */

        Transport_title1: 'Transport',
        Transport_brief1: 'Within Europe, HIMACS observes the Euro-5 standards for reduced particulate emissions. The partner-network of LX Hausys Europe consists of carefully selected partners with the highest environmental standards: for example, the State-of-the-Art logistics centre in the Netherlands is one of the first buildings to have been constructed in accordance with the WELL Building Standards and awarded the BREEAM Certificate. This means that it meets the highest requirements for environmentally friendly and healthy construction. '

        /* END US sustainbility - Transport - TAB */

      }, // End of PCD - text

      alert: {
        loginLike: 'Log in to save to your Likes'
      }, // End of PCD - alert

      button: {
        seeMore: 'See More',
        see_all: 'すべてのデザインを見る',
        learnMore: 'Learn more',
        explore_collection: 'コレクションを見る',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        close: 'close',
        find_a_sales_rep: 'Find a Sales Rep',
        btn_sustainbility_brochure: 'Download Sustainability Brochure',

        English: 'English',
        German: 'German',
        French: 'French',
        Italian: 'Italian',
        Spanish: 'Spanish',
        Dutch: 'Dutch',
        EnglishUK: 'English (UK)'

      }, // End of PCD - button

      popup: {
        /* Edge Profiles 시작 점 */
        edge_title: 'Viatera Edge Profile',
        edge_brief: 'Where quartz meets the edge. LX Hausys Surfaces offers a wide selection of edge treatments.' +
          '                    Select from a simple rounded corner to the complex multi-toned,' +
          '                    multi-tiered rolling edges that add that special finishing touch to your solid surface counter.' +
          '                    For more information on our edge treatments, please consult your local area distributor or' +
          '                    fabricator.',

        beveled_Edge: 'Beveled Edge',
        beveled_Edge_brief: 'Maintains the surface’s thickness,\n' +
          '                    but with a ¼” or ½” angular top edge.',
        bullnose_Edge: 'Bullnose Edge',
        bullnose_Edge_brief: 'A completed rounded edge.',

        eased_Edge: 'Eased Edge',
        eased_Edge_brief: 'A slightly rounded top edge that still\n' +
          "                    maintains the surface's thickness.",

        ellipse_Edge: 'Ellipse Edge',
        ellipse_Edge_brief: 'Rounded top and bottom edges\n' +
          '                    with a flat face.',

        knife_Edge: 'Knife Edge',
        knife_Edge_brief: 'A sharp, blade-like edge.',

        reverse_Ogee_Edge: 'Reverse Ogee Edge',
        reverse_Ogee_Edge_brief: 'Similar to Roman Edge, but reversed.',

        roman_Edge: 'Roman Edge',
        roman_Edge_brief: 'An elaborate ogee-style edge design\n' +
          '                    inspired by Roman architecture.',

        roundover_Edge: 'Roundover Edge',
        roundover_Edge_brief: 'A semi-circle rounded top edge.',

        /* Edge Profiles 끝 */

        /* Finish 시작 점 */
        finishInfo: 'Finish guide',
        finishTitle: 'Introducing New Viatera Finish Brushed',
        finishBrief: 'Select Viatera colors are now available with a “Brushed” finish to fulfill a wider range of aesthetics.\n' +
          '                  Enjoy the new classic beauty with a satin-like finish.',
        polished: 'POLISHED',
        polished_brief: 'Traditional reflective surface',

        brushed: 'BRUSHED',
        brushed_brief: 'Soft and smooth feel with\n' +
          '                    low-luster on the surface',

        leather: 'Leather',
        leather_brief: 'Leather finish has a slightly more matte texture than a polished finish, and makes you feel the soft touch of the leather.',

        velvet_Touch: 'Velvet Touch',
        velvet_Touch_brief: 'Velvet touch finish enables you to feel the texture of nature with the feeling of stone dents.',

        finish_viatera: 'Viatera',
        finish_viatera_info: 'Brushed Finish Care & Maintenance',
        finish_viatera_brief: 'Viatera products with Brushed Finish are the same as those with the standard Polished Finish.\n' +
          '                  The only manufacturing difference is how the final gloss level is achieved.',

        finish_viatera_brief_01: 'Brushed Finish may need more daily attention than Polished Finish. This is the nature of any material with a matte finish when compared to the same material\n' +
          '                  with a polished finish – smudges, fingerprints, and water spots are simply more visible on a matte surface. Promptly wipe up and buff dry routine spills, droplets,\n' +
          '                  and rings. A microfiber towel may be more effective than a paper towel because Brushed Finish has a slight surface texture when compared to Polished Finish.\n' +
          '                  These non-woven cleaning products work well on all surfaces and are especially helpful on products that feature anything other than a perfectly smooth surface.',

        finish_viatera_brief_02: 'Routine Care and Maintenance of Brushed Finish is easy with the same liquid household cleaners that are suitable for “Polished” finishes, including Formula 409\n' +
          '                  Natural Stone & Steel Cleaner.',

        finish_viatera_brief_03: 'Always read and follow that manufacturer’s label instructions. A textured sponge that’s suitable for non-stick coated cookware may be helpful in removing some\n' +
          '                  tougher spills. Avoid using abrasive cleaners like Ajax or Comet, as these more aggressive materials may dull or damage the surface of Brushed Finish.\n' +
          '                  After using any cleaning product always rinse the area and buff the area dry. A microfiber product is suggested but not required.'

        /* Finish 끝 */

      } // End of PCD - popup
    }, // End of PCD

    PD: {
      text: {
        new: 'NEW',
        coming: 'Coming soon',
        discontinued_Color: 'Discontinued Color',
        image_enlarged_view: 'IMAGE ENLARGED VIEW',
        image_download_view: 'IMAGE DOWNLOAD VIEW',
        finish: 'Finish',
        finishGuide: 'Finish guide',
        color: 'Color',
        product_Specs: '製品仕様',
        product_type: 'Product Type',
        total_thickness: 'Total Thickness',
        wear_layer: 'Wear Layer',
        dimension: 'Dimensions',
        dimension1: 'Dimension &',
        weight: 'Weight',
        remark: 'Remark',
        pattern: 'Pattern',
        emboss: 'Emboss',
        installation: 'Installation',
        adhesive_code: 'Adhesive Code',
        adhesive_name: 'Adhesive Name',
        available_Countries: 'Available Countries',
        related_Products: '関連製品',
        features_Benefits: 'Features & Benefits',
        certifications: 'Certifications',
        documentation_technical_details: '参考資料と技術詳細',
        fabrication: '加工マニュアル',
        test_report: '試験成績書',
        care_maintenance: 'メンテナンス',
        catalogue: 'カタログ',
        certification: '各種認証',
        technical_datasheet: '技術資料',
        installation_guide: '施工ガイド',
        warranty: '品質保証',
        edge_profile: 'Edge Profile',
        inspiration: 'Inspiration',
        standard: 'Standard',
        image_viewer: 'For illustration purposes only. Image size:',
        in: 'in',
        zoom_out: 'zoom Out',
        zoom_in: 'zoom In',
        Thickness: 'Thickness',
        Use: 'Use',
        Pattern: 'Pattern',
        Notice: 'Notice',
        Notice_brief: 'Less suitable for surfaces which are subject to high traffic, due to their higher pigmented colour saturation, marks may be seen more easily.',
        Semi_Translucent: 'Semi-Translucent colour',
        Semi_Translucent_brief: 'Colours with this mark have a semi-translucent effect, evident when combined with light sources',
        Outdoor: 'Outdoor',
        Outdoor_brief: 'Suitable for exterior use. Please check conditions about level of suitability and warranty per colour. Indoor, Suitable for Kitchen & Bathroom',
        Recycled: 'Recycled',
        Recycled_brief: 'Certified to contain pre-consumer recycled content. Minimum',
        Designer: 'Designer Series',
        Designer_brief: 'Designed by Marcel Wanders',
        Lucent: 'Lucent',
        Lucent_brief: 'Lucent colours have a higher level of translucency, more evident when combined with light source. Translucent colour',
        Veined: 'Veined',
        Veined_brief: 'As Marmo is a randomly veined product, specific fabrication guidelines need to be followed.',
        construct: '構造',
        news_letter: 'ニュースレターにご登録ください。',
        news_letter_desc: '革新的なプロジェクト、独自のカラー、最新のニュースやトレンド情報をお届けします。',
        subscribe: 'Subscribe',
      }, // End of PD - text

      button: {
        virtual_Showroom: 'Virtual Showroom',
        prev: 'Prev',
        next: 'Next',
        list_view: 'list view',
        download: 'download',
        see_all_documentation: 'See All Documentation',
        see_all_case_studies: 'See All Case Studies',
        see_more: 'See More'

      } // End of PD - button

    }, // End of PD

    PF: {
      text: {
        category: 'CATEGORY',
        luxury_vinyl_tile: 'ラグジュアリービニルタイル',
        looselay: 'ルーズレイフローリング',
        homogeneous_sheet: '単層床シート',
        heterogeneous_sheet: '複層床シート',
        specialty: '機能性床シート',
        home: 'Home',
        filter_by: 'Filter By',
        patterns: '柄',
        country: 'Country',
        new: 'New',
        new_a: 'NEW',
        coming: 'Coming soon',
        new_colors: 'NEW COLORS',
        product_type: 'Product Type',
        thickness: '厚さ（インチ）',
        weight: '重量(kg)',
        finish: '表面仕上げ',
        wear_layer: '摩耗層',
        dimension: '寸法 (mm)',
        searchText: 'アイテム番号または名前を入力してください',
        Tones: 'Tones',
        Use: 'Use',
        Recycled: 'Recycled',
        Thickness: '厚さ',
        himacs: 'HIMACS',
        borte: 'BORTE',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        exteriorfilm: 'EXTERIOR Film',
        decofilm: 'DECO Film',
        teracanto: 'TERACANTO',
        benif: 'BENIF',
        vizuon_a: 'VIZUON',
        lvt: '塩化ビニル床タイル',
        los: '置き敷きタイル',
        spc: 'SPCタイル',
        hom: '単層床シート',
        het: '複層床シート',
        spt: '機能性床シート',
        installation: '施工',
        results: '結果',
        no_search_result: '結果が見つかりませんでした。',
        no_compare_item: '比較するアイテムはありません',
        no_option: 'オプションを選択してください',
        color: '色',
        key_visual_desc: {
          all_colors: 'ソリッドサーフェスからポーセリン、工業用フィルム、弾性フローリングまで、<br>' +
            'あらゆるプロジェクトに最適なカラーとデザインをお選びいただけます。<br>' +
            'LX Hausysは、幅広いカラーバリエーション、仕上げ、質感を通じて、<br>' +
            '多様な空間演出の可能性を提供します。',

          hflor_color: 'HFLORが提案する多彩なレジリエントフローリングの世界を体感してください。<br>' +
            'LVTやビニルシートなど、多様なカラーとパターンが、<br>' +
            'あらゆる空間に新しいデザインの可能性をもたらします。',

          himacs_color: 'HIMACSは、商業施設から住宅空間まで、あらゆるシーンに適したソリッドサーフェスです。<br>' +
            '無限のカラーとデザインの組み合わせにより、<br>' +
            '空間デザインの新たな可能性を切り拓きます。',

          teracanto_color: '自然の美しさを最大限に引き出すTERACANTOポーセリンサーフェス。<br>' +
            '豊富なカラーとパターンバリエーションで、<br>' +
            '自然と技術が調和する唯一無二の空間を創り出します。',

          deco_color: '家具・内装デザインの新たな可能性を拓くLX Hausys Deco Film。<br>' +
            '多彩なカラーとパターンで、空間に洗練された美しさと個性を与えます。',

          exterior_color: '建築外装を彩るLX Hausys Exterior Film。<br>' +
            '紫外線・湿気・外的要因に対して高い耐久性を持ち、<br>' +
            '長期間にわたって美しさと機能性を維持します。',

          vizuon_color: 'Explore the full VIZUON collection of LX Hausys Sign & Graphic Film, designed to bring your ideas to life with vibrant visual imagery and easy application. <br>' +
            'Scroll through our wide range of solutions, perfectly suited for Vehicles and Transportation, large Signs and Displays, detailed Illuminated Signs, and custom Architectural projects. <br>' +
            'Discover available colors and styles, including our Eco Solutions and comprehensive Corporate Branding options, to find the ideal match for your visual needs.',

          default_desc: '',
        },
        compare: {
          viatera: 'VIATERA 製品を比較する',
          hflor: 'HFLOR 製品を比較する',
          teracanto: 'TERACANTO 製品を比較する',
          himacs: 'HIMACS 製品を比較する',
          vizuon_a: 'VIZUON 製品を比較する',
          exteriorfilm: 'Exterior Film 製品を比較する',
          decofilm: 'Deco Film 製品を比較する'
        },
        compare_full: {
          text: 'Do you want to replace the first Products <br>' +
            'you added by the one you selected?',
          footer: 'Edit products in compare'
        },
        slab_size: '板サイズ(インチ)',
        bookmatch: 'ブックマッチング',
        remark: '備考',
        allColors: {
          himacs: 'すべての柄',
          hflor: 'すべての柄',
          viatera: 'すべての柄',
          exteriorfilm: 'すべての柄',
          decofilm: 'すべての柄',
          teracanto: 'すべての柄',
          benif: 'すべての柄',
          vizuon_a: 'すべての柄',
          borte: 'すべての柄',
          himacs_ac: 'HIMACS',
          hflor_ac: 'HFLOR',
          viatera_ac: 'VIATERA',
          exteriorfilm_ac: 'EXTERIOR Film',
          decofilm_ac: 'DECO Film',
          borte_ac: 'BORTE',
          teracanto_ac: 'TERACANTO',
          benif_ac: 'BENIF',
          vizuon_ac: 'VIZUON',
          products: '製品情報',
          all_colors: 'すべての柄',
          filter: 'フィルター',
          filter_by: 'フィルター',
          brand: 'ブランド',
          color: '色',
          searchText: 'アイテム番号または名前を入力してください',
          results: '結果',
          no_result: '結果が見つかりませんでした。',
          no_result_text: 'If you do not find what you are looking for, please try different search terms or filters.',
          apply: '適用する',
          clear_all: 'すべてクリア',
          clear_all2: 'すべてクリア',
          products_a_to_z: '製品AからZまで',
          products_z_to_a: '製品ZからAまで',
          new_products_first: '最新の',
          your_compare_is_full: 'Your compare is full',
          new: 'NEW',
          new_a: 'NEW',
          brandLabel: 'ブランド',
          colorLabel: '色',
          white: '白',
          cream: 'クリーム',
          beige: 'ベージュ',
          brown: 'ブラウン',
          gray: 'グレー',
          black: '黒',
          green: 'グリーン',
          blue: 'ブルー',
          pink: 'ピンク',
          purple: '紫',
          ivory: 'Ivory',
          orange: 'Orange',
          red: 'Red'
        }
      }, // End of PF - text
      filter: {
        filter_by: 'フィルター',
        vizuon: 'VIZUON',
        vt: 'カーラッピング用',
        sd: '看板用',
        is: '照明用',
        ar: '建築用',
        es: 'エコソリューション',
        cb: '企業ブランディング',
        feature: 'FEATURE',
        country: 'COUNTRY',
        compare: '比較する',
        bookmatch: 'BOOKMATCH',
        application: 'APPLICATION',
        weatherability: 'WEATHERABILITY',
        remark: 'REMARK',
        hflor: 'HFLOR',
        pet: 'PET',
        installation: 'INSTALLATION',
        productType: 'PRODUCT TYPE',
        filter: 'FILTER',
        color: '色',
        collection: 'コレクション',
        patterns: 'パターン',
        finish: '仕上げ',
        recycled: 'リサイクル',
        thickness: '厚さ',
        format: '型式',
        wearlayer: 'ウェアレイヤー',
        dimensions: '寸法',
        prdtype: '設置', // installation
        adhesivetype: '粘着タイプ',
        productclassification: '製品分類',
        airfree: 'エアフリー',
        solidcolor: '単色',
        solidPatterns: 'ソリッドパターン',
        stoneColor: 'ストーンの色',
        metalColor: 'メタルカラー',
        woodColor: '木の色',
        metalPattern: 'メタルパターン',
        woodPattern: '木目柄',
        stonePattern: 'ストーン柄',
        pvc: '塩ビ',
        petFurnitureFilm: 'PET家具フィルム',
        acrylicFurnitureFilm: 'アクリル家具フィルム',
        woodSpecies: '木材の種類',
        new: 'NEW',
        slabsize: '板サイズ(インチ)',
        prestgSpcClick: 'PRESTG SPC クリック',
        decolay: 'デコレ―',
        origin: 'オリジン',
        leisure: 'レジェ―',
        celestial: '天体',
        space: 'スペース',
        stone: 'ストーン',
        rexcourt: 'Rexcourt',
        unite: 'ユナイト',
        abc: 'ABC',
        originConductive: 'オリジン導電性',
        supreme20: 'シュプリーム2.0',
        atmosphere: '雰囲気',
        style: 'スタイル',
        durable: '耐久性のある',
        medistudio: 'メディスタジオ',
        palace: 'パレス',
        bright: 'ブライト',
        supreme18: 'シュプリーム1.8',
        delight: 'ディライト',
        calmpasso: 'カームパッソ',
        comfort: 'コンフォート',
        senior: 'シニア',
        eqFloor: 'EQフロア',
        wood: 'ウッド',
        familia: 'ファミリア',
        mini: 'ミニ',
        trendy: 'トレンディ',
        textileCollection: 'テキスタイルコレクション',
        signatureWood: 'シグネチャー',
        prestgGluedownLvt: 'PRESTGグルーダウン (LVT)',
        prestgGluedownSpc: 'PRESTGグルーダウン (SPC)',
        decotilePlank: 'デコタイルプランク',
        decotileTile: 'デコタイルタイル',
        category: 'CATEGORY',
        type: 'TYPE'
      },
      updateFilter: {
        color: '色'
      },
      removeFilter: {
        color: '色'
      },
      popup: {
        filter_by: 'フィルター',
        your_compare_is_full: 'Your compare is full',
        compare_tool: 'Compare tool',
        compare_alert1: 'Do you want to replace the first product',
        compare_alert2: 'you added by the one you selected?',
        edit_products_in_compare: 'EDIT PRODUCTS IN COMPARE',
        replace: 'REPLACE',
        close: 'close',
        characteristics_technical_performance: '特性と技術的性能',
        pvc: '塩ビ',
        acrylic: 'アクリル',
        adhesive_type: '粘着タイプ',
        adhesive_code: '粘着コード',
        adhesive_name: '接着剤名',
        air_free: 'エアフリー',
        film_type: 'フィルムタイプ',
        material: '材質',
        liner: '剝離紙',
        width: '幅',
        grade: 'グレード',
        length: '長さ',
        thickness: '厚さ'
      },
      button: {
        all: 'All',
        lux: '塩化ビニル床タイル',
        hom: '単層床シート',
        het: '複層床シート',
        spt: '機能性床シート',
        compare: '比較する',
        compare_your_colors: '色を比較する',
        remove: 'Remove',
        add_more: 'さらに追加',
        search: '検索',
        color: '色',
        collection: 'コレクション',
        patterns: 'パターン',
        finish: 'Finish',
        country: 'Country',
        new: 'New',
        coming: 'Coming soon',
        all_products: 'All products',
        grouped_by_collections: 'Grouped by collections',
        filter_by: 'Filter By',
        products_a_to_z: '製品AからZまで',
        products_z_to_a: '製品ZからAまで',
        new_products_first: '最新の',
        clear_all: 'すべてクリア',
        load_more: 'さらに読み込む',
        see_all_colors: 'See all colors',
        download: 'ダウンロード',
        Popularity: 'Popularity',
        lvt: 'ラグジュアリービニルタイル',
        los: 'ルーズレイフローリング',
        spc: 'SPCタイル',
        compare_on: 'オン',
        most_recent: '最新の',
        filter: 'フィルター',
        apply: '適用する'
      } // End of PF - button
    }, // End of PF
    other: {
      text: {
        sales_rep: 'Find a Sales Rep',
        showroom: 'Virtual Showroom',
        home: 'Home',
        products: 'Products',
        viatera: 'VIATERA',
        himacs: 'HIMACS',
        hotherPD: 'HIMACS Sinks',
        votherPD: 'VIATERA Sinks',
        overall: 'Overall Dimensions',
        inner: 'Inner Dimensions',
        contactus: 'Contact Us',
        close: 'close',
        arctic: 'Arctic White',
        ivory: 'Ivory White',
        cream: 'Cream',
        almond: 'Almond',
        all: 'All',
        kitchen: 'Kitchen',
        bathroom: 'Bathroom',
        ada: 'ADA Compliance',
        himacs_sink_banner_desc: 'Explore the complete line of HIMACS vanity and kitchen sinks designed for superior aesthetics and functionality.<br>' +
          'Every HIMACS solid surface sink is engineered to be seamlessly integrated with a HIMACS countertop,<br>' +
          'providing a beautifully smooth, clean, and well-designed surface.',
        viatera_sink_banner_desc: 'Discover the Lovello™ stainless steel sink collection, designed to perfectly complement VIATERA Quartz Countertops.<br>' +
          'These high-quality sinks offer unique styling to enhance any kitchen or vanity,<br>' +
          'providing the ideal finishing touch when paired with your VIATERA surface.'
      },
      button: {
        learn_more: 'もっと詳しく知る',
        view_more: '続きを見る',
        load_more: 'もっと見る',
        certi_more: 'もっと詳しく知る'
      }
    }
  }, // End of JP

  CN: {
    PCD: {
      text: {
        home: 'Home',
        contact_us: 'Contact Us',
        products: '产品介绍',
        himacs: 'HIMACS',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        teracanto: 'TERACANTO',
        vizuonsigngraphic: 'VIZUON',
        himacssolidsurface: 'HIMACS',
        viateraquartzsurface: 'VIATERA',
        teracantoporcelainsurface: 'TERACANTO',
        benifarchitecturalfilm: 'BENIF',
        decofilm: 'Deco Film',
        exteriorfilm: 'Exterior Film',
        bortepanel: 'About BORTE',
        home_film: 'Home Appliance Surface Film',
        automotive: 'Automotive',
        sub: {
          lvt: 'Luxury Vinyl Tile',
          los: 'Looselay',
          spc: 'SPC Tile(Click)',
          homo: 'Homogeneous Sheet',
          het: 'Heterogeneous Sheet',
          spt: 'Specialty',
          veh: 'Vehicles and Transportation',
          sd: 'Signs and Displays',
          illum: 'Illuminated Sign',
          arch: 'Architecture',
          eco: 'Eco Solutions',
          corp: 'Corporate Branding'
        },
        vizuon_a: 'VIZUON',
        about: {
          himacs: '关于 HIMACS',
          hflor: '关于 HFLOR',
          viatera: '关于 VIATERA',
          teracanto: '关于 TERACANTO',
          deco: '关于 Deco Film',
          exterior: '关于 Exterior Film',
          benif: '关于 BENIF',
          vizuon_a: '关于 VIZUON',
          home_film: '关于家电膜',
          automotive: {
            vegan_leather: '人造皮革',
            light_comm: '轻量化零部件',
            auto_comm: '汽车零部件'
          }
        },
        featured_products: 'Featured Products',
        cart: 'cart',
        wish_list: 'wish list',
        new: 'New',
        coming: 'Coming soon',
        collection: 'Collection',
        explore_collection: 'Explore Collection',
        online_book: 'Online Book',
        load_more: '加载更多',
        certi_more: 'What These Certifications Mean',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        awards: 'Awards',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        order_a_sample: 'Order a Sample',
        documentation: 'Documentation',
        care_maintenance: 'Care & Maintenance',
        warranty: 'Warranty',
        where_to_buy: 'Where to buy',

        home_app_film: {
          title: '家电膜',
          title_description: '钢板覆膜表面处理材料, 适用于家用电器, UBR和电梯。',
          intro1: 'LX Hausys家电膜是一种高品质的表面材料，具有多种颜色和图案，适用于冰箱、洗衣机和小型家电等。',
          intro2: '我们的产品被多家全球知名家电公司所选择，因为它具有出色的抗污染、抗划伤和防腐特性',
          point_title1: '顾客定制设计方案',
          point_description1: '根据对全球趋势的研究，为当地客户定制设计方案及开发的能力在世界各地得到了认可，特别是在印度、美国、中国、东南亚和欧洲等国家和地区',
          point_title2: '全球第一',
          point_description2: '作为全球主要家电公司的合作伙伴，LX Hausys在家电膜市场份额中保持第一。',
          point_title3: '卓越的品质',
          point_description3: 'LX Hausys为客户提供耐指纹、抗污染、防刮擦和高伸长率的产品，使顾客能够长时间完美使用家用电器。',
          construction: '结构',
          construction_film1: 'Metallic Film',
          film1_item1: 'Eco PET',
          film1_item1_desc: 'PET基层上印刷金属纹理，也可以增加珠光效果。',
          film1_item2: 'Metalon',
          film1_item2_desc: '金属化处理呈现逼真的金属质感效果。',
          film1_item3: 'SUS Film',
          film1_item3_desc: '压花拉丝技术能够提供个性化定制图案服务，包括横向水平拉丝，从而实现与STS完全相同的金属效果。',
          construction_film2: '珍珠 & 花色膜',
          film2_item1: 'Hi-Gloss',
          film2_item1_desc: '通过精确的打印和颜色组合，实现各种图案和颜色的表达。',
          film2_item2: 'Galaxy',
          film2_item2_desc: '各种珠光效果将使表面细腻闪亮。',
          film2_item3: 'Soft-matte',
          film2_item3_desc: '柔光哑光膜可定制图案或呈现多种颜色。',
          application: '应用',
          application_sub_title: '家电膜',
          application_item1: 'Pastel Metal',
          application_item2: 'Soft Matte',
          application_item3: '横向水平拉丝(银色,短拉丝)',
          application_item4: '横向水平拉丝(黑色)',
          application_item5: '铱拉丝',
          application_item6: '横向水平拉丝(深灰色)',
          application_item7: '玻璃纤维',
          application_item8: '横向水平拉丝(银色,长拉丝)'
        },

        automotive_skin: {
          title: '人造皮革',
          sub_title: 'Sustainable & Innovative',
          title_description: '可持续产品，环境创新技术',
          intro: '是各种汽车应用的主要内饰供应商。凭借我们先进的技术和创新设计，能够为您提供全面的内饰解决方案，让您的车辆装饰超出您的预期。',
          point_title1: '安全规范',
          point_description1: 'STANDARD 100 by OEKO-TEX®鉴定产品已通过有害物质检测，以保护您的健康（绿色标签）',
          point_title2: '可持续材料',
          point_description2: '通过使用生物基和可回收材料（生物/生态标签）实现可持续发展',
          seat_cover: '座套',
          seat_cover_desc: 'LX Hausys汽车蒙皮通过创新设计及我们一流的技术，为室内驾驶空间带来激动人心的品质。',
          cover_item1: 'SOFINO®',
          cover_item2: 'VERNO®',
          cover_item3: 'Calfpelle®',
          cover_item4: 'LUSSINO™',
          sofino_item1: 'SOFINO® Green',
          sofino_desc1: '符合OEKO-TEX®Standard 100的1级标准，该标准证明该材料对婴儿和幼儿是安全的',
          sofino_item2: 'SOFINO® Bio',
          sofino_desc2: '<span>利用生物基填充材料开发生物皮革</span>' +
            '        <br />' +
            '        <span>（例如红麻、桉树等）</span>',
          sofino_item3: 'SOFINO® Eco',
          sofino_desc3: ' <span>• RCS (Recycled Claim Standard) 认证</span>' +
            '        <br />' +
            '        <span>• 可回收含量35% (可回收聚酯纤维)</span>',
          sofino_anno: '<span>1）OEKO-TEX®Standard 100 1级限值(婴儿产品)</span>' +
            '      <br />' +
            '      <span>• NMP (1-甲基-2-吡咯烷酮), DMF(二甲基甲酰胺) 溶剂残留 ≤0.05 wt%</span>' +
            '      <br />' +
            '      <span>• 邻苯二甲酸酯总量≤0.05 wt%</span>' +
            '      <br />' +
            '      <span class="spacing">(DBP, BBP, DEP, DMP, DEHP, DEMP, DIHP, DHNUP, DHxP, DIDP, DPrP, DHP, DNOP, DNP, DPP)</span>' +
            '      <br />' +
            '      <span>• 不含任何禁用的阻燃物质</span>' +
            '      <br />' +
            '      <span class="spacing">(例如, 多溴联苯醚, 三氧化二锑)</span>' +
            '      <br />',
          verno_item1: 'VERNO® Green',
          verno_desc1: '符合OEKO-TEX®Standard 100的1级标准，该标准证明该材料对婴儿和幼儿是安全的',
          verno_item2: 'VERNO® Bio',
          verno_desc2: '<span>• UL环境声明认证-生物基含量物解决方案</span>' +
            '        <br />' +
            '        <span>• 生物基含量≥19%</span>',
          verno_item3: 'VERNO® Eco',
          verno_desc3: '<span>• RCS (Recycled Claim Standard) 认证</span>' +
            '        <br />' +
            '        <span>• 可回收含量50% (可回收聚酯纤维)</span>',
          verno_anno: '<span>1）OEKO-TEX®Standard 100 1及限值 (婴儿产品)</span>' +
            '      <br />' +
            '      <span>• NMP (1-甲基-2-吡咯烷酮), DMF(二甲基甲酰胺) 溶剂残留≤0.05 wt%</span>' +
            '      <br />' +
            '      <span>• 邻苯二甲酸酯总量≤0.05 wt%</span>' +
            '      <br />' +
            '      <span class="spacing">(DBP, BBP, DEP, DMP, DEHP, DEMP, DIHP, DHNUP, DHxP, DIDP, DPrP, DHP, DNOP, DNP, DPP)</span>' +
            '      <br />' +
            '      <span>• 不含任何禁用的阻燃物质</span>' +
            '      <br />' +
            '      <span class="spacing">(例如, 多溴联苯醚, 三氧化二锑)</span>' +
            '      <br />',
          calfpelle_item1: 'Calfpelle®',
          calfpelle_desc1: '<span>• 绒面革, 表面质量极佳</span>' +
            '        <br />' +
            '        <span>• 触感柔软, 经久耐用</span>',
          calfpelle_item2: 'Calfpelle® Bio',
          calfpelle_desc2: '<span>• UL环境声明认证-生物基含量物解决方案\n</span>' +
            '        <br />' +
            '        <span>• 生物基含量≥10%</span>',
          lussino_item1: 'LUSSINO™',
          lussino_desc1: '<span>• [最高级]高性能及可持续的硅基皮革</span>' +
            '        <br />' +
            '        <span>• 硅基材料的成分 (面漆, 蒙皮, 粘合剂)</span>',
          design_area: '设计',
          design_area_desc: 'LX Hausys开发的汽车面料不仅提供极高品质, 还研究开发与车辆概念相匹配的表面纹理设计。通过利用各种图案和设计后处理技术，我们提供满足客户偏好的设计解决方案。',
          comm_vegan_leather: '商用人造皮革',
          comm_vegan_leather_desc: '我们应用于汽车座椅织物的技术，在耐用性、抗污染性及其他因素方面实现了卓越的表面质量。我们还可以提供使用红麻等生物基材料的产品。',
          comm_prd_title: 'LXELLO™',
          comm_item1: 'LXELLO™ Green',
          comm_desc1: '符合OEKO-TEX®Standard 100的1级标准，该标准证明该材料对婴儿和幼儿是安全的',
          comm_item2: 'LXELLO™ Bio',
          comm_desc2: '表层和泡沫层含有红麻等生物基材料',
          comm_item3: 'LXELLO™ Eco',
          comm_desc3: '<span>• RCS (Recycled Claim Standard) 认证</span><br /> <span>• 可回收含量35% (可回收聚酯纤维)</span>',
          comm_anno: '<span>• 表层和泡沫层含有红麻等生物基材料</span>' +
            '            <br>' +
            '            <span>-红麻是植物中二氧化碳吸收率最高的植物之一, 比平均水平高3到10倍</span>' +
            '            <br>' +
            '            <span>• 专为满足汽车内饰需求而设计, 包括耐污性</span>' +
            '            <br>' +
            '            <span>-出色的防污性能使室内设计更加明</span>' +
            '            <br>' +
            '            <span>1) 来源: 环境部\'生态友好作物分析报告\'(2019年)</span>' +
            '            <br>',
          lello_palette_title: 'LXELLO™ 调色板'
        },

        automotive_lightweight: {
          title: '轻量化零部件',
          sub_title: '我们提供由强化塑料够成的轻质化材料，它能够保持传统钢材的强度，并通过减轻部件的重量来降低燃料消耗。',
          title_description: '环保、省油的轻量化汽车零部件，具有高钢强度',
          point_title1: '轻量化',
          point_description1: '与传统钢材相比重量减轻25%',
          point_title2: '高强度',
          point_description2: '保持传统钢材的强度',
          point_title3: '降低成本',
          point_description3: '通过设计优化减少零件数量',
          component_item1: '保险杠防撞梁',
          component_desc1: '-与传统钢材相比重量减轻25% \n ' +
            '-通过减震保护乘客免受撞击',
          component_item2: '护膝',
          component_desc2: '-与传统钢材相比重量减轻了56% \n' +
            '-撞击时保护膝盖',
          component_item3: '座椅靠背',
          component_desc3: '-与传统钢材相比重量减轻30% \n' +
            '-配件数量最小化 \n' +
            '-提高碰撞安全',
          component_item4: '电池组底部面板',
          component_desc4: '-与铝相比，重量减轻了30%\n' +
            '-保护电动汽车电池组的下部',
          component_info: '※减重基于汽车设计分析程序(CATIA、LS-DYNA)的模拟结果，实际产品制造时可能因规格而异。',
          material_title: '轻量化材料',
          material_lwn_title: 'LiteMax',
          material_lwn_desc: 'LX Hausys热塑性连续玻璃纤维板',
          lwn_item1: 'LiteMax PPGF60',
          lwn_desc1: '<p>-聚丙烯浸渍玻璃纤维板</p>' +
            '                  <p>-玻璃纤维含量：60wt%</p>' +
            '                  <p>-最适合轻量化设计</p>' +
            '                  <p>-应用：后保险杠防撞梁</p>',
          lwn_item2: 'LiteMax PPGF80',
          lwn_desc2: '<p>-聚丙烯浸渍玻璃纤维板</p>' +
            '                  <p>-玻璃纤维含量：80wt%</p>' +
            '                  <p>-高玻璃纤维含量，高刚度</p>' +
            '                  <p>-应用：电池组底部面板</p>',
          lwn_item3: 'LiteMax PAGF60',
          lwn_desc3: '<p>-聚酰胺6浸渍玻璃纤维板</p>' +
            '                  <p>-玻璃纤维含量：60wt%</p>' +
            '                  <p>-优异的耐热性和抗冲击性</p>' +
            '                  <p>-应用：座椅靠背框架</p>',
          material_lcore_title: 'L-芯板',
          material_lcore_desc: '在北美，纤维芯的轻质夹芯板被用作拖车的墙壁。L-芯板比 HDPE 芯板更轻、更耐腐蚀、更有弹性。',
          lcore_item1: 'HDPE芯板',
          lcore_item2: 'L-芯板',
          lcore_thick: '厚度',
          lcore_weight: '单位重量',
          lcore_redu: '减轻体重',
          lcore_resi: '耐腐蚀性',
          lcore_defo: '加载前后的变形',
          lcore_testInfo: '*基于高温高湿加速寿命检测'
        },

        automotive_auto: {
          title: '汽车零部件',
          sub_title: '我们使用多种材料配方制造创新的汽车零部件。我们的尖端技术提高了能源效率，减轻了汽车的重量。',
          title_description: '应用于汽车外部和内部的各种部件',
          point_title1: '能源效率',
          point_description1: '减轻重量以提高能源效率',
          point_title2: '高质量',
          point_description2: '尖端技术带来的卓越品质',
          point_title3: '卓越的设计',
          point_description3: '实现您驾驶空间的精致与奢华模式',
          ext_eng_title: '外观和发动机部件',
          exterior_part: '外观部件',
          engine_part: '发动机部件',
          exterior_item1: '结构保险杠系统',
          exterior_desc1: '-前,后保险杠总成\n' +
            '-遵守行人安全\n' +
            '-符合 IIHS, R-Car',
          exterior_item2: '侧裙',
          exterior_desc2: '-注塑+喷漆\n' +
            '-成型技术 (电动注塑)',
          engine_item1: '气缸盖罩',
          engine_desc1: '-以塑料代替铝\n' +
            '-防止漏油\n' +
            '-油-水分离系统\n' +
            '-遵守欧5法规',
          engine_item2: '进气歧管',
          engine_desc2: '-以塑料代替铝\n' +
            '-可变进气系统',
          engine_item3: '变速箱油底壳',
          engine_desc3: '-以塑料代替钢\n' +
            '-防止漏油\n' +
            '-油循环系统',
          interior_title: '内部零件',
          interior_desc: '以天然实木图案打造的精致设计',
          inter_detail1: 'SRP (超细真印刷)',
          inter_detail1_desc: '<li>实现精确的3D物体打印</li>\n' +
            '            <li>提供卓越的真实感和纹理效果</li>\n' +
            '            <li>适用于各种汽车内饰</li>\n' +
            '            <li>应用：防撞垫, 装饰, 控制台, 方向盘等</li>',
          inter_detail2: '真实材料',
          inter_detail2_desc: '<li>天然木皮和碳纤维的高级美学</li>\n' +
            '            <li>精致的防撞垫, 装饰, 控制台和扶手, 用于豪华内饰</li>',
          inter_design1: 'SRP 设计',
          inter_design1_item1: '木纹',
          inter_design1_item2: '织物',
          inter_design1_item3: '几何体, 技术性',
          inter_design1_item4: '拉丝',
          inter_design2: '真实材料',
          inter_design2_item1: '木纹',
          inter_design2_item2: '铝',
          inter_design2_item3: '纺织',
          inter_design2_item4: '石纹',
          inter_design2_item5: '碳纤维'
        },

        SOLID_SURFACE: 'SOLID SURFACE',
        KV_brief: 'The New Generation of Design Inspiration',
        brief: 'HIMACS is composed of minerals, acrylic and natural pigments that come together to provide a durable, smooth, non-porous and visually seamless surface which meets the highest standards for quality, aesthetics, fabrication, functionality and hygiene - offering manifold advantages over conventional materials. HIMACS is durable, it can be shaped by a thermoforming process, and thanks to its huge colour spectrum and translucent properties can help to achieve outstanding and colourful designs. HIMACS uses a simple heating process to give three-dimensional thermoforming capabilities, allows visually seamless designs, offers a virtually limitless range of colours and - for some shades - exhibits a special translucency when exposed to light. Although HIMACS is almost as robust as stone, it can be worked in a similar way as wood: it can be sawn, routed, drilled or sanded. HIMACS is available in sheets of different dimensions and thicknesses. The collection is completed with our range of kitchen sinks, basins, baths and shower trays.',
        photo_credit: 'Photo Credits: Design Marc Fidelle and Andrei David - Paris Airport Engineering and Architectural Management, fabrication : LCCA, photo : Mathieu Ducros',

        Aurora_collection_title: 'AURORA & MARMO',
        Aurora_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        ASTER_collection_title: 'ASTER',
        ASTER_collection_brief: 'Aster is a collection of elegant shades of grey, ranging from almost white to a warm beige, all with a gorgeous mother of pearl shimmer.',

        CONCRETE_collection_title: 'CONCRETE',
        CONCRETE_collection_brief: 'The indusrial look of concrete combined with the incredible flexibility of HI-MACS. The Concrete Collection adds huge opportunities for great designs to architects and designers',

        EXTERIA_collection_title: 'EXTERIA',

        GRANITE_collection_title: 'GRANITE, SPARKLE, QUARTZ, SAND & PEARL',
        GRANITE_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        LUCIA_collection_title: 'LUCIA',
        LUCIA_collection_brief: 'This collection focuses on the natural trend colours black, white and grey. The lively and homogeneous structures add character and expression to the colours. Not surprising, as the renowned Dutch designer, Marcel Wanders, designed three of these colours. (W001, W003, W004)',

        LUCENT_collection_title: 'LUCENT',
        LUCENT_collection_brief: 'The shades of the Lucent Collection, with their exceptional light translucency, allow for spectacular designs. Whether effectively backlit or simply illuminated, the Lucent colours of the architecture always add an elegant touch thanks to their characteristic reaction to light.',

        SOLIDS_collection_title: 'SOLIDS',
        SOLIDS_collection_brief: 'The classic in terms of solid surfaces &ndash; a wide range of attractive shades of white lies at the heart of this collection. Complemented by colourful, dynamic uni-shade accents from Lemon Squash to Festival Pink. The timeless collection offers the perfect colour for every design.',

        STRATO_collection_title: 'STRATO',
        STRATO_collection_brief: 'The marked linear patterns of Strato collection creates geometry through its soft structure and subtle look. The skilful use of the new linear pattern, vertically or horizontally, allows for great variation in each and every project.',

        TERRAZZO_collection_title: 'TERRAZZO',
        TERRAZZO_collection_brief: 'Using a vibrant concrete-base as the canvas for each design, the Terrazzo Collection from HI-MACS offers a vibration of color and patterns that speak to your past, present, and future self in anesthetic. Textured shades, artistic designs, and a touch of modern class, this collection creates a one of a kind experience.',

        ULTRA_collection_title: 'ULTRA',
        ULTRA_collection_brief: 'HIMACS Intense Ultra is based on a brand-new material formulation and combines Intense Colour technology with Ultra-thermoforming. Dark colours become more “intense”, darker and also more resistant, with less visible scratches. The new HIMACS Intense Ultra, also has excellent thermoforming capabilities.',

        VOLCANICS_collection_title: 'VOLCANICS',
        VOLCANICS_collection_brief: 'The large particles of the Volcanics shades add a sense of style to any design. When used on a large scale the result is a dramatic showpiece.',

        Sustainability: 'Sustainability',

        /* US feature benefits TAB */

        TAB_Quality_Design_title: 'Quality Design',
        TAB_Quality_Performance_title: 'Quality Performance',
        TAB_Quality_Fabrication_title: 'Quality Fabrication',
        TAB_Quality_Sustainability_title: 'Quality Sustainability',

        /* END US feature benefits TAB */

        /* US feature benefits - Quality Design - TAB */

        Design_title1: 'Wide Range of Shapes',
        Design_brief1: 'Every option is available to designers to create neat washrooms, kitchens, hospitals and much more with our wide range of HIMACS sinks and bowls. Perfectly coordinated and ideal for mixing and matching, the bowls and sinks guarantee a modern look that is easy ad simple to look after.',

        Design_title2: 'Dramatic Translucency',
        Design_brief2: 'Certain colours and thicknesses of HIMACS exhibit a special translucency when exposed to light.',
        Design_brief2_1: 'Various textures and patterns can be built into the material to intensify the HIMACS translucency effect.',

        Design_title3: '3-Dimensional Design',
        Design_brief3: 'HIMACS boasts a simple heating process and three-dimensional thermoplastic forming capabilities.',
        Design_brief3_1: 'This allows for greater forming flexibility compared with other conventional materials so that spectacular ideas can quickly take on a concrete shape.',

        Design_title4: 'Unlimited Spectrum of Colours',
        Design_brief4: 'HIMACS offers a virtually limitless range of colours in all conceivable shades.',
        Design_brief4_1: 'More are being added every year no matter what colour you choose, HIMACS remains 100% homogeneous.',

        /* END US feature benefits - Quality Design - TAB */

        /* US feature benefits - Quality Performance - TAB */

        Performance_title1: 'Strong',
        Performance_brief1: 'Stronger surface with durability similar to that of natural stone - HIMACS stands up to everyday scratches. Should you accidentally inflict a deeper scratch or surface impression, a trained professional can easily resurface your HIMACS thanks to its sealant-free consistency.',

        Performance_title2: 'Fire Resistant',
        Performance_brief2: 'Backed up with numerous certificates that attest of its fire resistance,',
        Performance_brief2_1: 'HIMACS is ideal for places where security is the number 1 criteria of choice.',

        Performance_title3: 'Hygienic',
        Performance_brief3: 'Thanks to its impermeability to dirt, bacteria, viruses and countless chemicals, HIMACS is the ideal material for the hospital,',
        Performance_brief3_1: 'medical practice or laboratory. And for all other areas where hygiene really counts.',

        Performance_title4: 'Water Resistant',
        Performance_brief4: 'Thanks to its non-porous surface HIMACS is suitable for humid areas where moisture can form such as wet rooms',
        Performance_brief4_1: 'and bathrooms.',

        /* END US feature benefits - Quality Performance - TAB */

        /* US feature benefits - Quality Fabrication - TAB */

        Fabrication_title1: 'Most Advanced Fabrication Technology',
        Fabrication_brief1: 'The material is heated in a progressive tempering process (Thermal Cure). which sets HIMACS apart from other mineral materials and produces a new and stronger compound in which any structural defects are perfectly evened out. This improved structure automatically affects the quality of the material.',

        Fabrication_title2: 'Simple Processing',
        Fabrication_brief2: 'Although HIMACS is almost as robust as stone, it can be worked in the same way as wood. ',
        Fabrication_brief2_1: 'Using conventional carpenter\'s tools, this solid surface material can be sawn, routed or drilled.',

        Fabrication_title3: 'Seamless Perfection',
        Fabrication_brief3: 'HIMACS allows for visually seamless manipulation.',
        Fabrication_brief3_1: 'Smooth integration enables large areas without joints or edges as well as flush mounting of sinks or bowls.',

        /* END US feature benefits - Quality Fabrication - TAB */

        /* US feature benefits - Quality Sustainability - TAB */

        Sustainability_title1: 'Renewable',
        Sustainability_brief1: 'With easy-to-care and repairable properties, no matter if it\'s a scratch, stain or crack,',
        Sustainability_brief1_1: 'HIMACS can be restored to its original state by a certified professional.',

        Sustainability_title2: 'Sustailable',
        Sustainability_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        /* END US feature benefits - Quality Sustainability - TAB */

        /* US certifications TAB */
        certifications_desc_p: '认证说明',
        certifications_desc_m: '认证说明',

        TAB_Environment_title: 'Environment',
        TAB_Fire_Rating_title: 'Fire Rating',
        TAB_HIMACS_Exteria_title: 'HIMACS Exteria Certificates',
        TAB_Hygiene_title: 'Hygiene',
        TAB_Process_title: 'Process',

        /* END US certifications TAB */

        /* US certifications - Environment - TAB */

        Environment_title1: 'Ministry of Environment of the Republic of Korea',
        Environment_brief1: 'designates HIMACS as environmentally-friendly thanks to the demonstration of its commitment to ecological awareness in its product management activities.',

        Environment_title2: 'M1 Emissions Classification',
        Environment_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        Environment_title3: 'Leadership in Energy and Environnemental Design (LEED)',
        Environment_brief3: 'Is a standard voluntary system to certify high performance of buildings, from the US Green Building Council (USGBC). LEED certifies buildings using a credit system. The use of HIMACS contributes toward satisfying EQ Credit for Low-Emitting Materials with the category Indoor Environmental Quality (EQ).',

        Environment_title4: 'ISO 14001',
        Environment_brief4: 'The ISO 14000 family concerns the management of environmental quality. The most popular certificate in this group is ISO 14001. It encourages the minimisation of damage caused by our own activity to the environment and the continuous improvement of environmental performance. The objective is to contribute to protecting and stabilising our planet’s environment. This test certifies that the environment management system of HIMACS conforms to ISO 14001 standards.',

        Environment_title5: 'Greenguard',
        Environment_brief5: 'HI-MACS has been approved by Greenguard in the USA, as a “low emitting product”. The organisation establishes acceptable indoor air standards for indoor products, environments and buildings. The organisation’s goal is to improve public health and quality of life through programs that improve indoor air.',

        Environment_title6: 'Environmental Building Certificate – Grade "outstanding"',
        Environment_brief6: 'The Korean Air Cleaning Association certifies that HIMACS complies with the Korean regulations for environmental building materials.',

        Environment_title7: 'DGNB',
        Environment_brief7: 'The DGNB system, founded by the "German Sustainable Building Council”, evaluates buildings holistically on the basis of individual criteria within the categories Ecological Quality, Economic Quality, Sociocultural and Functional Quality, Technical Quality, Process Quality and Location Quality. Different profiles allow the certification of new buildings and existing buildings, as well as of quarters in Germany and Internationally. Buildings can achieve a certification in Bronze, Silver, Gold and Platinum. HIMACS has an Environmental Product Declaration (EPD), which can be used to calculate the building life cycle assessment (ENV1.1/2.1). Furthermore, HIMACS has achieved Quality Level 4 of 4 in DGNB 2018 criteria for local environmental impact for the entire product.',

        Environment_title8: 'BREEAM (Building Research Establishment Environmental Assessment Method)',
        Environment_brief8: 'BREEAM is the world’s leading sustainability assessment method for masterplanning rojects, infrastructure and buildings. It recognises and reflects the value in higher performing assets across the built environment lifecycle, from new construction to in-use and refurbishment. HIMACS can contribute to BREEAM International New Construction 2016 certification, as the entire product complies with Hea 02 Indoor air quality. Furthermore, HIMACS achieved RSCS summary score level in Mat 03, responsible sourcing of construction products for the entire product: RSCS level 1. “BREEAM is a registered trade mark of the Building Research Establishment Limited, a wholly owned subsidiary of BRE Group Limited, and is used by permission. LX Hausys and its products are not affiliated, endorsed or certified by BRE Global Limited, which is the operator of BREEAM, or any other subsidiary of BRE Group Limited. All rights are reserved.”',

        /* END US certifications - Environment - TAB */

        /* US certifications - Fire Rating - TAB */

        Fire_Rating_title1: 'Norm NFP 92-501 Class M1',
        Fire_Rating_brief1: 'LNE tests the reactivity to fire of a material. Class M1 certifies that HIMACS FR benefits from advanced resistance to fire. This certificate is recommended in France.',

        Fire_Rating_title2: 'Norm EN 45 545 Class R1 HZL3',
        Fire_Rating_brief2: 'Fire protection on railway vehicles: The measures and requirements specified in EN 45 545 are intended to protect passengers and staff in railway vehicles in the event of a fire on board. HIMACS has achieved the highest and best performance R1 HZL3 (Hazard Level). Valid for Alpine White S728.',

        Fire_Rating_title3: 'Norm EN 13501 - Class B-s1, d0',
        Fire_Rating_brief3: 'HIMACS successfully passed the European test EN 13501 – Class B-s1, d0, equivalent to the class 0 from Warrington Fire certification.',

        Fire_Rating_title4: 'Norm DIN 4102-1 - Class B1',
        Fire_Rating_brief4: 'Class B1 certifies that HIMACS has a low flammability. B1 class is the European fire resistance requirement. This test result is valid for all colour ranges in 12mm.',

        /* END US certifications - Fire Rating - TAB */

        /* US certifications - Exteria Certificates - TAB */

        Exteria_title1: 'IMO MED – Modules B and D',
        Exteria_brief1: 'MED stands for Marine Equipment Directive. Both modules are extremely important for the shipbuilding industry, as they are mandatory for fabrication materials used in ships. IMO B covers the fire resistance of the material per se and certifies that the material has low flame spread characteristics and is not capable of producing excessive quantities of smoke and toxic combustion products. Module D covers the overall production capacity and checks, among other production processes, the management and systems used.',

        Exteria_title2: 'ETA',
        Exteria_brief2: 'Fixed with Keil inserts and a BWM structure, HIMACS facade in S728 - Alpine White successfully passed the ETA tests (European Technical Agreement).',

        Exteria_title3: 'CSTB Certification',
        Exteria_brief3: 'HIMACS has obtained the French QB certification and CSTB ATec “Avis Technique” for facade applications (Avis Technique 2.2/18-1795_V1).',

        /* END US certifications - Exteria Certificates - TAB */

        /* US certifications - Hygiene - TAB */

        Hygiene_title1: 'NSF',
        Hygiene_brief1: 'NSF standards are generally accepted norms for a variety of public health related industries and fields. These include drinking water treatment and contact with materials, food equipment manufacturing etc. NSF recognises that HIMACS complies with NSF norms.',

        Hygiene_title2: 'LGA',
        Hygiene_brief2: 'Necessary in hospitals and environments where hygiene is critical, LGA assesses the ease of cleaning, resistance to bacteria and fungi and rates the design from a hygiene point of view. Thanks to its non-porosity, HIMACS has been approved for the LGA seal “hygiene tested”.',

        /* END US certifications - Hygiene - TAB */

        /* US certifications - Process - TAB */

        Process_title1: 'OHSAS 18001',
        Process_brief1: 'OHSAS 18001, Occupational Health and Safety Assessment Series, (officially BS OHSAS 18001) is a British Standard for occupational health and safety management systems. Compliance with it enables organizations to demonstrate that they have a system in place for occupational health and safety.',

        Process_title2: 'ISO 9001',
        Process_brief2: 'ISO 9001 criteria can guarantee the following points:',
        Process_brief3: 'The whole fabrication process, ensuring a good product quality',
        Process_brief4: 'Quality control, with an appropriate corrective procedure, when needed and regular control of quality control procedures.',
        Process_brief5: 'Process, which aims to continuously improve global efficiency',

        /* END US certifications - Process - TAB */

        /* US sustainbility - TAB */

        sustainbility_title1: 'Shaping the Future in Harmony with the Environment',
        sustainbility_brief1: 'Countless internationally recognized certificates attest to the fact that HIMACS has a strong focus on ecological aspects. Without exception, all HIMACS products are manufactured in accordance with the ISO 14001 environmental standard.',

        TAB_Commitment_title: 'Commitment',
        TAB_Material_Safety_title: 'Material Safety',
        TAB_Manufacturing_title: 'Manufacturing',
        TAB_Processing_title: 'Processing',
        TAB_Transport_title: 'Transport',

        /* END US sustainbility - TAB */

        /* US sustainbility - Commitment - TAB */

        Commitment_title1: 'Commitment',
        Commitment_brief1: 'LX Hausys conducts and publishes regular environmental audits along with energy consumption analyses. Thanks to the use of non-polluting fuels, greenhouse gas emissions have been cut by 15,000 tons per year since 2008.',

        /* END US sustainbility - Commitment - TAB */

        /* US sustainbility - Material Safety - TAB */

        Material_Safety_title1: 'Material Safety',
        Material_Safety_brief1: 'Extensive studies – within LX Hausys’ own laboratories as well as tests carried out by other renowned independent institutions – have shown that the HIMACS material itself, as well as the cured adhesive, are completely free from formaldehyde and emissions. HIMACS has been awarded the Greenguard Gold Indoor Air Quality Certificate.',

        /* END US sustainbility - Material Safety - TAB */

        /* US sustainbility - Manufacturing - TAB */

        Manufacturing_title1: 'Manufacturing',
        Manufacturing_brief1: 'The production of this solid surface material is marked by an excellent energy balance. In recent years, the company was very successful in achieving ambitious goals in terms of waste reduction and water conservation. In addition, HIMACS plants in Cheongju (Korea) and Atlanta (USA) meet all environmental standards.',

        /* END US sustainbility - Manufacturing - TAB */

        /* US sustainbility - Processing - TAB */

        Processing_title1: 'Processing',
        Processing_brief1: 'The material allows for virtually waste-free processing. In addition, HIMACS installations are extremely strong and durable. They can easily be renewed to their original appearance, meaning they don’t have to be replaced, thus giving a positive long-term  environmental footprint.',

        /* END US sustainbility - Processing - TAB */

        /* US sustainbility - Transport - TAB */

        Transport_title1: 'Transport',
        Transport_brief1: 'Within Europe, HIMACS observes the Euro-5 standards for reduced particulate emissions. The partner-network of LX Hausys Europe consists of carefully selected partners with the highest environmental standards: for example, the State-of-the-Art logistics centre in the Netherlands is one of the first buildings to have been constructed in accordance with the WELL Building Standards and awarded the BREEAM Certificate. This means that it meets the highest requirements for environmentally friendly and healthy construction. '

        /* END US sustainbility - Transport - TAB */

      }, // End of PCD - text

      alert: {
        loginLike: 'Log in to save to your Likes'
      }, // End of PCD - alert

      button: {
        seeMore: 'See More',
        see_all: '查看所有设计',
        learnMore: 'Learn more',
        explore_collection: '探索系列',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        close: 'close',
        find_a_sales_rep: 'Find a Sales Rep',
        btn_sustainbility_brochure: 'Download Sustainability Brochure',

        English: 'English',
        German: 'German',
        French: 'French',
        Italian: 'Italian',
        Spanish: 'Spanish',
        Dutch: 'Dutch',
        EnglishUK: 'English (UK)'

      }, // End of PCD - button

      popup: {
        /* Edge Profiles 시작 점 */
        edge_title: 'Viatera Edge Profile',
        edge_brief: 'Where quartz meets the edge. LX Hausys Surfaces offers a wide selection of edge treatments.' +
          '                    Select from a simple rounded corner to the complex multi-toned,' +
          '                    multi-tiered rolling edges that add that special finishing touch to your solid surface counter.' +
          '                    For more information on our edge treatments, please consult your local area distributor or' +
          '                    fabricator.',

        beveled_Edge: 'Beveled Edge',
        beveled_Edge_brief: 'Maintains the surface’s thickness,\n' +
          '                    but with a ¼” or ½” angular top edge.',
        bullnose_Edge: 'Bullnose Edge',
        bullnose_Edge_brief: 'A completed rounded edge.',

        eased_Edge: 'Eased Edge',
        eased_Edge_brief: 'A slightly rounded top edge that still\n' +
          "                    maintains the surface's thickness.",

        ellipse_Edge: 'Ellipse Edge',
        ellipse_Edge_brief: 'Rounded top and bottom edges\n' +
          '                    with a flat face.',

        knife_Edge: 'Knife Edge',
        knife_Edge_brief: 'A sharp, blade-like edge.',

        reverse_Ogee_Edge: 'Reverse Ogee Edge',
        reverse_Ogee_Edge_brief: 'Similar to Roman Edge, but reversed.',

        roman_Edge: 'Roman Edge',
        roman_Edge_brief: 'An elaborate ogee-style edge design\n' +
          '                    inspired by Roman architecture.',

        roundover_Edge: 'Roundover Edge',
        roundover_Edge_brief: 'A semi-circle rounded top edge.',

        /* Edge Profiles 끝 */

        /* Finish 시작 점 */
        finishInfo: 'Finish guide',
        finishTitle: 'Introducing New Viatera Finish Brushed',
        finishBrief: 'Select Viatera colors are now available with a “Brushed” finish to fulfill a wider range of aesthetics.\n' +
          '                  Enjoy the new classic beauty with a satin-like finish.',
        polished: 'POLISHED',
        polished_brief: 'Traditional reflective surface',

        brushed: 'BRUSHED',
        brushed_brief: 'Soft and smooth feel with\n' +
          '                    low-luster on the surface',

        leather: 'Leather',
        leather_brief: 'Leather finish has a slightly more matte texture than a polished finish, and makes you feel the soft touch of the leather.',

        velvet_Touch: 'Velvet Touch',
        velvet_Touch_brief: 'Velvet touch finish enables you to feel the texture of nature with the feeling of stone dents.',

        finish_viatera: 'Viatera',
        finish_viatera_info: 'Brushed Finish Care & Maintenance',
        finish_viatera_brief: 'Viatera products with Brushed Finish are the same as those with the standard Polished Finish.\n' +
          '                  The only manufacturing difference is how the final gloss level is achieved.',

        finish_viatera_brief_01: 'Brushed Finish may need more daily attention than Polished Finish. This is the nature of any material with a matte finish when compared to the same material\n' +
          '                  with a polished finish – smudges, fingerprints, and water spots are simply more visible on a matte surface. Promptly wipe up and buff dry routine spills, droplets,\n' +
          '                  and rings. A microfiber towel may be more effective than a paper towel because Brushed Finish has a slight surface texture when compared to Polished Finish.\n' +
          '                  These non-woven cleaning products work well on all surfaces and are especially helpful on products that feature anything other than a perfectly smooth surface.',

        finish_viatera_brief_02: 'Routine Care and Maintenance of Brushed Finish is easy with the same liquid household cleaners that are suitable for “Polished” finishes, including Formula 409\n' +
          '                  Natural Stone & Steel Cleaner.',

        finish_viatera_brief_03: 'Always read and follow that manufacturer’s label instructions. A textured sponge that’s suitable for non-stick coated cookware may be helpful in removing some\n' +
          '                  tougher spills. Avoid using abrasive cleaners like Ajax or Comet, as these more aggressive materials may dull or damage the surface of Brushed Finish.\n' +
          '                  After using any cleaning product always rinse the area and buff the area dry. A microfiber product is suggested but not required.'

        /* Finish 끝 */

      } // End of PCD - popup
    }, // End of PCD

    PD: {
      text: {
        new: 'NEW',
        coming: 'Coming soon',
        discontinued_Color: 'Discontinued Color',
        image_enlarged_view: 'IMAGE ENLARGED VIEW',
        image_download_view: 'IMAGE DOWNLOAD VIEW',
        finish: 'Finish',
        finishGuide: 'Finish guide',
        color: 'Color',
        product_Specs: '产品参数',
        product_type: 'Product Type',
        total_thickness: 'Total Thickness',
        wear_layer: 'Wear Layer',
        dimension: 'Dimensions',
        dimension1: 'Dimension &',
        weight: 'Weight',
        remark: 'Remark',
        pattern: 'Pattern',
        emboss: 'Emboss',
        installation: 'Installation',
        adhesive_code: 'Adhesive Code',
        adhesive_name: 'Adhesive Name',
        available_Countries: 'Available Countries',
        related_Products: '相关产品',
        features_Benefits: 'Features & Benefits',
        certifications: 'Certifications',
        documentation_technical_details: '文档 & 技术详情',
        fabrication: 'Fabrication',
        test_report: 'Test Report',
        care_maintenance: '维护与保养',
        catalogue: '综合彩页/样品册',
        certification: '认证资料',
        technical_datasheet: '技术数据',
        installation_guide: '安装指南',
        warranty: '保修单',
        edge_profile: 'Edge Profile',
        inspiration: 'Inspiration',
        standard: 'Standard',
        image_viewer: 'For illustration purposes only. Image size:',
        in: 'in',
        zoom_out: 'zoom Out',
        zoom_in: 'zoom In',
        Thickness: 'Thickness',
        Use: 'Use',
        Pattern: 'Pattern',
        Notice: 'Notice',
        Notice_brief: 'Less suitable for surfaces which are subject to high traffic, due to their higher pigmented colour saturation, marks may be seen more easily.',
        Semi_Translucent: 'Semi-Translucent colour',
        Semi_Translucent_brief: 'Colours with this mark have a semi-translucent effect, evident when combined with light sources',
        Outdoor: 'Outdoor',
        Outdoor_brief: 'Suitable for exterior use. Please check conditions about level of suitability and warranty per colour. Indoor, Suitable for Kitchen & Bathroom',
        Recycled: 'Recycled',
        Recycled_brief: 'Certified to contain pre-consumer recycled content. Minimum',
        Designer: 'Designer Series',
        Designer_brief: 'Designed by Marcel Wanders',
        Lucent: 'Lucent',
        Lucent_brief: 'Lucent colours have a higher level of translucency, more evident when combined with light source. Translucent colour',
        Veined: 'Veined',
        Veined_brief: 'As Marmo is a randomly veined product, specific fabrication guidelines need to be followed.',
        construct: 'Construct',
        news_letter: '订阅我们的新闻通讯',
        news_letter_desc: '探索创新项目、独特色彩与最新新闻和趋势',
        subscribe: 'Subscribe',
      }, // End of PD - text

      button: {
        virtual_Showroom: 'Virtual Showroom',
        prev: 'Prev',
        next: 'Next',
        list_view: 'list view',
        download: 'download',
        see_all_documentation: 'See All Documentation',
        see_all_case_studies: 'See All Case Studies',
        see_more: 'See More'

      } // End of PD - button

    }, // End of PD

    PF: {
      text: {
        category: 'CATEGORY',
        luxury_vinyl_tile: 'Luxury Vinyl Tile',
        looselay: 'Looselay',
        spc_tile: 'SPC Tile(Click)',
        homogeneous_sheet: 'Homogeneous Sheet',
        heterogeneous_sheet: 'Heterogeneous Sheet',
        specialty: 'Specialty',
        home: 'Home',
        filter_by: 'Filter By',
        patterns: '纹路',
        country: 'Country',
        new: 'New',
        new_a: 'NEW',
        coming: 'Coming soon',
        new_colors: '新花色',
        product_type: '产品类型',
        thickness: '厚度',
        weight: '重量',
        finish: '表面处理',
        wear_layer: '厚度',
        dimension: '标准规格 (mm)',
        searchText: '输入产品代码或名称',
        Tones: 'Tones',
        Use: 'Use',
        Recycled: 'Recycled',
        Thickness: '厚度',
        himacs: 'HIMACS',
        borte: 'BORTE',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        exteriorfilm: 'EXTERIOR Film',
        decofilm: 'DECO Film',
        teracanto: 'TERACANTO',
        benif: 'BENIF',
        vizuon_a: 'VIZUON',
        lvt: 'Luxury Vinyl Tile',
        los: 'Looselay',
        spc: 'SPC Tile(Click)',
        hom: 'Homogeneous Sheet',
        het: 'Heterogeneous Sheet',
        spt: 'Specialty',
        filters: '全部筛选',
        compare: {
          decofilm: '家具膜产品对比',
          exteriorfilm: '户外膜产品对比',
          vizuon_a: 'VIZUON广告材产品对比',
          viatera: 'VIATERA石英石产品对比',
          hflor: 'HFLOR地板产品对比',
          teracanto: 'TERACANTO岩板产品对比',
          benif: 'BENIF装饰贴膜产品对比',
          himacs: 'HIMACS人造大理石产品对比'
        },
        compare_full: {
          text: '是否愿意已选择的产品替换您添加的第一个产品？',
          footer: '编辑比对比的产品'
        },
        installation: '安装',
        results: '结果',
        no_search_result: '未找到结果',
        no_compare_item: '未查到可比较的信息',
        no_option: '请选择选项',
        color: '颜色',
        slab_size: '板坯尺寸',
        bookmatch: '图书比赛',
        remark: '评论',
        allColors: {
          himacs: 'HIMACS 颜色',
          hflor: 'HFLOR 颜色',
          viatera: 'VIATERA 颜色',
          exteriorfilm: 'Exterior Film 颜色',
          decofilm: 'Deco Film 颜色',
          teracanto: 'TERACANTO 颜色',
          benif: 'BENIF 颜色',
          vizuon_a: 'VIZUON 颜色',
          borte: 'BORTE 颜色',
          himacs_ac: 'HIMACS',
          hflor_ac: 'HFLOR',
          viatera_ac: 'VIATERA',
          exteriorfilm_ac: 'EXTERIOR Film',
          decofilm_ac: 'DECO Film',
          borte_ac: 'BORTE',
          teracanto_ac: 'TERACANTO',
          benif_ac: 'BENIF',
          vizuon_ac: 'VIZUON',
          products: '产品介绍',
          all_colors: '所有颜色',
          filter: '筛选',
          filter_by: '筛选',
          brand: '品牌',
          color: '颜色',
          searchText: '输入产品代码或名称',
          results: '结果',
          no_result: 'No Result found',
          no_result_text: 'If you do not find what you are looking for, please try different search terms or filters.',
          apply: '提交',
          clear_all: '清除',
          clear_all2: 'clear all',
          products_a_to_z: '产品 A to Z',
          products_z_to_a: '产品 Z to A',
          new_products_first: '最新浏览',
          your_compare_is_full: '对比选项已满',
          new: '新',
          new_a: 'NEW',
          brandLabel: '品牌',
          colorLabel: '颜色',
          white: 'White',
          cream: 'Cream',
          beige: 'Beige',
          brown: 'Brown',
          gray: 'Gray',
          black: 'Black',
          green: 'Green',
          blue: 'Blue',
          pink: 'Pink',
          purple: 'Purple',
          ivory: 'Ivory',
          orange: 'Orange',
          red: 'Red'
        },
        key_visual_desc: {
          all_colors: 'LX Hausys凭借其创新的表面与地板材料，为您提供从亚克力人造石表面到岩板、产业用膜及弹性地板的多元化色彩、饰面与美学解决方案，助力实现项目愿景。',

          hflor_color: 'HFLOR弹性地板：用色彩与图案演绎设计美学。从LVT豪华乙烯基地板到卷材地板，每一款皆可定制。',

          viatera_color: 'Raise the style quotient of every space with the beautiful range of quartz worktops from VIATERA. <br>' +
            'Explore our vast selection to find the ideal quartz countertop solution that blends exceptional performance with timeless design.',

          himacs_color: '借助HIMACS，重新思考设计的局限，突破可能的边界。探索HIMACS丰富的色彩与设计选择，使其成为商业与住宅应用的理想实体面材。',

          teracanto_color: '让TERACANTO台面大胆精致的设计，为您创造沉浸式体验。其表面装饰系统融合自然美学与工程创新，提供多元化的色彩与图案解决方案。',

          benif_color: '用BENIF自粘性装饰贴膜，解锁设计的无限可能。海量花色选择，搭配便捷自粘技术，轻松实现墙面、天花板及家具的快速焕新。',

          deco_color: '突破传统设计边界，用LX Hausys Deco Film家具膜重新定义家具与木制品的可能性。探索我们丰富无限的色彩与图案组合，<br>' +
            '为您的室内空间注入独一无二的美学魅力，实现真正意义的定制化设计。',

          exterior_color: '让LX Hausys Exterior Film 户外膜的丰富色彩与图案，为您的建筑组件注入全新生命力。 <br>' +
            '无论是提升外观质感还是实现功能改造，其卓越的耐磨性能可抵御紫外线、湿气及多变外部环境，确保建筑立面持久如新。',

          vizuon_color: '探索LX Hausys Sign&Graphic Film的完整VIZUON系列，该系列旨在通过生动的视觉图像和便捷的应用程序，将您的创意构想变为现实。<br>' +
            '滚动浏览LX Hausys Sign&Graphic Film的全场景解决方案：覆盖车辆运输动态标识、大型LED显示系统、精密照明标识及定制化建筑项目，以技术创新驱动视觉表达升级。 <br>' +
            '探索LX Hausys Sign&Graphic Film的色彩与风格体系，涵盖生态友好型材料解决方案及全品牌视觉定制选项，助您精准匹配项目需求。',

          default_desc: '',
        },
      }, // End of PF - text

      filter: {
        filter_by: '筛选',
        vizuon: 'VIZUON',
        vt: '车辆及运输 Vehicles and Transportation',
        sd: '标识标牌 Signs and Displays',
        is: '保护膜 Illuminated Sign',
        ar: '建筑用膜 Architecture',
        es: '生态解决方案 Eco Solution',
        cb: '企业品牌 Corporate branding',
        feature: 'FEATURE',
        country: 'COUNTRY',
        compare: '对比',
        bookmatch: 'BOOKMATCH',
        application: 'APPLICATION',
        weatherability: 'WEATHERABILITY',
        remark: 'REMARK',
        hflor: 'HFLOR',
        pet: 'PET',
        installation: 'INSTALLATION',
        productType: 'PRODUCT TYPE',
        filter: 'FILTER',
        color: '颜色',
        collection: '系列 ',
        patterns: '纹路',
        finish: '表面处理',
        recycled: 'Recycled',
        thickness: '厚度',
        format: '格式',
        wood: '林涵',
        dimensions: '标准规格',
        prdtype: '安装', // installation
        adhesivetype: '胶水类型',
        productclassification: '产品分类',
        airfree: '导气槽',
        stone: '砳涵',
        solidcolor: '单色',
        solidPatterns: '单色纹路',
        stoneColor: '石纹色',
        metalColor: '金属色',
        woodColor: '木纹色',
        metalPattern: '金属纹路',
        woodPattern: '木纹',
        stonePattern: '石纹',
        pvc: 'PVC',
        petFurnitureFilm: 'PET',
        acrylicFurnitureFilm: '丙烯酸纤维',
        woodSpecies: '木材类型',
        new: '新',
        fireresistance: '防火性能',
        fire_grade: '阻燃等级',
        stonetype: '石头类型',
        textiletype: '纺织类型',
        slabsize: '板坯尺寸',
        econo: '爱可诺 ECONO',
        mini: 'MINI',
        prestg30: 'PRESTG 3.0',
        spcTile: 'SPC 锁扣地板 SPC TILE',
        qboom: '祺宝 QBOOM',
        relax18: '岚风1.8 RELAX 1.8',
        stoneCollection: '砳涵 STONE COLLECTION',
        woodCollection: '林涵 WOOD COLLECTION',
        leisure: '暮锐 LEISURE',
        square20: '博雅2.0 SQUARE2.0',
        fine: '福耐 FINE',
        oa: '商宝 OA',
        superior: '舒可丽 SUPERIOR',
        xinbo: '芯宝 XINBO',
        livens: '乐雅 LIVENS',
        livensConductive: '乐雅导电 LIVENS CONDUCTIVE',
        cube: '广雅 CUBE',
        durable: '悦宝 DURABLE',
        xComfort: '玉米地板 X-COMFORT',
        supreme18: '优耐1.8 SUPREME1.8',
        unite: '优耐特 Unite',
        space: '优澜 Space',
        offistepStyle: '优丽 OFFISTEP STYLE',
        prairie: '优林 PRAIRIE',
        passion: '优祥 PASSION',
        essential: '优熠 ESSENTIAL',
        grace: '优雅 GRACE',
        allroad: '优芮 ALLROAD',
        un: '优恩 UN',
        origin: '优净 Origin',
        originConductive: '优净导电 Origin Conductive',
        rexcourt: '运宝 REXCOURT',
        calmpasso: '静宝 CALMPASSO',
        sorizam: '静源 SORIZAM',
        eqFloor: '智宝 EQ FLOOR',
        trendy: '特兰迪 TRENDY',
        palace: '巴利斯 PALACE',
        ocean: '瀚雅 OCEAN',
        prime: '恒雅 PRIME',
        delight: '惠宝 DELIGHT',
        abc: '惠阅 ABC',
        aquaMarine: '船舶专用地板 AQUA MARINE',
        superiorPlus: '舒可丽 Plus Surperior Plus',
        category: 'CATEGORY',
        type: '类型'
      },
      popup: {
        filter_by: '筛选',
        your_compare_is_full: '对比选项已满',
        compare_tool: 'Compare tool',
        compare_alert1: 'Do you want to replace the first product',
        compare_alert2: 'you added by the one you selected?',
        edit_products_in_compare: 'EDIT PRODUCTS IN COMPARE',
        replace: '替换',
        close: 'close',
        characteristics_technical_performance: '特点及技术参数',
        pvc: 'PVC',
        acrylic: '丙烯酸纤维',
        adhesive_type: '胶水类型',
        adhesive_code: '胶水代码',
        adhesive_name: '胶水名称',
        air_free: '导气槽',
        film_type: '薄膜类型',
        material: '材料',
        liner: '离型纸/膜',
        width: '宽度',
        grade: '等级',
        length: '长度',
        repeatImage: 'Repeat Image',
        fireResis: '防火性能',
        fireGrade: '阻燃等级',
        pet: 'PET',
        thickness: '厚度'
      },
      button: {
        all: 'All',
        lux: 'Luxury Vinyl Tile',
        hom: 'Homogeneous Sheet',
        het: 'Heterogeneous Sheet',
        spt: 'Specialty',
        compare: '对比',
        compare_your_colors: '对比颜色',
        remove: 'Remove',
        add_more: '添加更多',
        search: 'search',
        color: '颜色',
        collection: 'Collection',
        patterns: 'Patterns',
        finish: 'Finish',
        country: 'Country',
        new: 'New',
        coming: 'Coming soon',
        all_products: 'All products',
        grouped_by_collections: 'Grouped by collections',
        filter_by: 'Filter By',
        products_a_to_z: '产品 A to Z',
        products_z_to_a: '产品 Z to A',
        new_products_first: '最新浏览',
        clear_all: '清除',
        load_more: '加载更多',
        see_all_colors: 'See all colors',
        download: '下载',
        Popularity: 'Popularity',
        lvt: 'Luxury Vinyl Tile',
        los: 'Looselay',
        spc: 'SPC Tile(Click)',
        compare_on: 'ON',
        most_recent: '最新浏览',
        filter: '筛选',
        apply: '提交',
        all_filters: '全部筛选',

      } // End of PF - button
    }, // End of PF
    other: {
      text: {
        sales_rep: 'Find a Sales Rep',
        showroom: 'Virtual Showroom',
        home: 'Home',
        products: 'Products',
        viatera: 'VIATERA',
        himacs: 'HIMACS',
        hotherPD: 'HIMACS Sinks',
        votherPD: 'VIATERA Sinks',
        overall: 'Overall Dimensions',
        inner: 'Inner Dimensions',
        contactus: 'Contact Us',
        close: 'close',
        arctic: 'Arctic White',
        ivory: 'Ivory White',
        cream: 'Cream',
        almond: 'Almond',
        all: 'All',
        kitchen: 'Kitchen',
        bathroom: 'Bathroom',
        ada: 'ADA Compliance',
        himacs_sink_banner_desc: 'Explore the complete line of HIMACS vanity and kitchen sinks designed for superior aesthetics and functionality.<br>' +
          'Every HIMACS solid surface sink is engineered to be seamlessly integrated with a HIMACS countertop,<br>' +
          'providing a beautifully smooth, clean, and well-designed surface.',
        viatera_sink_banner_desc: 'Discover the Lovello™ stainless steel sink collection, designed to perfectly complement VIATERA Quartz Countertops.<br>' +
          'These high-quality sinks offer unique styling to enhance any kitchen or vanity,<br>' +
          'providing the ideal finishing touch when paired with your VIATERA surface.'
      },
      button: {
        learn_more: '了解更多',
        view_more: '查看更多',
        load_more: '加载更多',
        certi_more: 'What These Certifications Mean'
      }
    }

  }, // End of CN

  RU: {
    PCD: {
      text: {
        home: 'Home',
        contact_us: 'Contact Us',
        products: 'Продукция',
        himacs: 'HIMACS',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        teracanto: 'TERACANTO',
        vizuonsigngraphic: 'VIZUON',
        himacssolidsurface: 'HIMACS',
        viateraquartzsurface: 'VIATERA',
        teracantoporcelainsurface: 'TERACANTO',
        benifarchitecturalfilm: 'BENIF',
        decofilm: 'Deco Film',
        exteriorfilm: 'Exterior Film',
        bortepanel: 'BORTE',
        home_film: 'Бытовая техника Поверхностная пленка',
        automotive: 'Automotive',
        sub: {
          lvt: 'Виниловая плитка',
          los: 'Свободнолежащая плитка ПВХ',
          spc: 'Кварцвиниловая плитка',
          homo: 'Гомогенный',
          het: 'Гетерогенный',
          spt: 'Специализация',
          veh: 'Автомобили и транспорт',
          sd: 'Вывески и витрины',
          illum: 'Светящаяся вывеска',
          arch: 'Архитектура',
          eco: 'Экологические решения',
          corp: 'Корпоративный брендинг'
        },
        vizuon_a: 'VIZUON',
        about: {
          himacs: 'О HIMACS',
          benif: 'О BENIF',
          vizuon_a: 'О VIZUON',
          hflor: 'Об HFLOR',
          viatera: 'О VIATERA',
          teracanto: 'О TERACANTO',
          deco: 'О Deco Film',
          exterior: 'Об Exterior Film',
          home_film: 'О поверхностной пленке для бытовой техники',
          automotive: {
            vegan_leather: 'Vegan Leather',
            light_comm: 'Lightweight Component',
            auto_comm: 'Automotive Component'
          }
        },
        featured_products: 'Featured Products',
        cart: 'cart',
        wish_list: 'wish list',
        new: 'New',
        coming: 'Coming soon',
        collection: 'Collection',
        explore_collection: 'Explore Collection',
        online_book: 'Online Book',
        load_more: 'Загрузить еще',
        certi_more: 'What These Certifications Mean',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        awards: 'Awards',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        order_a_sample: 'Order a Sample',
        documentation: 'Documentation',
        care_maintenance: 'Care & Maintenance',
        warranty: 'Warranty',
        where_to_buy: 'Where to buy',

        home_app_film: {
          title: 'Поверхностная пленка для бытовой техники',
          title_description: 'Ламинированная пленкой стальная поверхность, отделочный материал для бытовой техники и лифтов.',
          intro1: 'Пленка для бытовой техники LX Hausys - это высококачественный поверхностный материал с разнообразными цветами и дизайном для холодильников, стиральных машин и ванных комнат.',
          intro2: 'Наша превосходная продукция уже выбрана мировыми компаниями, производящими бытовую технику, благодаря своей превосходной устойчивости к загрязнениям, царапинам и коррозиям.',
          point_title1: 'Индивидуальное дизайнерское решение',
          point_description1: 'По данным исследования Global Trend Research, возможности разработки индивидуальных дизайнерских решений для местных клиентов были признаны во всем мире, особенно в Индии, Америке, Китае, Юго-Восточной Азии и Европе.',
          point_title2: 'Global No.1',
          point_description2: 'Поверхностная пленка для бытовой техники LX Hausys участвует в 1-м M/S в качестве партнера крупнейших мировых компаний по производству бытовой техники.',
          point_title3: 'Отличное качество',
          point_description3: 'Технология компании LX Hausys обеспечивает защиту от отпечатков пальцев, устойчивость к загрязнениям, защиту от царапин и высокую упругость, чтобы покупатели могли долгое время пользоваться бытовой техникой в прекрасном состоянии.',
          construction: 'Строительство',
          construction_film1: 'Металлизированная пленка',
          film1_item1: 'Эко ПЭТ',
          film1_item1_desc: 'Печать на металлизированном перламутре с основой из ПЭТ',
          film1_item2: 'Metalon',
          film1_item2_desc: 'Металлизация придает пленке вид настоящего металла',
          film1_item3: 'SUS Film',
          film1_item3_desc: 'Технология Embossed Hairline позволяет создавать индивидуальный рисунок, включая горизонтальный покров.',
          construction_film2: 'Перламутровая пленка и пленка с узором',
          film2_item1: 'Глянец',
          film2_item1_desc: 'Превосходная технология печати позволяет предложить индивидуальный рисунок',
          film2_item2: 'Галактика',
          film2_item2_desc: 'Различные перламутровые эффекты позволят тонкую и блестящую поверхность',
          film2_item3: 'Мягкий матовый',
          film2_item3_desc: 'Мягкие матовые текстуры с различными цветами или индивидуальным дизайном',
          application: 'Применение',
          application_sub_title: 'Поверхностная пленка для бытовой техники',
          application_item1: 'Пастельный металл',
          application_item2: 'Мягкий матовый',
          application_item3: 'Горизонтальная линия (серебристый, короткий)',
          application_item4: 'Горизонтальная линия (черный)',
          application_item5: 'Iridium Hairline',
          application_item6: 'Горизонтальная линия (темно-серый)',
          application_item7: 'Стекловолокно',
          application_item8: 'Горизонтальная линия (серебристый, длинный)'
        },

        SOLID_SURFACE: 'SOLID SURFACE',
        KV_brief: 'The New Generation of Design Inspiration',
        brief: 'HIMACS is composed of minerals, acrylic and natural pigments that come together to provide a durable, smooth, non-porous and visually seamless surface which meets the highest standards for quality, aesthetics, fabrication, functionality and hygiene - offering manifold advantages over conventional materials. HIMACS is durable, it can be shaped by a thermoforming process, and thanks to its huge colour spectrum and translucent properties can help to achieve outstanding and colourful designs. HIMACS uses a simple heating process to give three-dimensional thermoforming capabilities, allows visually seamless designs, offers a virtually limitless range of colours and - for some shades - exhibits a special translucency when exposed to light. Although HIMACS is almost as robust as stone, it can be worked in a similar way as wood: it can be sawn, routed, drilled or sanded. HIMACS is available in sheets of different dimensions and thicknesses. The collection is completed with our range of kitchen sinks, basins, baths and shower trays.',
        photo_credit: 'Photo Credits: Design Marc Fidelle and Andrei David - Paris Airport Engineering and Architectural Management, fabrication : LCCA, photo : Mathieu Ducros',

        Aurora_collection_title: 'AURORA & MARMO',
        Aurora_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        ASTER_collection_title: 'ASTER',
        ASTER_collection_brief: 'Aster is a collection of elegant shades of grey, ranging from almost white to a warm beige, all with a gorgeous mother of pearl shimmer.',

        CONCRETE_collection_title: 'CONCRETE',
        CONCRETE_collection_brief: 'The indusrial look of concrete combined with the incredible flexibility of HI-MACS. The Concrete Collection adds huge opportunities for great designs to architects and designers',

        EXTERIA_collection_title: 'EXTERIA',

        GRANITE_collection_title: 'GRANITE, SPARKLE, QUARTZ, SAND & PEARL',
        GRANITE_collection_brief: 'The Aurora Collection -an evolution of the Marmo Collection- realizes the soft and mysterious beauty of natural marble pattern inspired by the aurora seen in the polar regions.',

        LUCIA_collection_title: 'LUCIA',
        LUCIA_collection_brief: 'This collection focuses on the natural trend colours black, white and grey. The lively and homogeneous structures add character and expression to the colours. Not surprising, as the renowned Dutch designer, Marcel Wanders, designed three of these colours. (W001, W003, W004)',

        LUCENT_collection_title: 'LUCENT',
        LUCENT_collection_brief: 'The shades of the Lucent Collection, with their exceptional light translucency, allow for spectacular designs. Whether effectively backlit or simply illuminated, the Lucent colours of the architecture always add an elegant touch thanks to their characteristic reaction to light.',

        SOLIDS_collection_title: 'SOLIDS',
        SOLIDS_collection_brief: 'The classic in terms of solid surfaces &ndash; a wide range of attractive shades of white lies at the heart of this collection. Complemented by colourful, dynamic uni-shade accents from Lemon Squash to Festival Pink. The timeless collection offers the perfect colour for every design.',

        STRATO_collection_title: 'STRATO',
        STRATO_collection_brief: 'The marked linear patterns of Strato collection creates geometry through its soft structure and subtle look. The skilful use of the new linear pattern, vertically or horizontally, allows for great variation in each and every project.',

        TERRAZZO_collection_title: 'TERRAZZO',
        TERRAZZO_collection_brief: 'Using a vibrant concrete-base as the canvas for each design, the Terrazzo Collection from HI-MACS offers a vibration of color and patterns that speak to your past, present, and future self in anesthetic. Textured shades, artistic designs, and a touch of modern class, this collection creates a one of a kind experience.',

        ULTRA_collection_title: 'ULTRA',
        ULTRA_collection_brief: 'HIMACS Intense Ultra is based on a brand-new material formulation and combines Intense Colour technology with Ultra-thermoforming. Dark colours become more “intense”, darker and also more resistant, with less visible scratches. The new HIMACS Intense Ultra, also has excellent thermoforming capabilities.',

        VOLCANICS_collection_title: 'VOLCANICS',
        VOLCANICS_collection_brief: 'The large particles of the Volcanics shades add a sense of style to any design. When used on a large scale the result is a dramatic showpiece.',

        Sustainability: 'Sustainability',

        /* US feature benefits TAB */

        TAB_Quality_Design_title: 'Quality Design',
        TAB_Quality_Performance_title: 'Quality Performance',
        TAB_Quality_Fabrication_title: 'Quality Fabrication',
        TAB_Quality_Sustainability_title: 'Quality Sustainability',

        /* END US feature benefits TAB */

        /* US feature benefits - Quality Design - TAB */

        Design_title1: 'Wide Range of Shapes',
        Design_brief1: 'Every option is available to designers to create neat washrooms, kitchens, hospitals and much more with our wide range of HIMACS sinks and bowls. Perfectly coordinated and ideal for mixing and matching, the bowls and sinks guarantee a modern look that is easy ad simple to look after.',

        Design_title2: 'Dramatic Translucency',
        Design_brief2: 'Certain colours and thicknesses of HIMACS exhibit a special translucency when exposed to light.',
        Design_brief2_1: 'Various textures and patterns can be built into the material to intensify the HIMACS translucency effect.',

        Design_title3: '3-Dimensional Design',
        Design_brief3: 'HIMACS boasts a simple heating process and three-dimensional thermoplastic forming capabilities.',
        Design_brief3_1: 'This allows for greater forming flexibility compared with other conventional materials so that spectacular ideas can quickly take on a concrete shape.',

        Design_title4: 'Unlimited Spectrum of Colours',
        Design_brief4: 'HIMACS offers a virtually limitless range of colours in all conceivable shades.',
        Design_brief4_1: 'More are being added every year no matter what colour you choose, HIMACS remains 100% homogeneous.',

        /* END US feature benefits - Quality Design - TAB */

        /* US feature benefits - Quality Performance - TAB */

        Performance_title1: 'Strong',
        Performance_brief1: 'Stronger surface with durability similar to that of natural stone - HIMACS stands up to everyday scratches. Should you accidentally inflict a deeper scratch or surface impression, a trained professional can easily resurface your HIMACS thanks to its sealant-free consistency.',

        Performance_title2: 'Fire Resistant',
        Performance_brief2: 'Backed up with numerous certificates that attest of its fire resistance,',
        Performance_brief2_1: 'HIMACS is ideal for places where security is the number 1 criteria of choice.',

        Performance_title3: 'Hygienic',
        Performance_brief3: 'Thanks to its impermeability to dirt, bacteria, viruses and countless chemicals, HIMACS is the ideal material for the hospital,',
        Performance_brief3_1: 'medical practice or laboratory. And for all other areas where hygiene really counts.',

        Performance_title4: 'Water Resistant',
        Performance_brief4: 'Thanks to its non-porous surface HIMACS is suitable for humid areas where moisture can form such as wet rooms',
        Performance_brief4_1: 'and bathrooms.',

        /* END US feature benefits - Quality Performance - TAB */

        /* US feature benefits - Quality Fabrication - TAB */

        Fabrication_title1: 'Most Advanced Fabrication Technology',
        Fabrication_brief1: 'The material is heated in a progressive tempering process (Thermal Cure). which sets HIMACS apart from other mineral materials and produces a new and stronger compound in which any structural defects are perfectly evened out. This improved structure automatically affects the quality of the material.',

        Fabrication_title2: 'Simple Processing',
        Fabrication_brief2: 'Although HIMACS is almost as robust as stone, it can be worked in the same way as wood. ',
        Fabrication_brief2_1: 'Using conventional carpenter\'s tools, this solid surface material can be sawn, routed or drilled.',

        Fabrication_title3: 'Seamless Perfection',
        Fabrication_brief3: 'HIMACS allows for visually seamless manipulation.',
        Fabrication_brief3_1: 'Smooth integration enables large areas without joints or edges as well as flush mounting of sinks or bowls.',

        /* END US feature benefits - Quality Fabrication - TAB */

        /* US feature benefits - Quality Sustainability - TAB */

        Sustainability_title1: 'Renewable',
        Sustainability_brief1: 'With easy-to-care and repairable properties, no matter if it\'s a scratch, stain or crack,',
        Sustainability_brief1_1: 'HIMACS can be restored to its original state by a certified professional.',

        Sustainability_title2: 'Sustailable',
        Sustainability_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        /* END US feature benefits - Quality Sustainability - TAB */

        /* US certifications TAB */
        certifications_desc_p: 'ОПИСАНИЕ СЕРТИФИКАЦИИ',
        certifications_desc_m: 'ОПИСАНИЕ <br> СЕРТИФИКАЦИИ',

        TAB_Environment_title: 'Environment',
        TAB_Fire_Rating_title: 'Fire Rating',
        TAB_HIMACS_Exteria_title: 'HIMACS Exteria Certificates',
        TAB_Hygiene_title: 'Hygiene',
        TAB_Process_title: 'Process',

        /* END US certifications TAB */

        /* US certifications - Environment - TAB */

        Environment_title1: 'Ministry of Environment of the Republic of Korea',
        Environment_brief1: 'designates HIMACS as environmentally-friendly thanks to the demonstration of its commitment to ecological awareness in its product management activities.',

        Environment_title2: 'M1 Emissions Classification',
        Environment_brief2: 'HIMACS supports greener earth by using sustainable material, eco-friendly manufacturing process and recycling at the end of its life-cycle. LX Hausys fully stands behind HIMACS uality, which is we offer a 15 year transferable warranty with customer\'s best interest in mind. ',

        Environment_title3: 'Leadership in Energy and Environnemental Design (LEED)',
        Environment_brief3: 'Is a standard voluntary system to certify high performance of buildings, from the US Green Building Council (USGBC). LEED certifies buildings using a credit system. The use of HIMACS contributes toward satisfying EQ Credit for Low-Emitting Materials with the category Indoor Environmental Quality (EQ).',

        Environment_title4: 'ISO 14001',
        Environment_brief4: 'The ISO 14000 family concerns the management of environmental quality. The most popular certificate in this group is ISO 14001. It encourages the minimisation of damage caused by our own activity to the environment and the continuous improvement of environmental performance. The objective is to contribute to protecting and stabilising our planet’s environment. This test certifies that the environment management system of HIMACS conforms to ISO 14001 standards.',

        Environment_title5: 'Greenguard',
        Environment_brief5: 'HI-MACS has been approved by Greenguard in the USA, as a “low emitting product”. The organisation establishes acceptable indoor air standards for indoor products, environments and buildings. The organisation’s goal is to improve public health and quality of life through programs that improve indoor air.',

        Environment_title6: 'Environmental Building Certificate – Grade "outstanding"',
        Environment_brief6: 'The Korean Air Cleaning Association certifies that HIMACS complies with the Korean regulations for environmental building materials.',

        Environment_title7: 'DGNB',
        Environment_brief7: 'The DGNB system, founded by the "German Sustainable Building Council”, evaluates buildings holistically on the basis of individual criteria within the categories Ecological Quality, Economic Quality, Sociocultural and Functional Quality, Technical Quality, Process Quality and Location Quality. Different profiles allow the certification of new buildings and existing buildings, as well as of quarters in Germany and Internationally. Buildings can achieve a certification in Bronze, Silver, Gold and Platinum. HIMACS has an Environmental Product Declaration (EPD), which can be used to calculate the building life cycle assessment (ENV1.1/2.1). Furthermore, HIMACS has achieved Quality Level 4 of 4 in DGNB 2018 criteria for local environmental impact for the entire product.',

        Environment_title8: 'BREEAM (Building Research Establishment Environmental Assessment Method)',
        Environment_brief8: 'BREEAM is the world’s leading sustainability assessment method for masterplanning rojects, infrastructure and buildings. It recognises and reflects the value in higher performing assets across the built environment lifecycle, from new construction to in-use and refurbishment. HIMACS can contribute to BREEAM International New Construction 2016 certification, as the entire product complies with Hea 02 Indoor air quality. Furthermore, HIMACS achieved RSCS summary score level in Mat 03, responsible sourcing of construction products for the entire product: RSCS level 1. “BREEAM is a registered trade mark of the Building Research Establishment Limited, a wholly owned subsidiary of BRE Group Limited, and is used by permission. LX Hausys and its products are not affiliated, endorsed or certified by BRE Global Limited, which is the operator of BREEAM, or any other subsidiary of BRE Group Limited. All rights are reserved.”',

        /* END US certifications - Environment - TAB */

        /* US certifications - Fire Rating - TAB */

        Fire_Rating_title1: 'Norm NFP 92-501 Class M1',
        Fire_Rating_brief1: 'LNE tests the reactivity to fire of a material. Class M1 certifies that HIMACS FR benefits from advanced resistance to fire. This certificate is recommended in France.',

        Fire_Rating_title2: 'Norm EN 45 545 Class R1 HZL3',
        Fire_Rating_brief2: 'Fire protection on railway vehicles: The measures and requirements specified in EN 45 545 are intended to protect passengers and staff in railway vehicles in the event of a fire on board. HIMACS has achieved the highest and best performance R1 HZL3 (Hazard Level). Valid for Alpine White S728.',

        Fire_Rating_title3: 'Norm EN 13501 - Class B-s1, d0',
        Fire_Rating_brief3: 'HIMACS successfully passed the European test EN 13501 – Class B-s1, d0, equivalent to the class 0 from Warrington Fire certification.',

        Fire_Rating_title4: 'Norm DIN 4102-1 - Class B1',
        Fire_Rating_brief4: 'Class B1 certifies that HIMACS has a low flammability. B1 class is the European fire resistance requirement. This test result is valid for all colour ranges in 12mm.',

        /* END US certifications - Fire Rating - TAB */

        /* US certifications - Exteria Certificates - TAB */

        Exteria_title1: 'IMO MED – Modules B and D',
        Exteria_brief1: 'MED stands for Marine Equipment Directive. Both modules are extremely important for the shipbuilding industry, as they are mandatory for fabrication materials used in ships. IMO B covers the fire resistance of the material per se and certifies that the material has low flame spread characteristics and is not capable of producing excessive quantities of smoke and toxic combustion products. Module D covers the overall production capacity and checks, among other production processes, the management and systems used.',

        Exteria_title2: 'ETA',
        Exteria_brief2: 'Fixed with Keil inserts and a BWM structure, HIMACS facade in S728 - Alpine White successfully passed the ETA tests (European Technical Agreement).',

        Exteria_title3: 'CSTB Certification',
        Exteria_brief3: 'HIMACS has obtained the French QB certification and CSTB ATec “Avis Technique” for facade applications (Avis Technique 2.2/18-1795_V1).',

        /* END US certifications - Exteria Certificates - TAB */

        /* US certifications - Hygiene - TAB */

        Hygiene_title1: 'NSF',
        Hygiene_brief1: 'NSF standards are generally accepted norms for a variety of public health related industries and fields. These include drinking water treatment and contact with materials, food equipment manufacturing etc. NSF recognises that HIMACS complies with NSF norms.',

        Hygiene_title2: 'LGA',
        Hygiene_brief2: 'Necessary in hospitals and environments where hygiene is critical, LGA assesses the ease of cleaning, resistance to bacteria and fungi and rates the design from a hygiene point of view. Thanks to its non-porosity, HIMACS has been approved for the LGA seal “hygiene tested”.',

        /* END US certifications - Hygiene - TAB */

        /* US certifications - Process - TAB */

        Process_title1: 'OHSAS 18001',
        Process_brief1: 'OHSAS 18001, Occupational Health and Safety Assessment Series, (officially BS OHSAS 18001) is a British Standard for occupational health and safety management systems. Compliance with it enables organizations to demonstrate that they have a system in place for occupational health and safety.',

        Process_title2: 'ISO 9001',
        Process_brief2: 'ISO 9001 criteria can guarantee the following points:',
        Process_brief3: 'The whole fabrication process, ensuring a good product quality',
        Process_brief4: 'Quality control, with an appropriate corrective procedure, when needed and regular control of quality control procedures.',
        Process_brief5: 'Process, which aims to continuously improve global efficiency',

        /* END US certifications - Process - TAB */

        /* US sustainbility - TAB */

        sustainbility_title1: 'Shaping the Future in Harmony with the Environment',
        sustainbility_brief1: 'Countless internationally recognized certificates attest to the fact that HIMACS has a strong focus on ecological aspects. Without exception, all HIMACS products are manufactured in accordance with the ISO 14001 environmental standard.',

        TAB_Commitment_title: 'Commitment',
        TAB_Material_Safety_title: 'Material Safety',
        TAB_Manufacturing_title: 'Manufacturing',
        TAB_Processing_title: 'Processing',
        TAB_Transport_title: 'Transport',

        /* END US sustainbility - TAB */

        /* US sustainbility - Commitment - TAB */

        Commitment_title1: 'Commitment',
        Commitment_brief1: 'LX Hausys conducts and publishes regular environmental audits along with energy consumption analyses. Thanks to the use of non-polluting fuels, greenhouse gas emissions have been cut by 15,000 tons per year since 2008.',

        /* END US sustainbility - Commitment - TAB */

        /* US sustainbility - Material Safety - TAB */

        Material_Safety_title1: 'Material Safety',
        Material_Safety_brief1: 'Extensive studies – within LX Hausys’ own laboratories as well as tests carried out by other renowned independent institutions – have shown that the HIMACS material itself, as well as the cured adhesive, are completely free from formaldehyde and emissions. HIMACS has been awarded the Greenguard Gold Indoor Air Quality Certificate.',

        /* END US sustainbility - Material Safety - TAB */

        /* US sustainbility - Manufacturing - TAB */

        Manufacturing_title1: 'Manufacturing',
        Manufacturing_brief1: 'The production of this solid surface material is marked by an excellent energy balance. In recent years, the company was very successful in achieving ambitious goals in terms of waste reduction and water conservation. In addition, HIMACS plants in Cheongju (Korea) and Atlanta (USA) meet all environmental standards.',

        /* END US sustainbility - Manufacturing - TAB */

        /* US sustainbility - Processing - TAB */

        Processing_title1: 'Processing',
        Processing_brief1: 'The material allows for virtually waste-free processing. In addition, HIMACS installations are extremely strong and durable. They can easily be renewed to their original appearance, meaning they don’t have to be replaced, thus giving a positive long-term  environmental footprint.',

        /* END US sustainbility - Processing - TAB */

        /* US sustainbility - Transport - TAB */

        Transport_title1: 'Transport',
        Transport_brief1: 'Within Europe, HIMACS observes the Euro-5 standards for reduced particulate emissions. The partner-network of LX Hausys Europe consists of carefully selected partners with the highest environmental standards: for example, the State-of-the-Art logistics centre in the Netherlands is one of the first buildings to have been constructed in accordance with the WELL Building Standards and awarded the BREEAM Certificate. This means that it meets the highest requirements for environmentally friendly and healthy construction. '

        /* END US sustainbility - Transport - TAB */

      }, // End of PCD - text

      alert: {
        loginLike: 'Log in to save to your Likes'
      }, // End of PCD - alert

      button: {
        seeMore: 'See More',
        see_all: 'Посмотреть все дизайны',
        learnMore: 'Learn more',
        explore_collection: 'Изучите коллекцию',
        feature_benefits: 'FEATURE & BENEFITS',
        certifications: 'CERTIFICATIONS',
        finish: 'FINISH',
        edge_profiles: 'EDGE PROFILES',
        country_of_origin: 'COUNTRY OF ORIGIN',
        close: 'close',
        find_a_sales_rep: 'Find a Sales Rep',
        btn_sustainbility_brochure: 'Download Sustainability Brochure',

        English: 'English',
        German: 'German',
        French: 'French',
        Italian: 'Italian',
        Spanish: 'Spanish',
        Dutch: 'Dutch',
        EnglishUK: 'English (UK)'

      }, // End of PCD - button

      popup: {
        /* Edge Profiles 시작 점 */
        edge_title: 'Viatera Edge Profile',
        edge_brief: 'Where quartz meets the edge. LX Hausys Surfaces offers a wide selection of edge treatments.' +
          '                    Select from a simple rounded corner to the complex multi-toned,' +
          '                    multi-tiered rolling edges that add that special finishing touch to your solid surface counter.' +
          '                    For more information on our edge treatments, please consult your local area distributor or' +
          '                    fabricator.',

        beveled_Edge: 'Beveled Edge',
        beveled_Edge_brief: 'Maintains the surface’s thickness,\n' +
          '                    but with a ¼” or ½” angular top edge.',
        bullnose_Edge: 'Bullnose Edge',
        bullnose_Edge_brief: 'A completed rounded edge.',

        eased_Edge: 'Eased Edge',
        eased_Edge_brief: 'A slightly rounded top edge that still\n' +
          "                    maintains the surface's thickness.",

        ellipse_Edge: 'Ellipse Edge',
        ellipse_Edge_brief: 'Rounded top and bottom edges\n' +
          '                    with a flat face.',

        knife_Edge: 'Knife Edge',
        knife_Edge_brief: 'A sharp, blade-like edge.',

        reverse_Ogee_Edge: 'Reverse Ogee Edge',
        reverse_Ogee_Edge_brief: 'Similar to Roman Edge, but reversed.',

        roman_Edge: 'Roman Edge',
        roman_Edge_brief: 'An elaborate ogee-style edge design\n' +
          '                    inspired by Roman architecture.',

        roundover_Edge: 'Roundover Edge',
        roundover_Edge_brief: 'A semi-circle rounded top edge.',

        /* Edge Profiles 끝 */

        /* Finish 시작 점 */
        finishInfo: 'Finish guide',
        finishTitle: 'Introducing New Viatera Finish Brushed',
        finishBrief: 'Select Viatera colors are now available with a “Brushed” finish to fulfill a wider range of aesthetics.\n' +
          '                  Enjoy the new classic beauty with a satin-like finish.',
        polished: 'POLISHED',
        polished_brief: 'Traditional reflective surface',

        brushed: 'BRUSHED',
        brushed_brief: 'Soft and smooth feel with\n' +
          '                    low-luster on the surface',

        leather: 'Leather',
        leather_brief: 'Leather finish has a slightly more matte texture than a polished finish, and makes you feel the soft touch of the leather.',

        velvet_Touch: 'Velvet Touch',
        velvet_Touch_brief: 'Velvet touch finish enables you to feel the texture of nature with the feeling of stone dents.',

        finish_viatera: 'Viatera',
        finish_viatera_info: 'Brushed Finish Care & Maintenance',
        finish_viatera_brief: 'Viatera products with Brushed Finish are the same as those with the standard Polished Finish.\n' +
          '                  The only manufacturing difference is how the final gloss level is achieved.',

        finish_viatera_brief_01: 'Brushed Finish may need more daily attention than Polished Finish. This is the nature of any material with a matte finish when compared to the same material\n' +
          '                  with a polished finish – smudges, fingerprints, and water spots are simply more visible on a matte surface. Promptly wipe up and buff dry routine spills, droplets,\n' +
          '                  and rings. A microfiber towel may be more effective than a paper towel because Brushed Finish has a slight surface texture when compared to Polished Finish.\n' +
          '                  These non-woven cleaning products work well on all surfaces and are especially helpful on products that feature anything other than a perfectly smooth surface.',

        finish_viatera_brief_02: 'Routine Care and Maintenance of Brushed Finish is easy with the same liquid household cleaners that are suitable for “Polished” finishes, including Formula 409\n' +
          '                  Natural Stone & Steel Cleaner.',

        finish_viatera_brief_03: 'Always read and follow that manufacturer’s label instructions. A textured sponge that’s suitable for non-stick coated cookware may be helpful in removing some\n' +
          '                  tougher spills. Avoid using abrasive cleaners like Ajax or Comet, as these more aggressive materials may dull or damage the surface of Brushed Finish.\n' +
          '                  After using any cleaning product always rinse the area and buff the area dry. A microfiber product is suggested but not required.'

        /* Finish 끝 */

      } // End of PCD - popup
    }, // End of PCD

    PD: {
      text: {
        new: 'NEW',
        coming: 'Coming soon',
        discontinued_Color: 'Discontinued Color',
        image_enlarged_view: 'IMAGE ENLARGED VIEW',
        image_download_view: 'IMAGE DOWNLOAD VIEW',
        finish: 'Finish',
        finishGuide: 'Finish guide',
        color: 'Color',
        product_Specs: 'СПЕЦИФИКАЦИИ ПРОДУКЦИИ',
        product_type: 'Product Type',
        total_thickness: 'Total Thickness',
        wear_layer: 'Wear Layer',
        dimension: 'Dimensions',
        dimension1: 'Dimension &',
        weight: 'Weight',
        remark: 'Remark',
        pattern: 'Pattern',
        emboss: 'Emboss',
        installation: 'Installation',
        adhesive_code: 'Adhesive Code',
        adhesive_name: 'Adhesive Name',
        available_Countries: 'Available Countries',
        related_Products: 'СОПУТСТВУЮЩИЕ ПРОДУКТЫ',
        features_Benefits: 'Features & Benefits',
        certifications: 'Certifications',
        documentation_technical_details: 'ДОКУМЕНТАЦИЯ И ТЕХНИЧЕСКИЕ ДЕТАЛИ',
        fabrication: 'ИЗГОТОВЛЕНИЕ',
        test_report: 'ПРОТОКОЛ ИСПЫТАНИЙ',
        care_maintenance: 'УХОД И ОБСЛУЖИВАНИЕ',
        catalogue: 'КАТАЛОГ',
        certification: 'СЕРТИФИКАЦИЯ',
        technical_datasheet: 'ТЕХНИЧЕСКИЙ ПАСПОРТ',
        installation_guide: 'РУКОВОДСТВО ПО УСТАНОВКЕ',
        warranty: 'ГАРАНТИЯ',
        edge_profile: 'ПРОФИЛЬ КРОМКИ',
        inspiration: 'Inspiration',
        standard: 'Standard',
        image_viewer: 'For illustration purposes only. Image size:',
        in: 'in',
        zoom_out: 'zoom Out',
        zoom_in: 'zoom In',
        Thickness: 'Thickness',
        Use: 'Use',
        Pattern: 'Pattern',
        Notice: 'Notice',
        Notice_brief: 'Less suitable for surfaces which are subject to high traffic, due to their higher pigmented colour saturation, marks may be seen more easily.',
        Semi_Translucent: 'Semi-Translucent colour',
        Semi_Translucent_brief: 'Colours with this mark have a semi-translucent effect, evident when combined with light sources',
        Outdoor: 'Outdoor',
        Outdoor_brief: 'Suitable for exterior use. Please check conditions about level of suitability and warranty per colour. Indoor, Suitable for Kitchen & Bathroom',
        Recycled: 'Recycled',
        Recycled_brief: 'Certified to contain pre-consumer recycled content. Minimum',
        Designer: 'Designer Series',
        Designer_brief: 'Designed by Marcel Wanders',
        Lucent: 'Lucent',
        Lucent_brief: 'Lucent colours have a higher level of translucency, more evident when combined with light source. Translucent colour',
        Veined: 'Veined',
        Veined_brief: 'As Marmo is a randomly veined product, specific fabrication guidelines need to be followed.',
        construct: 'Продукт',
        news_letter: 'Подпишитесь на нашу<br>новостную рассылку.',
        news_letter_desc: 'Узнайте об инновационных проектах,<br>уникальных цветах и последних новостях и тенденциях.',
        subscribe: 'Подписаться',
      }, // End of PD - text

      button: {
        virtual_Showroom: 'Virtual Showroom',
        prev: 'Prev',
        next: 'Next',
        list_view: 'list view',
        download: 'download',
        see_all_documentation: 'See All Documentation',
        see_all_case_studies: 'See All Case Studies',
        see_more: 'See More'

      } // End of PD - button

    }, // End of PD

    PF: {
      text: {
        category: 'CATEGORY',
        luxury_vinyl_tile: 'Виниловая плитка (LVT)',
        looselay: 'Свободнолежащая плитка ПВХ',
        homogeneous_sheet: 'Гомогенное покрытие',
        heterogeneous_sheet: 'Гетерогенное покрытие',
        specialty: 'Специализация',
        home: 'Home',
        filter_by: 'Filter By',
        patterns: 'Узор',
        country: 'Country',
        new: 'New',
        new_a: 'NEW',
        coming: 'Coming soon',
        new_colors: 'НОВЫЕ ЦВЕТА',
        product_type: 'Product Type',
        thickness: 'Толщина (дюйм)',
        weight: 'Вес (кг)',
        finish: 'Полировка',
        wear_layer: 'Износостойкий слой',
        dimension: 'Размер (мм)',
        searchText: 'Введите номер или название продукта',
        Tones: 'Tones',
        Use: 'Use',
        Recycled: 'Переработанный',
        recycled: 'Переработанный',
        Thickness: 'Толщина',
        himacs: 'HIMACS',
        borte: 'BORTE',
        hflor: 'HFLOR',
        viatera: 'VIATERA',
        exteriorfilm: 'EXTERIOR Film',
        decofilm: 'DECO Film',
        teracanto: 'TERACANTO',
        benif: 'BENIF',
        vizuon_a: 'VIZUON',
        lvt: 'Виниловая плитка (LVT)',
        los: 'Свободнолежащая плитка ПВХ',
        spc: 'Кварцвиниловая плитка',
        hom: 'Гомогенное покрытие',
        het: 'Гетерогенное покрытие',
        spt: 'Специализация',
        installation: 'Установка',
        results: 'Результаты',
        no_search_result: 'Не найдено ни одного результата',
        no_option: 'Пожалуйста, выберите вариант',
        no_compare_item: 'Нет товаров для сравнения',
        color: 'ЦВЕТ',
        slab_size: 'Размер плиты (дюйм)',
        bookmatch: 'Узор бабочка',
        remark: 'Примечание',
        compare: {
          himacs: 'Сравнить ПРОДУКТЫ HIMACS',
          hflor: 'Сравнить ПРОДУКТЫ HFLOR',
          viatera: 'Сравнить ПРОДУКТЫ VIATERA',
          exteriorfilm: 'Сравнить ПРОДУКТЫ Exterior Film',
          decofilm: 'Сравнить ПРОДУКТЫ Deco Film',
          teracanto: 'Сравнить ПРОДУКТЫ TERACANTO',
          benif: 'Сравнить ПРОДУКТЫ BENIF',
          vizuon_a: 'Сравнить ПРОДУКТЫ VIZUON',
          borte: 'Сравнить ПРОДУКТЫ BORTE'
        },
        compare_full: {
          text: 'Do you want to replace the first Products <br>' +
            'you added by the one you selected?',
          footer: 'Edit products in compare'
        },
        key_visual_desc: {
          all_colors: 'Найдите идеальный вариант цвета и дизайна для ваших будущих проектов, от акрилового камня до интерьерных пленок и пленок для экстерьера. <br>' +
            'Компания LX Hausys предлагает широкий спектр цветов, отделок и эстетических решений для всего ассортимента материалов для отделки поверхностей и напольных покрытий.',

          all_samples: 'Find the perfect samples for your next project, whether you need quartz countertops, solid surfaces, porcelain surfaces, or resilient flooring. <br>' +
            'LX Hausys offers a diverse array of samples across its entire surfacing and flooring portfolio.',

          hflor_color: 'Откройте для себя огромный мир дизайнерских возможностей с эластичными напольными покрытиями HFLOR.  <br>' +
            'Наша разнообразная палитра цветов и рисунков распространяется на все наши эластичные напольные покрытия, включая роскошную виниловую плитку и виниловые листы.',

          hflor_sample: 'Find the perfect resilient flooring samples for your next demanding project. <br>' +
            'HFLOR offers a diverse array of samples to help you select from its innovative and high-performance LVT collections.',

          viatera_color: 'Подчеркните стиль любого пространства с помощью изысканной коллекции кварцевых столешниц VIATERA.<br>' +
            'Откройте для себя непревзойдённое качество и долговечную элегантность, которые делают VIATERA идеальным решением среди кварцевых столешниц.',

          viatera_sample: 'Find the perfect quartz countertop samples for your next design project. <br>' +
            'VIATERA offers a diverse array of samples across its beautiful and highly durable quartz collection.',

          himacs_color: 'С HIMACS вы переосмыслите ограничения дизайна и раздвинете границы возможного. <br>' +
            'Откройте для себя безграничную палитру цветов и декоров, которые делают HIMACS идеальным выбором как для коммерческого, так и для жилого помещения.',

          himacs_sample: 'Find the perfect solid surface samples for your next creative project. <br>' +
            'HIMACS offers a diverse array of samples to help you explore its flexible and seamless solid surface collection.',

          teracanto_color: 'Позвольте смелым и изысканным дизайнам столешниц TERACANTO превратить ваше пространство в по-настоящему незабываемое впечатление.<br>' +
            'Созданные для тех, кто ценит утончённую роскошь, фарфоровые поверхности TERACANTO представляют собой подлинные шедевры,<br>' +
            'в которых гармонично сочетаются красота природы и передовые инженерные технологии.',

          teracanto_sample: 'Find the perfect porcelain surface samples for your next sophisticated design. <br>' +
            'TERACANTO offers a diverse array of samples across its durable, large-format porcelain collection.',

          benif_color: 'Откройте для себя исключительную универсальность дизайна с пленкой для интерьера BENIF. <br>' +
            'Ознакомьтесь с нашим обширным выбором цветов и декоров, которые помогут легко преобразить стены,<br>' +
            ' потолки и мебель, используя специальную самоклеящуюся основу для быстрого и легкого нанесения.',

          borte_color: 'Your Doorway to Sustainable Home Innovation',

          deco_color: 'Переосмыслите ограничения в дизайне мебели и столярных изделий с помощью пленки для мебели и декора LX Hausys Deco film.  <br>' +
            'Откройте для себя обширную и безграничную палитру цветов и декоров, позволяющую привнести исключительную эстетическую универсальность и индивидуальный дизайн в любой интерьер.',

          exterior_color: 'Изучите обширную палитру цветов и декоров пленки для экстерьера LX Hausys, призванной подчеркнуть и преобразить любой элемент интерьера. <br>' +
            'Откройте для себя идеальную эстетику, которая обещает непревзойденную долговечность, устойчивость к ультрафиолетовым лучам, влаге и разнообразным внешним условиям.',

          vizuon_color: 'Ознакомьтесь с полной коллекцией пленок для вывесок и графики VIZUON от LX Hausys, разработанных для воплощения ваших идей в жизнь с помощью ярких визуальных образов и простого применения. <br>' +
            'Ознакомьтесь с нашим широким ассортиментом решений, идеально подходящих для транспортных средств, больших вывесок и дисплеев, детализированных световых вывесок и проектов на заказ. <br>' +
            'Ознакомьтесь с доступными цветами и стилями, в том числе с нашими экологичными решениями и комплексными вариантами корпоративного брендинга, чтобы найти идеальное визуальное решение для ваших потребностей.',

          default_desc: '',
        },
        allColors: {
          himacs: 'Цвета HIMACS',
          hflor: 'Цвета HFLOR',
          viatera: 'Цвета VIATERA',
          exteriorfilm: 'Цвета Exterior Film',
          decofilm: 'Цвета Deco Film',
          teracanto: 'Цвета TERACANTO',
          benif: 'Цвета BENIF',
          vizuon_a: 'Цвета VIZUON',
          borte: 'Цвета BORTE',
          himacs_ac: 'HIMACS',
          hflor_ac: 'HFLOR',
          viatera_ac: 'VIATERA',
          exteriorfilm_ac: 'EXTERIOR Film',
          decofilm_ac: 'DECO Film',
          borte_ac: 'BORTE',
          teracanto_ac: 'TERACANTO',
          benif_ac: 'BENIF',
          vizuon_ac: 'VIZUON',
          products: 'Продукция',
          all_colors: 'Все цвета',
          filter: 'Фильтр',
          filter_by: 'Фильтр',
          brand: 'БРЕНД',
          color: 'ЦВЕТ',
          searchText: 'Введите номер или название продукта',
          results: 'Результаты',
          no_result: 'Не найдено ни одного результата',
          no_result_text: 'If you do not find what you are looking for, please try different search terms or filters.',
          apply: 'Применить',
          clear_all: 'Очистить все',
          clear_all2: 'Очистить все',
          products_a_to_z: 'Продукты от А до Я',
          products_z_to_a: 'Продукты от Z до A',
          new_products_first: 'Последние',
          your_compare_is_full: 'Your compare is full',
          new: 'НОВИНКИ',
          new_a: 'NEW',
          brandLabel: 'БРЕНД',
          colorLabel: 'ЦВЕТ',
          white: 'Белый',
          cream: 'Кремовый',
          beige: 'Бежевый',
          brown: 'Коричневый',
          gray: 'Серый',
          black: 'Черный',
          green: 'Зеленый',
          blue: 'Синий',
          pink: 'Розовый',
          purple: 'Фиолетовый',
          ivory: 'Ivory',
          orange: 'Orange',
          red: 'Red'
        }
      }, // End of PF - text
      filter: {
        filter_by: 'Фильтр',
        vizuon: 'VIZUON',
        vt: 'Автомобили и транспорт',
        sd: 'Вывески и витрины',
        is: 'Светящаяся вывеска',
        ar: 'Архитектура',
        es: 'Экологические решения',
        cb: 'Корпоративный брендинг',
        feature: 'FEATURE',
        country: 'COUNTRY',
        compare: 'Сравнить',
        bookmatch: 'BOOKMATCH',
        application: 'APPLICATION',
        weatherability: 'WEATHERABILITY',
        remark: 'REMARK',
        hflor: 'HFLOR',
        pet: 'PET',
        installation: 'INSTALLATION',
        productType: 'PRODUCT TYPE',
        filter: 'FILTER',
        color: 'ЦВЕТ',
        collection: 'КОЛЛЕКЦИЯ',
        patterns: 'ДИЗАЙНЫ',
        finish: 'ПОЛИРОВКА',
        recycled: 'СБРОСИТЬ',
        thickness: 'ТОЛЩИНА',
        format: 'ФОРМАТ',
        wearlayer: 'ЗАЩИТНЫЙ СЛОЙ',
        dimensions: 'Размеры',
        prdtype: 'УСТАНОВКА', // installation
        adhesivetype: 'Название клея',
        productclassification: 'КЛАССИФИКАЦИЯ ПРОДУКЦИИ',
        airfree: 'С аэроканалами',
        solidcolor: 'ОДНОТОННЫЙ ЦВЕТ',
        stoneColor: 'ЦВЕТ КАМНЯ',
        solidPatterns: 'Однотонный дизайн',
        metalColor: 'ЦВЕТ МЕТАЛЛА',
        woodColor: 'ЦВЕТ ДЕРЕВА',
        metalPattern: 'ПОД МЕТАЛЛ',
        woodPattern: 'ПОД ДЕРЕВО',
        stonePattern: 'ПОД КАМЕНЬ',
        pvc: 'PVC',
        petFurnitureFilm: 'PET',
        acrylicFurnitureFilm: 'Acrylic',
        woodSpecies: 'ПОРОДЫ ДЕРЕВА',
        fireresistance: 'ОГНЕСТОЙКОСТЬ',
        stonetype: 'ТИП КАМНЯ',
        textiletype: 'ТИП ТЕКСТИЛЯ',
        new: 'НОВИНКИ',
        slabsize: 'Размер плиты (мм)',
        prestgSpcClick: 'Замковая плитка',
        category: 'CATEGORY',
        type: 'TYPE',
        marmoAurora: 'Мармо Аврора',
        terrazzo: 'Терраццо',
        volcanics: 'Волканикс',
        granite: 'Гранит',
        solid: 'Солид',
        lucia: 'Лючия',
        lucent: 'Люсент',
        marmo: 'Мармо',
        quartz: 'Кварц',
        sandPearl: 'Песок и жемчуг'
      },
      popup: {
        slabsize_inch: 'Размер плиты (дюйм)',
        filter_by: 'Фильтр',
        your_compare_is_full: 'Your compare is full',
        compare_tool: 'Compare tool',
        compare_alert1: 'Do you want to replace the first product',
        compare_alert2: 'you added by the one you selected?',
        edit_products_in_compare: 'EDIT PRODUCTS IN COMPARE',
        replace: 'REPLACE',
        close: 'close',
        characteristics_technical_performance: 'Характеристики и технические показатели',
        pvc: 'ПВХ',
        acrylic: 'АКРИЛОВЫЙ',
        adhesive_type: 'ТИП КЛЕЯ',
        adhesive_code: 'Код КЛЕЯ',
        adhesive_name: 'Название клея',
        air_free: 'Безвоздушный',
        film_type: 'типа пленки',
        material: 'материал',
        liner: 'Лайнер',
        width: 'Ширина',
        grade: 'Категория прочности',
        length: 'длина',
        repeatImage: 'Повторяющийся рисунок',
        fireResis: 'Огнестойкость',
        cmThickness: 'Толщина (см)',
        thickness: 'Толщина',
        thickness_mm: 'Толщина (мм)',
        pet: 'ПЭТ',
      },
      button: {
        all: 'All',
        lux: 'Виниловая плитка (LVT)',
        hom: 'Гомогенное покрытие',
        het: 'Гетерогенное покрытие',
        spt: 'Специализация',
        compare: 'Сравнить',
        compare_your_colors: 'Сравнить цвета',
        remove: 'Remove',
        add_more: 'AДобавить еще',
        search: 'search',
        color: 'ЦВЕТ',
        collection: 'КОЛЛЕКЦИЯ',
        patterns: 'Patterns',
        finish: 'Finish',
        country: 'Country',
        new: 'НОВИНКИ',
        all_products: 'All products',
        grouped_by_collections: 'Grouped by collections',
        filter_by: 'Filter By',
        products_a_to_z: 'Продукты от А до Я',
        products_z_to_a: 'Продукты от Z до A',
        new_products_first: 'Последние',
        clear_all: 'Очистить все',
        load_more: 'Загрузить еще',
        see_all_colors: 'See all colors',
        download: 'Загрузить',
        Popularity: 'Popularity',
        lvt: 'Виниловая плитка (LVT)',
        los: 'Свободнолежащая плитка ПВХ',
        spc: 'Кварцвиниловая плитка',
        compare_on: 'на',
        filter: 'Фильтр',
        most_recent: 'Последние',
        apply: 'Применить',
        all_filters: 'Все фильтры'
      } // End of PF - button
    }, // End of PF
    other: {
      text: {
        sales_rep: 'Find a Sales Rep',
        showroom: 'Virtual Showroom',
        home: 'Home',
        products: 'Products',
        viatera: 'VIATERA',
        himacs: 'HIMACS',
        hotherPD: 'HIMACS Sinks',
        votherPD: 'VIATERA Sinks',
        overall: 'Overall Dimensions',
        inner: 'Inner Dimensions',
        contactus: 'Contact Us',
        close: 'close',
        arctic: 'Arctic White',
        ivory: 'Ivory White',
        cream: 'Cream',
        almond: 'Almond',
        all: 'All',
        kitchen: 'Kitchen',
        bathroom: 'Bathroom',
        ada: 'ADA Compliance',
        himacs_sink_banner_desc: 'Explore the complete line of HIMACS vanity and kitchen sinks designed for superior aesthetics and functionality.<br>' +
          'Every HIMACS solid surface sink is engineered to be seamlessly integrated with a HIMACS countertop,<br>' +
          'providing a beautifully smooth, clean, and well-designed surface.',
        viatera_sink_banner_desc: 'Discover the Lovello™ stainless steel sink collection, designed to perfectly complement VIATERA Quartz Countertops.<br>' +
          'These high-quality sinks offer unique styling to enhance any kitchen or vanity,<br>' +
          'providing the ideal finishing touch when paired with your VIATERA surface.'
      },
      button: {
        learn_more: 'Узнать больше',
        view_more: 'Подробнее',
        load_more: 'Загрузить еще',
        certi_more: 'What These Certifications Mean'
      }
    }// End of RU
  }
}
